/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ChartLines, CriticalPoint } from "../../components/Highcharts/LineCharts/SoilMoistureChart/types";

export interface CompanySchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id?: string;
  /** @example "Empresa 123" */
  name: string;
  /** @example "12345678-9" */
  rut: string;
  /** @example "Empresa Cerezos" */
  businessName: string;
  /** @example "Chile" */
  country: string;
  /** @example "Region Metropolitana" */
  region: string;
  /** @example "Santiago" */
  commune: string;
  /** @example "123 Vespucio" */
  address: string;
  /** @example false */
  deleted: boolean;
  /**
   * @format date-time
   * @example "2023-03-07T19:43:46.303Z"
   */
  createdAt: string;
  /**
   * @format date-time
   * @example "2023-03-07T19:43:46.303Z"
   */
  updatedAt: string;
}

export interface GetConversationsPerPageResponse {
  /** @example true */
  success?: boolean;
  /** @example "Conversaciones encontradas exitosamente" */
  message?: string;
  conversations?: ConversationSchema[];
  totalConversations: number;
}


export interface GetCompaniesPerPageResponse {
  /** @example true */
  success?: boolean;
  /** @example "Empresas encontradas exitosamente" */
  message?: string;
  companies?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "Empresa 123" */
    name: string;
    /** @example "12345678-9" */
    rut: string;
    /** @example "Empresa Cerezos" */
    businessName: string;
    /** @example "Chile" */
    country: string;
    /** @example "Region Metropolitana" */
    region: string;
    /** @example "Santiago" */
    commune: string;
    /** @example "123 Vespucio" */
    address: string;
    /** @example false */
    deleted: boolean;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    createdAt: string;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    updatedAt: string;
  }[];
  /** @example 1 */
  totalCompanies?: number;
}

export interface GetCompanyByIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Empresa encontrada exitosamente" */
  message?: string;
  company?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "Empresa 123" */
    name: string;
    /** @example "12345678-9" */
    rut: string;
    /** @example "Empresa Cerezos" */
    businessName: string;
    /** @example "Chile" */
    country: string;
    /** @example "Region Metropolitana" */
    region: string;
    /** @example "Santiago" */
    commune: string;
    /** @example "123 Vespucio" */
    address: string;
    /** @example false */
    deleted: boolean;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    createdAt: string;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    updatedAt: string;
  };
}

export interface GetWindVelocityDataResponse {
  /** @example true */
  success?: boolean;
  /** @example "Datos de velocidad del viento obtenidos" */
  message?: string;
  velocitySeries: {
    type: string;
    name: string;
    data: number[];
  }[];
  directionSeries: {
    type: string;
    name: string;
    data: number[];
  }[];
  gustSeries: {
    type: string;
    name: string;
    data: number[];
  }[];
  absoluteCategories: string[];
}

export interface GetDpvDataResponse {
  /** @example true */
  success?: boolean;
  /** @example "Datos de dpv obtenidos" */
  message?: string;
  dpvSeries: {
    type: string;
    name: string;
    data: number[];
  }[];
  absoluteCategories: string[];
}

export interface PutCompaniesSoftlandToMongoResponse {
  /** @example true */
  success?: boolean;
  /** @example "Empresas actualizadas exitosamente" */
  message?: string;
}

export interface AlertSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id: string;
  /** @example "Alerta de humedad" */
  name: string;
  /** @example "669814726c9ca473fff3ee4d" */
  cycle?: string;
  /** @example "Floración" */
  phenologicalState?: string;
  /** @example "Humedad del suelo" */
  chart: string;
  /** @example "2024-05-01T00:00:00.000Z" */
  startDate: string;
  /** @example "2024-05-01T00:00:00.000Z" */
  endDate: string;
  /** @example [{ name: "Humedad", value: 80, top: true }] */
  limits: Array<{
    name: string;
    value: number;
    top: boolean;
  }>;
  /** @example "La humedad del suelo ha superado el límite" */
  message: string;
  /** @example "2024-05-01T00:00:00.000Z" */
  lastActivation?: string;
  /** @example 5 */
  maxFrequency: number;
  /** @example 30 */
  timeOutRange: number;
  /** @example "15" */
  timeEachReview: string;
  /** @example "669814726c9ca473fff3ee4d" */
  sectorId: string;
  /** @example "Sector 1" */
  sectorName?: string;
  /** @example "Farm 1" */
  farmName?: string;
  /** @example true */
  active: boolean;
  /** @example false */
  deleted: boolean;
  /** @example ["user@example.com"] */
  recipients: string[];
  /** @example "2024-05-01T00:00:00.000Z" */
  createdAt: string;
  /** @example "2024-05-01T00:00:00.000Z" */
  updatedAt: string;
}

export interface SensorSchema {

  /** @example "669814726c9ca473fff3ee4d" */
  _id: string;
  /** @example "669814726c9ca473fff3ee4d" */
  id: string;
  /** @example "Sensor 1" */
  name: string;
  /** @example "669814726c9ca473fff3ee4d" */
  wiseconnId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  zoneId?: string;
  /** @example false */
  deleted: boolean;
  /** @example "2024-05-01T00:00:00.000Z" */
  createdAt: string;
  /** @example "2024-05-01T00:00:00.000Z" */
  updatedAt: string;
  /** @example "2024-05-01T00:00:00.000Z" */
  lastActivity: string;
  /** @example "Operative" */
  status: string;
  /** @example "Nuevo sensor" */
  comment?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farm: string;
  /** @example "669814726c9ca473fff3ee4d" */
  sector: {
    /** @example "669814726c9ca473fff3ee4d" */
    id: string;
    /** @example "Sector 1" */
    name: string;
  };
  /** @example "669814726c9ca473fff3ee4d" */
  subSector: string;
  coordinates: {
    /** @example -25.12 */
    lng: number;
    /** @example 35.12 */
    lat: number;
  };
  /** @example "suelo" */
  sensorType?: string;
  /** @example false */
  sensorDepth?: string;
  /** @example "m" */
  depthUnit?: string;
  /** @example false */
  isWeatherStation?: boolean;
  /** @example "wiseconn" */
  telemetryType?: string;
  /** @example "m3" */
  unit?: string;
  /** @example "Sentek" */
  physicalConnection?: object;
  /** @example "Sentek" */
  softlandBrand?: string;
  /** @example "Drill and Drop" */
  softlandModel?: string;
  brand?: string;
  active: boolean;
}

export interface NodeSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  _id: string;
  /** @example "669814726c9ca473fff3ee4d" */
  id: string;
  /** @example "Node 1" */
  name: string;
  /** @example "669814726c9ca473fff3ee4d" */
  wiseconnId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  deleted: boolean;
  /** @example "2024-05-01T00:00:00.000Z" */
  createdAt: string;
  /** @example "2024-05-01T00:00:00.000Z" */
  updatedAt: string;
  /** @example "2024-05-01T00:00:00.000Z" */
  lastActivity: string;
  /** @example "Operative" */
  status: string;
  /** @example "Nuevo sensor" */
  comment?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farm: FarmSchema;
  /** @example "669814726c9ca473fff3ee4d" */
  sector: {
    /** @example "669814726c9ca473fff3ee4d" */
    id: string;
    /** @example "Sector 1" */
    name: string;
  };
  /** @example "669814726c9ca473fff3ee4d" */
  subSector: string;
  coordinates: {
    /** @example -25.12 */
    lng: number;
    /** @example 35.12 */
    lat: number;
  };
  isGatewayNode: boolean;
  nodeType: string;
  telemetryType: string;
  softlandBrand: string;
  softlandModel: string;
  modemId: string;
  networkNumber: number;
  mac: string;
  expansions: string[];
  zoneId?: string;
  active: boolean;
}

export interface DeviceModelSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  _id: string;
  /** @example "669814726c9ca473fff3ee4d" */
  id: string;
  name: string;
  model?: string;
  group?: string;
  subGroup?: string;
  codProd?: string;
  /** @default false */
  deleted: boolean;
  /** @example "135654" */
  cdtecDeviceId?: string;
  /** @example "Sentek" */
  brand?: string;
}

export interface PostSensorSchema {
  /** @example "node" */
  deviceType: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farmId: string;
  /** @example "669814726c9ca473fff3ee4d" */
  sectorId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  subSectorId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  dispatchGuideId?: string;
  /** @example "Nuevo sensor" */
  comment?: string;
  coordinates: {
    /**
     * @format float
     * @example -25.12
     */
    lng: number;
    /**
     * @format float
     * @example 35.12
     */
    lat: number;
  };
  /** @example "135654" */
  cdtecDeviceId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  sensorType: string;
  /** @example "Sentek" */
  brand?: string;
  /** @example "Alpha" */
  model?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  nodeId: string;
  zoneId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  isWeatherStation?: boolean;
  /** @example "wiseconn" */
  telemetryType?: string;
}

export interface PostNodeSchema {
  /** @example "node" */
  deviceType: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farmId: string;
  /** @example "669814726c9ca473fff3ee4d" */
  sectorId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  subSectorId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  dispatchGuideId?: string;
  /** @example "Nuevo sensor" */
  comment?: string;
  coordinates: {
    /**
     * @format float
     * @example -25.12
     */
    lng: number;
    /**
     * @format float
     * @example 35.12
     */
    lat: number;
  };
  /** @example "135654" */
  cdtecDeviceId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  nodeType: string;
  /** @example "Sentek" */
  brand?: string;
  /** @example "Alpha" */
  model?: string;
  /** @example true */
  isGatewayNode?: boolean;
  nodeChip?: string;
  batteryLevelId?: string;
  rfPowerId?: string;
  currentId?: string;
  /** @example "wiseconn" */
  telemetryType?: string;
}

export interface PostSensorDispatchGuideSchema {
  /** @example "node" */
  deviceType: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farmId: string;
  /** @example "669814726c9ca473fff3ee4d" */
  sectorId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  subSectorId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  dispatchGuideId?: string;
  /** @example "Nuevo sensor" */
  comment?: string;
  coordinates: {
    /**
     * @format float
     * @example -25.12
     */
    lng: number;
    /**
     * @format float
     * @example 35.12
     */
    lat: number;
  };
  /** @example "669814726c9ca473fff3ee4d" */
  sensorId: string;
  /** @example "669814726c9ca473fff3ee4d" */
  nodeId: string;
}

export interface PostNodeDispatchGuideSchema {
  /** @example "node" */
  deviceType: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farmId: string;
  /** @example "669814726c9ca473fff3ee4d" */
  sectorId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  subSectorId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  dispatchGuideId?: string;
  /** @example "Nuevo sensor" */
  comment?: string;
  coordinates: {
    /**
     * @format float
     * @example -25.12
     */
    lng: number;
    /**
     * @format float
     * @example 35.12
     */
    lat: number;
  };
  /** @example true */
  isGatewayNode?: boolean;
  nodeChip?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  nodeId: string;
  /** @example "wiseconn" */
  telemetryType?: string;
}

export interface PutDeviceSchema {
  /** @example "Updated Device" */
  deviceName?: string;
  /** @example "device model" */
  model?: string;
  /** @example "device name" */
  name?: string;
  /** @example "active" */
  status?: string;
  /** @example false */
  deleted?: boolean;
  /** @example "Nuevo sensor" */
  comment?: string;
  /** @example "suelo" */
  sensorType?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  nodeId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  batteryLevelId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  rfPowerId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  currentId?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  sector?: string;
  /** @example "wiseconn" */
  telemetryType?: string;
  /** @example "zone123" */
  zoneId?: string;
}

export interface GetDevicesPerPageSchema {
  /**
   * @format float
   * @example 10
   */
  limit?: number;
  /**
   * @format float
   * @example 0
   */
  page?: number;
  /** @example "" */
  searchValue?: string;
  /** @pattern (\|DESC\b|\|ASC\b) */
  sort?: string;
  /** @example "" */
  accountId?: string | null;
}

export interface GetDevicesByFarmIdSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  farmId: string;
}

export interface GetDevicesPerPageResponse {
  /** @example true */
  success?: boolean;
  /** @example "Equipos encontrados exitosamente" */
  message?: string;
  devices?: {
    /** @example "669814726c9ca473fff3ee4d" */
    _id: string;
    deviceModel?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id: string;
      name: string;
      model?: string;
      group?: string;
      subGroup?: string;
      codProd?: string;
      /** @default false */
      deleted: boolean;
      /** @example "135654" */
      cdtecDeviceId?: string;
      /** @example "Sentek" */
      brand?: string;
    };
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "node" */
    deviceType: string;
    /** @example "1351-545-548-DP2564" */
    uniqueSoftlandId: string;
    /** @example "DP50256" */
    serie?: string;
    nodeId?:
    | string
    | {
      _id: string;
      deviceModel: {
        /** @example "669814726c9ca473fff3ee4d" */
        _id: string;
        /** @example "669814726c9ca473fff3ee4d" */
        id: string;
        name: string;
        model?: string;
        group?: string;
        subGroup?: string;
        codProd?: string;
        /** @default false */
        deleted: boolean;
        /** @example "135654" */
        cdtecDeviceId?: string;
        /** @example "Sentek" */
        brand?: string;
      };
    };
    /** @example "suelo" */
    sensorType?: string;
    /** @example true */
    isGatewayNode?: boolean;
    nodeChip?: string;
    /** @example "123456" */
    deviceId: string;
    /** @example "2024-05-01T00:00:00.000Z" */
    createdAt: string;
    /** @example "2024-05-01T00:00:00.000Z" */
    updatedAt: string;
    /** @example "active" */
    status: string;
    /** @example false */
    deleted: boolean;
    /** @example "Nuevo sensor" */
    comment?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    farm: string;
    /** @example "669814726c9ca473fff3ee4d" */
    sector?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    subSector?: string;
    coordinates?: {
      /**
       * @format float
       * @example -25.12
       */
      lng: number;
      /**
       * @format float
       * @example 35.12
       */
      lat: number;
    };
  }[];
  /** @example 1 */
  totalDevices?: number;
}

export interface GetDeviceByIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Equipo encontrado exitosamente" */
  message?: string;
  device?: {
    /** @example "669814726c9ca473fff3ee4d" */
    _id: string;
    deviceModel?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id: string;
      name: string;
      model?: string;
      group?: string;
      subGroup?: string;
      codProd?: string;
      /** @default false */
      deleted: boolean;
      /** @example "135654" */
      cdtecDeviceId?: string;
      /** @example "Sentek" */
      brand?: string;
    };
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "node" */
    deviceType: string;
    /** @example "1351-545-548-DP2564" */
    uniqueSoftlandId: string;
    /** @example "DP50256" */
    serie?: string;
    nodeId?:
    | string
    | {
      _id: string;
      deviceModel: {
        /** @example "669814726c9ca473fff3ee4d" */
        _id: string;
        /** @example "669814726c9ca473fff3ee4d" */
        id: string;
        name: string;
        model?: string;
        group?: string;
        subGroup?: string;
        codProd?: string;
        /** @default false */
        deleted: boolean;
        /** @example "135654" */
        cdtecDeviceId?: string;
        /** @example "Sentek" */
        brand?: string;
      };
    };
    /** @example "suelo" */
    sensorType?: string;
    /** @example true */
    nodeType?: string;
    isGatewayNode?: boolean;
    nodeChip?: string;
    /** @example "123456" */
    deviceId: string;
    /** @example "2024-05-01T00:00:00.000Z" */
    createdAt: string;
    /** @example "2024-05-01T00:00:00.000Z" */
    updatedAt: string;
    /** @example "active" */
    status: string;
    /** @example false */
    deleted: boolean;
    /** @example "Nuevo sensor" */
    comment?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    batteryLevelId?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    rfPowerId?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    currentId?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    farm: string;
    /** @example "669814726c9ca473fff3ee4d" */
    sector?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    lastActivity?: string;
    subSector?: string;
    /** @example "wiseconn" */
    telemetryType?: string;
    /** @example "zone123" */
    zoneId?: string;
    coordinates?: {
      /**
       * @format float
       * @example -25.12
       */
      lng: number;
      /**
       * @format float
       * @example 35.12
       */
      lat: number;
    };
  };
}

export interface PutDevicesSoftlandToMongoResponse {
  /** @example true */
  success?: boolean;
  /** @example "Equipos actualizados exitosamente" */
  message?: string;
}

export interface PostDevicesResponse {
  /** @example true */
  success?: boolean;
  /** @example "Equipos actualizados exitosamente" */
  message?: string;
  device?: {
    id?: string;
    type: string;
    brand: string;
    model: string;
    nodeId?: string | null;
    nodeType?: string | null;
  };
}

export interface PutDeviceResponse {
  /** @example true */
  success?: boolean;
  /** @example "Equipo actualizado exitosamente" */
  message?: string;
  device?: {
    /** @example "669814726c9ca473fff3ee4d" */
    _id: string;
    deviceModel?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id: string;
      name: string;
      model?: string;
      group?: string;
      subGroup?: string;
      codProd?: string;
      /** @default false */
      deleted: boolean;
      /** @example "135654" */
      cdtecDeviceId?: string;
      /** @example "Sentek" */
      brand?: string;
    };
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "node" */
    deviceType: string;
    /** @example "1351-545-548-DP2564" */
    uniqueSoftlandId: string;
    /** @example "DP50256" */
    serie?: string;
    nodeId?:
    | string
    | {
      _id: string;
      deviceModel: {
        /** @example "669814726c9ca473fff3ee4d" */
        _id: string;
        /** @example "669814726c9ca473fff3ee4d" */
        id: string;
        name: string;
        model?: string;
        group?: string;
        subGroup?: string;
        codProd?: string;
        /** @default false */
        deleted: boolean;
        /** @example "135654" */
        cdtecDeviceId?: string;
        /** @example "Sentek" */
        brand?: string;
      };
    };
    /** @example "suelo" */
    sensorType?: string;
    /** @example true */
    isGatewayNode?: boolean;
    nodeChip?: string;
    /** @example "123456" */
    deviceId: string;
    /** @example "2024-05-01T00:00:00.000Z" */
    createdAt: string;
    /** @example "2024-05-01T00:00:00.000Z" */
    updatedAt: string;
    /** @example "active" */
    status: string;
    /** @example false */
    deleted: boolean;
    /** @example "Nuevo sensor" */
    comment?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    farm: string;
    /** @example "669814726c9ca473fff3ee4d" */
    sector?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    subSector?: string;
    coordinates?: {
      /**
       * @format float
       * @example -25.12
       */
      lng: number;
      /**
       * @format float
       * @example 35.12
       */
      lat: number;
    };
  };
}

export interface GetDevicesByFarmIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Equipos encontrados exitosamente" */
  message?: string;
  devices?: {
    /** @example "669814726c9ca473fff3ee4d" */
    _id: string;
    deviceModel?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id: string;
      name: string;
      model?: string;
      group?: string;
      subGroup?: string;
      codProd?: string;
      /** @default false */
      deleted: boolean;
      /** @example "135654" */
      cdtecDeviceId?: string;
      /** @example "Sentek" */
      brand?: string;
    };
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "node" */
    deviceType: string;
    /** @example "1351-545-548-DP2564" */
    uniqueSoftlandId: string;
    /** @example "DP50256" */
    serie?: string;
    nodeId?:
    | string
    | {
      _id: string;
      deviceModel: {
        /** @example "669814726c9ca473fff3ee4d" */
        _id: string;
        /** @example "669814726c9ca473fff3ee4d" */
        id: string;
        name: string;
        model?: string;
        group?: string;
        subGroup?: string;
        codProd?: string;
        /** @default false */
        deleted: boolean;
        /** @example "135654" */
        cdtecDeviceId?: string;
        /** @example "Sentek" */
        brand?: string;
      };
    };
    /** @example "suelo" */
    sensorType?: string;
    /** @example true */
    isGatewayNode?: boolean;
    nodeChip?: string;
    /** @example "123456" */
    deviceId: string;
    /** @example "2024-05-01T00:00:00.000Z" */
    createdAt: string;
    /** @example "2024-05-01T00:00:00.000Z" */
    updatedAt: string;
    /** @example "active" */
    status: string;
    /** @example false */
    deleted: boolean;
    /** @example "Nuevo sensor" */
    lastActivity?: string;
    comment?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    farm: string;
    /** @example "669814726c9ca473fff3ee4d" */
    sector?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    subSector?: string;
    /** @example "wiseconn" */
    telemetryType?: string;
    /** @example "zone123" */
    zoneId?: string;
    coordinates?: {
      /**
       * @format float
       * @example -25.12
       */
      lng: number;
      /**
       * @format float
       * @example 35.12
       */
      lat: number;
    };
  }[];
}

export interface GetDeviceModelsFromSoftlandResponse {
  /** @example true */
  success?: boolean;
  /** @example "Modelos de equipos encontrados exitosamente" */
  message?: string;
  nodeModels?: string[];
  nodeBrands?: string[];
  sensorModels?: string[];
  sensorBrands?: string[];
}

export interface SectorSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id?: string;
  /** @example "Sector 1" */
  name: string;
  /** @example "Drill and drop" */
  sectorDevice: string;
  /** @example "100" */
  theoreticalSurface: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farm?: string;
  /** @example "5618131" */
  wiseconnId?: string;
  /** @example "1" */
  sectorNumber: string;
  variety?: {
    /** @example "Chandler" */
    name?: string;
    /** @example "Chandler" */
    species?: string;
  };
  /** @example "Loamy" */
  typeOfSoil: string;
  coordinates?: {
    /**
     * @format float
     * @example -25.12
     */
    lng: number;
    /**
     * @format float
     * @example 35.12
     */
    lat: number;
  }[];
  /** @example [] */
  subSectors?: any[];
  /** @example {} */
  graphConfig?: object;
  /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
  measures?: {
    wiseconn?: {
      /** @example ["1-80474"] */
      sectorMeasures?: string[];
      /** @example ["1-80475"] */
      weatherMeasures?: string[];
      /** @example ["1-80476"] */
      irrigationMeasures?: string[];
    };
  };
  /**
   * @format float
   * @example "2020"
   */
  plantingYear?: number;
  weatherZoneId?: string;
  sn?: string;
  irrigationConfig?: {
    lineNumber?: string;
    rowDistance?: string;
    plantDistance?: string;
    plantsPerHectare?: string;
    emittersPerHectare?: string;
    emitterSurface?: string;
    realPrecipitation?: string;
    designPrecipitation?: string;
    typeOfIrrigation?: string;
    theoreticalPrecipitation?: string;
    emitterFlow?: string;
    transmittersDistance?: number;
    selectedCultivationCycleId?: string;
  };
  /** @example "Sector padre" */
  parentSector?: string;
  /** @example "Wiseconn" */
  telemetryType?: string;
}

export interface SectorDetailSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id?: string;
  /** @example "Sector 1" */
  name: string;
  /** @example "Drill and drop" */
  sectorDevice: string;
  /** @example "100" */
  theoreticalSurface: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farm?: string;
  /** @example "5618131" */
  wiseconnId?: string;
  /** @example "1" */
  sectorNumber: string;
  variety?: {
    /** @example "Chandler" */
    name?: string;
    /** @example "Chandler" */
    species?: string;
  };
  /** @example "Loamy" */
  typeOfSoil: string;
  coordinates?: {
    /**
     * @format float
     * @example -25.12
     */
    lng: number;
    /**
     * @format float
     * @example 35.12
     */
    lat: number;
  }[];
  /** @example [] */
  subSectors?: any[];
  /** @example {} */
  graphConfig?: object;
  /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
  measures?: {
    wiseconn?: {
      /** @example ["1-80474"] */
      sectorMeasures?: string[];
      /** @example ["1-80475"] */
      weatherMeasures?: string[];
      /** @example ["1-80476"] */
      irrigationMeasures?: string[];
    };
  };
  /**
   * @format float
   * @example 2020
   */
  plantingYear?: number;
  /** @example "pluvial" */
  typeOfIrrigation?: string;
  /** @example "Normal" */
  emitterFlowRate?: string;
  /**
   * @format float
   * @example 100
   */
  transmittersDistance?: number;
  /** @example "Regular" */
  plantingFrame?: string;
  /** @example "Patricio Orrego" */
  managerName?: string;
  /** @example "Sector padre" */
  parentSector?: string;
  weatherZoneId?: string;
  sn?: string;
  irrigationConfig?: {
    typeOfIrrigation?: string;
    lineNumber?: string;
    rowDistance?: string;
    plantDistance?: string;
    plantsPerHectare?: string;
    emittersPerHectare?: string;
    emitterSurface?: string;
    realPrecipitation?: string;
    designPrecipitation?: string;
    theoreticalPrecipitation?: string;
    emitterFlow?: string;
    selectedCultivationCycleId?: string;
  };
  /** @example "Wiseconn" */
  telemetryType?: string;
}

export interface GetSectorsPerPageSchema {
  /**
   * @format float
   * @example 10
   */
  limit?: number;
  /**
   * @format float
   * @example 0
   */
  page?: number;
  /** @example "" */
  searchValue?: string;
  /** @pattern (\|DESC\b|\|ASC\b) */
  sort?: string;
}

export interface PostFarmSectorsSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id?: string;
  /** @example "Sector 1" */
  name: string;
  /** @example "Drill and drop" */
  sectorDevice: string;
  /** @example "100" */
  theoreticalSurface: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farm?: string;
  /** @example "5618131" */
  wiseconnId?: string;
  /** @example "1" */
  sectorNumber: string;
  variety?: {
    /** @example "Chandler" */
    name?: string;
    /** @example "Chandler" */
    species?: string;
  };
  /** @example "Loamy" */
  typeOfSoil: string;
  coordinates?: {
    /**
     * @format float
     * @example -25.12
     */
    lng: number;
    /**
     * @format float
     * @example 35.12
     */
    lat: number;
  }[];
  /** @example [] */
  subSectors?: any[];
  /** @example {} */
  graphConfig?: object;
  /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
  measures?: {
    wiseconn?: {
      /** @example ["1-80474"] */
      sectorMeasures?: string[];
      /** @example ["1-80475"] */
      weatherMeasures?: string[];
      /** @example ["1-80476"] */
      irrigationMeasures?: string[];
    };
  };
  /**
   * @format float
   * @example "2020"
   */
  plantingYear?: number;
}

export interface UpdateSectorSchema {
  /** @example "Sector 1" */
  name: string;
  /** @example "100" */
  theoreticalSurface: string;
  /** @example "1234567" */
  wiseconnId?: string;
  /** @example "Drill and drop" */
  sectorDevice?: string;
  /** @example "pluvial" */
  typeOfIrrigation?: string;
  /** @example "Loamy" */
  typeOfSoil: string;
  /** @example "Chandler" */
  variety?: string;
  /**
   * @format float
   * @example 2020
   */
  plantingYear?: number;
  /** @example "Normal" */
  emitterFlowRate?: string;
  /**
   * @format float
   * @example 100
   */
  transmittersDistance?: number;
  /** @example "Regular" */
  plantingFrame?: string;
  /** @example "Patricio Orrego" */
  managerName?: string;
  /** @example "Sector padre" */
  parentSector?: string | null;
  /** @example "1" */
  sectorNumber?: string;
  measures?: {
    /** @example ["1-80474"] */
    wiseconn?: string[];
  }[];
  /** @example {} */
  graphConfig?: object;
  irrigationConfig?: {
    typeOfIrrigation?: string;
    lineNumber?: string;
    rowDistance?: string;
    plantDistance?: string;
    plantsPerHectare?: string;
    emittersPerHectare?: string;
    emitterSurface?: string;
    realPrecipitation?: string;
    designPrecipitation?: string;
    theoreticalPrecipitation?: string;
    emitterFlow?: string;
    selectedCultivationCycleId?: string;
  };
}

export interface UpdateSectorMeasuresSchema {
  farmId: string;
  wiseconnZoneId: string;
}

export type PutSectorsKMZSchema = Record<
  string,
  {
    id: string;
    coordinates: {
      /** @format float */
      lat: number;
      /** @format float */
      lng: number;
    }[];
  }
>;

export interface GetNodesByFarmIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Nodos encontrados exitosamente" */
  message?: string;
  nodes?: NodeSchema[];
}
export interface NodeWiseconnSchema extends NodeSchema {
  sensors: SensorSchema[];
  lat: number;
  lng: number;
}
export interface GetNodesWiseconnListResponse {
  /** @example true */
  success?: boolean;
  /** @example "Nodos encontrados exitosamente" */
  message?: string;
  nodes?: NodeWiseconnSchema[];
}

export interface PutNodeSchema {
  id?: string;
  name?: string;
  wiseconnId?: string;
  sector?: { id: string, name: string };
  coordinates?: {
    lng?: number;
    lat?: number;
  };
  status?: string;
  comment?: string;
  isGatewayNode?: boolean;
  nodeType?: string;
  modemId?: string;
  networkNumber?: number;
  mac?: string;
  telemetryType?: string;
  softlandBrand?: string;
  softlandModel?: string;
  active?: boolean;
}

export interface GetNodeByIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Nodo encontrado exitosamente" */
  message?: string;
  node?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "Nodo 1" */
    name: string;
    wiseconnId?: string;
    deleted?: boolean;
    createdAt?: string;
    updatedAt?: string;
    lastActivity?: string;
    status?: string;
    comment?: string;
    farm?: string;
    sector?: { id: string, name: string };
    coordinates?: {
      lng?: number;
      lat?: number;
    };
    isGatewayNode?: boolean;
    nodeType?: string;
    modemId?: string;
    networkNumber?: number;
    mac?: string;
    expansions?: any[];
    telemetryType?: string;
    softlandBrand?: string;
    softlandModel?: string;
    active?: boolean;
  };
}

export interface GetSensorsByFarmIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Sensores encontrados exitosamente" */
  message?: string;
  sensors?: SensorSchema[];
}

export interface GetSensorModelsByFarmIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "SensorModels encontradas exitosamente" */
  message?: string;
  sensorModels?: SensorModelSchema[];
}

export interface SensorModelSchema {
  telemetryType?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  _id: string;
  /** @example "669814726c9ca473fff3ee4d" */
  id: string;
  /** @example "Sonda 1" */
  name: string;
  sensorType: string;
  unit: string;
  status: string;
  lastActivity: string;
  isWeatherStation: boolean;
  type: string;
  zoneId: string;
  account?: AccountSchema;
  farm: {
    /** @example "669814726c9ca473fff3ee4d" */
    _id: string;
    /** @example "Farm 1" */
    name: string;
  };
  sector: {
    /** @example "669814726c9ca473fff3ee4d" */
    _id: string;
    /** @example "Sector 1" */
    name: string;
    id: string;
  };
  node: {
    _id: string;
    name: string;
  };
  sensors?: SensorSchema[];
}

export interface GetSensorModelByIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Sensor model encontrado exitosamente" */
  message?: string;
  sensorModel?: SensorModelSchema;
}

export interface GetSensorByIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Sensor encontrado exitosamente" */
  message?: string;
  sensor?: {
    /** @example "669814726c9ca473fff3ee4d" */
    _id: string;
    /** @example "669814726c9ca473fff3ee4d" */
    id: string;
    /** @example "Sensor 1" */
    name: string;
    /** @example "669814726c9ca473fff3ee4d" */
    wiseconnId?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    zoneId?: string;
    /** @example false */
    deleted: boolean;
    sensorModel: SensorModelSchema;
    /** @example "2024-05-01T00:00:00.000Z" */
    createdAt: string;
    /** @example "2024-05-01T00:00:00.000Z" */
    updatedAt: string;
    /** @example "2024-05-01T00:00:00.000Z" */
    lastActivity: string;
    /** @example "Operative" */
    status: string;
    /** @example "Nuevo sensor" */
    comment?: string;
    farm?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id: string;
      /** @example "Farm 1" */
      name: string;
    };
    sector?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id: string;
      /** @example "Sector 1" */
      name: string;
    };
    coordinates?: {
      /**
       * @format float
       * @example -25.12
       */
      lng: number;
      /**
       * @format float
       * @example 35.12
       */
      lat: number;
    };
    sensorModelId?: string;
    /** @example "suelo" */
    sensorType?: string;
    /** @example false */
    isWeatherStation?: boolean;
    /** @example "wiseconn" */
    telemetryType?: string;
    /** @example "m3" */
    unit?: string;
    /** @example "Sentek" */
    brand?: string;
    physicalConnection?: object;
    /** @example "Sentek" */
    softlandBrand?: string;
    /** @example "Drill and Drop" */
    softlandModel?: string;
  };
}

export interface PostFarmSectorsResponse {
  /** @example true */
  success?: boolean;
  /** @example "Sector anadido a campo exitosamente" */
  message?: string;
  sector?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "Sector 1" */
    name: string;
    /** @example "Drill and drop" */
    sectorDevice: string;
    /** @example "100" */
    theoreticalSurface: string;
    /** @example "669814726c9ca473fff3ee4d" */
    farm?: string;
    /** @example "5618131" */
    wiseconnId?: string;
    /** @example "1" */
    sectorNumber: string;
    variety?: {
      /** @example "Chandler" */
      name?: string;
      /** @example "Chandler" */
      species?: string;
    };
    /** @example "Loamy" */
    typeOfSoil: string;
    coordinates?: {
      /**
       * @format float
       * @example -25.12
       */
      lng: number;
      /**
       * @format float
       * @example 35.12
       */
      lat: number;
    }[];
    /** @example [] */
    subSectors?: any[];
    /** @example {} */
    graphConfig?: object;
    /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
    measures?: {
      wiseconn?: {
        /** @example ["1-80474"] */
        sectorMeasures?: string[];
        /** @example ["1-80475"] */
        weatherMeasures?: string[];
        /** @example ["1-80476"] */
        irrigationMeasures?: string[];
      };
    };
    /**
     * @format float
     * @example "2020"
     */
    plantingYear?: number;
    sn?: string;
    irrigationConfig?: {
      typeOfIrrigation?: string;
      lineNumber?: string;
      rowDistance?: string;
      plantDistance?: string;
      plantsPerHectare?: string;
      emittersPerHectare?: string;
      emitterSurface?: string;
      realPrecipitation?: string;
      designPrecipitation?: string;
      theoreticalPrecipitation?: string;
      emitterFlow?: string;
      selectedCultivationCycleId?: string;
    };
  };
}
export interface CheckSectorDataRecoveryStatusResponse {
  success: boolean;
  sectorId: string;
  needsRecovery: boolean;
  lastRecoveryDate: Date;
  message: string;
}
export interface PublishSectorDataRecoveryBatchesSchema {
  batchesCount: number;
  batches: string[];
}

export interface SectorByIdSchemaResponse {
  /** @example true */
  success?: boolean;
  /** @example "Usuario encontrado" */
  message?: string;
  sector?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "Sector 1" */
    name: string;
    /** @example "Drill and drop" */
    sectorDevice: string;
    /** @example "100" */
    theoreticalSurface: string;
    /** @example "669814726c9ca473fff3ee4d" */
    farm?: string;
    /** @example "5618131" */
    wiseconnId?: string;
    /** @example "1" */
    sectorNumber: string;
    variety?: {
      /** @example "Chandler" */
      name?: string;
      /** @example "Chandler" */
      species?: string;
    };
    /** @example "Loamy" */
    typeOfSoil: string;
    coordinates?: {
      /**
       * @format float
       * @example -25.12
       */
      lng: number;
      /**
       * @format float
       * @example 35.12
       */
      lat: number;
    }[];
    /** @example [] */
    subSectors?: any[];
    /** @example {} */
    graphConfig?: object;
    /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
    measures?: {
      wiseconn?: {
        /** @example ["1-80474"] */
        sectorMeasures?: string[];
        /** @example ["1-80475"] */
        weatherMeasures?: string[];
        /** @example ["1-80476"] */
        irrigationMeasures?: string[];
      };
    };
    /**
     * @format float
     * @example 2020
     */
    plantingYear?: number;
    /** @example "pluvial" */
    plantingFrame?: string;
    /** @example "Patricio Orrego" */
    managerName?: string;
    /** @example "Sector padre" */
    parentSector?: string;
    irrigationConfig?: {
      lineNumber?: string;
      rowDistance?: string;
      plantDistance?: string;
      plantsPerHectare?: string;
      emittersPerHectare?: string;
      emitterSurface?: string;
      realPrecipitation?: string;
      designPrecipitation?: string;
      typeOfIrrigation?: string;
      theoreticalPrecipitation?: string;
      emitterFlow?: string;
      transmittersDistance?: number;
      selectedCultivationCycleId?: string;
    };
    /** @example "Wiseconn" */
    telemetryType?: string;
  };
}

export interface UpdateSectorResponse {
  /** @example true */
  success?: boolean;
  /** @example "Sector editado exitosamente" */
  message?: string;
  sector?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "Sector 1" */
    name: string;
    /** @example "Drill and drop" */
    sectorDevice: string;
    /** @example "100" */
    theoreticalSurface: string;
    /** @example "669814726c9ca473fff3ee4d" */
    farm?: string;
    /** @example "5618131" */
    wiseconnId?: string;
    /** @example "1" */
    sectorNumber: string;
    variety?: {
      /** @example "Chandler" */
      name?: string;
      /** @example "Chandler" */
      species?: string;
    };
    /** @example "Loamy" */
    typeOfSoil: string;
    coordinates?: {
      /**
       * @format float
       * @example -25.12
       */
      lng: number;
      /**
       * @format float
       * @example 35.12
       */
      lat: number;
    }[];
    /** @example [] */
    subSectors?: any[];
    /** @example {} */
    graphConfig?: object;
    /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
    measures?: {
      wiseconn?: {
        /** @example ["1-80474"] */
        sectorMeasures?: string[];
        /** @example ["1-80475"] */
        weatherMeasures?: string[];
        /** @example ["1-80476"] */
        irrigationMeasures?: string[];
      };
    };
    /**
     * @format float
     * @example 2020
     */
    plantingYear?: number;
    /** @example "pluvial" */
    typeOfIrrigation?: string;
    /** @example "Normal" */
    emitterFlowRate?: string;
    /**
     * @format float
     * @example 100
     */
    transmittersDistance?: number;
    /** @example "Regular" */
    plantingFrame?: string;
    /** @example "Patricio Orrego" */
    managerName?: string;
    /** @example "Sector padre" */
    parentSector?: string;
    sn?: string;
    irrigationConfig?: {
      typeOfIrrigation?: string;
      lineNumber?: string;
      rowDistance?: string;
      plantDistance?: string;
      plantsPerHectare?: string;
      emittersPerHectare?: string;
      emitterSurface?: string;
      realPrecipitation?: string;
      designPrecipitation?: string;
      theoreticalPrecipitation?: string;
      emitterFlow?: string;
      selectedCultivationCycleId?: string;
    };
    /** @example "Wiseconn" */
    telemetryType?: string;
  };
}

export interface PutSectorsKMZResponse {
  /** @example true */
  success?: boolean;
  /** @example "Sectores actualizados basados en KMZ" */
  message?: string;
  sectors?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "Sector 1" */
    name: string;
    /** @example "Drill and drop" */
    sectorDevice: string;
    /** @example "100" */
    theoreticalSurface: string;
    /** @example "669814726c9ca473fff3ee4d" */
    farm?: string;
    /** @example "5618131" */
    wiseconnId?: string;
    /** @example "1" */
    sectorNumber: string;
    variety?: {
      /** @example "Chandler" */
      name?: string;
      /** @example "Chandler" */
      species?: string;
    };
    /** @example "Loamy" */
    typeOfSoil: string;
    coordinates?: {
      /**
       * @format float
       * @example -25.12
       */
      lng: number;
      /**
       * @format float
       * @example 35.12
       */
      lat: number;
    }[];
    /** @example [] */
    subSectors?: any[];
    /** @example {} */
    graphConfig?: object;
    /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
    measures?: {
      wiseconn?: {
        /** @example ["1-80474"] */
        sectorMeasures?: string[];
        /** @example ["1-80475"] */
        weatherMeasures?: string[];
        /** @example ["1-80476"] */
        irrigationMeasures?: string[];
      };
    };
    /**
     * @format float
     * @example "2020"
     */
    plantingYear?: number;
  }[];
}

export interface GetSectorsWiseconnIdsResponse {
  /** @example true */
  success?: boolean;
  /** @example "Wiseconn Ids de todos los sectores obtenidos con éxito" */
  message?: string;
  /** @example ["1234567","7654321"] */
  allSectorsWiseconnIds?: string[];
}

export interface GetSectorsHeliusSnResponse {
  /** @example true */
  success?: boolean;
  /** @example "Helius Sns de todos los sectores obtenidos con éxito" */
  message?: string;
  /** @example ["1234567","7654321"] */
  allSectorsHeliusSn?: string[];
}

export interface GetFarmSectorsResponse {
  /** @example true */
  success?: boolean;
  /** @example "Sectores del campo obtenidos con éxito" */
  message?: string;
  sectors?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "Sector 1" */
    name: string;
    /** @example "Drill and drop" */
    sectorDevice: string;
    /** @example "100" */
    theoreticalSurface: string;
    /** @example "669814726c9ca473fff3ee4d" */
    farm?: string;
    /** @example "5618131" */
    wiseconnId?: string;
    /** @example "1" */
    sectorNumber: string;
    variety?: {
      /** @example "Chandler" */
      name?: string;
      /** @example "Chandler" */
      species?: string;
    };
    /** @example "Loamy" */
    typeOfSoil: string;
    coordinates?: {
      /**
       * @format float
       * @example -25.12
       */
      lng: number;
      /**
       * @format float
       * @example 35.12
       */
      lat: number;
    }[];
    /** @example [] */
    subSectors?: any[];
    /** @example {} */
    graphConfig?: object;
    /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
    measures?: {
      wiseconn?: {
        /** @example ["1-80474"] */
        sectorMeasures?: string[];
        /** @example ["1-80475"] */
        weatherMeasures?: string[];
        /** @example ["1-80476"] */
        irrigationMeasures?: string[];
      };
    };
    /**
     * @format float
     * @example "2020"
     */
    plantingYear?: number;
  }[];
}

export interface GetMeasuresBySectorIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Mediciones del sector obtenidas con éxito" */
  message?: string;
  /** @example [] */
  measures?: any[];
}

export interface UpdateSectorMeasuresResponse {
  /** @example true */
  success?: boolean;
  /** @example "Mediciones del sector actualizadas con éxito" */
  message?: string;
  /** @example [] */
  measures?: any[];
}

export interface FarmSchema {
  _id?: string;
  /** @example "Campo Cerezos" */
  name: string;
  /** @example "Calle Ejemplo Exampl 123" */
  location: string;
  /** @example "100" */
  theoreticalSurface: string;
  center: {
    /** @example "-30.35161" */
    lat: string | number;
    /** @example "58.681618" */
    lng: string | number;
  };
  coordinates?: {
    /** @example "-30.35161" */
    lat: string;
    /** @example "58.681618" */
    lng: string;
  }[];
  /**
   * @format float
   * @example 18
   */
  zoom?: number;
  /** @example "669814726c9ca473fff3ee4d" */
  accountId?: string | AccountSchema;
  sectors?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "Sector 1" */
    name: string;
    /** @example "Drill and drop" */
    sectorDevice: string;
    /** @example "100" */
    theoreticalSurface: string;
    /** @example "669814726c9ca473fff3ee4d" */
    farm?: string;
    /** @example "5618131" */
    wiseconnId?: string;
    /** @example "1" */
    sectorNumber: string;
    variety?: {
      /** @example "Chandler" */
      name?: string;
      /** @example "Chandler" */
      species?: string;
    };
    /** @example "Loamy" */
    typeOfSoil: string;
    coordinates?: {
      /**
       * @format float
       * @example -25.12
       */
      lng: number;
      /**
       * @format float
       * @example 35.12
       */
      lat: number;
    }[];
    /** @example [] */
    subSectors?: any[];
    /** @example {} */
    graphConfig?: object;
    /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
    measures?: {
      wiseconn?: {
        /** @example ["1-80474"] */
        sectorMeasures?: string[];
        /** @example ["1-80475"] */
        weatherMeasures?: string[];
        /** @example ["1-80476"] */
        irrigationMeasures?: string[];
      };
    };
    /**
     * @format float
     * @example "2020"
     */
    plantingYear?: number;
    parentSector?: string;
    /** @example "Wiseconn" */
    telemetryType?: string;
    weatherZoneId?: string;
  }[];
  devices?: {
    id?: string;
    type: string;
    brand: string;
    model: string;
    nodeId?: string | null;
    nodeType?: string | null;
  }[];
  /** @example "58" */
  wiseconnId?: string;
  /** @example "api-key-123" */
  wiseconnApiKey?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  id?: string;
  /** @default false */
  deleted?: boolean;
  /**
   * @format date-time
   * @default "2023-03-07T19:43:46.303Z"
   */
  createdAt?: string;
  /**
   * @format date-time
   * @default "2023-03-07T19:43:46.303Z"
   */
  updatedAt?: string;
}

export interface PostFarmSchema {
  /** @example "Campo Cerezos" */
  name: string;
  /** @example "Calle Ejemplo Exampl 123" */
  location: string;
  /** @example "100" */
  theoreticalSurface: string;
  center: {
    /** @example "-30.35161" */
    lat: string | number;
    /** @example "58.681618" */
    lng: string | number;
  };
  coordinates?: {
    /**
     * @format float
     * @example -30.35161
     */
    lat: number;
    /**
     * @format float
     * @example 58.681618
     */
    lng: number;
  }[];
  /**
   * @format float
   * @example 18
   */
  zoom?: number;
  /** @example "669814726c9ca473fff3ee4d" */
  accountId?: string;
  sectors?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "Sector 1" */
    name: string;
    /** @example "Drill and drop" */
    sectorDevice: string;
    /** @example "100" */
    theoreticalSurface: string;
    /** @example "669814726c9ca473fff3ee4d" */
    farm?: string;
    /** @example "5618131" */
    wiseconnId?: string;
    /** @example "1" */
    sectorNumber: string;
    variety?: {
      /** @example "Chandler" */
      name?: string;
      /** @example "Chandler" */
      species?: string;
    };
    /** @example "Loamy" */
    typeOfSoil: string;
    coordinates?: {
      /**
       * @format float
       * @example -25.12
       */
      lng: number;
      /**
       * @format float
       * @example 35.12
       */
      lat: number;
    }[];
    /** @example [] */
    subSectors?: any[];
    /** @example {} */
    graphConfig?: object;
    /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
    measures?: {
      wiseconn?: {
        /** @example ["1-80474"] */
        sectorMeasures?: string[];
        /** @example ["1-80475"] */
        weatherMeasures?: string[];
        /** @example ["1-80476"] */
        irrigationMeasures?: string[];
      };
    };
    /**
     * @format float
     * @example "2020"
     */
    plantingYear?: number;
    /** @example "Wiseconn" */
    telemetryType?: string;
  }[];
  devices?: {
    id?: string;
    type: string;
    brand: string;
    model: string;
    nodeId?: string | null;
    nodeType?: string | null;
  }[];
  /** @example "58" */
  wiseconnId?: string;
  /** @example "api-key-123" */
  wiseconnApiKey?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  accountDocumentId?: string;
}

export interface PutNodeResponse {
  /** @example true */
  success?: boolean;
  /** @example "Nodo actualizado exitosamente" */
  message?: string;
  node?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
  }[];
}

export interface GetFarmsPerPageSchema {
  /**
   * @format float
   * @example 10
   */
  limit?: number;
  /**
   * @format float
   * @example 0
   */
  page?: number;
  /** @example "" */
  searchValue?: string;
  /** @pattern (\|DESC\b|\|ASC\b) */
  sort?: string;
}

export interface IrrigationSchema {
  /**
   * @format float
   * @example 18720510
   */
  id: number;
  /** @example "2026-04-01T21:00:00.000Z" */
  initTime: string;
  /** @example "2026-04-01T21:10:00.000Z" */
  endTime: string;
  /** @example "executedOk" */
  status: "scheduled" | "proposal" | "running" | "executedOk" | "stoppedByUser" | "failure" | "unknown";
  /** @example "Executed OK" */
  rawStatus?: string | null;
  /** @example "Duration" */
  irrigationType?: string | null;
  /**
   * @format float
   * @example 40835
   */
  zoneId?: number | null;
  /**
   * @format float
   * @example 7652
   */
  pumpSystemId?: number | null;
  volume?: {
    /**
     * @format float
     * @example 7.4
     */
    value?: number | null;
    /** @example "m³" */
    unit?: string | null;
  };
  precipitation?: {
    /**
     * @format float
     * @example 7.4
     */
    value?: number | null;
    /** @example "m³" */
    unit?: string | null;
  };
}
export interface GetIrrigationsSchema {
  /**
   * @format date-time
   * @example "2026-04-01T00:00:00.000Z"
   */
  initTime: string;
  /**
   * @format date-time
   * @example "2026-04-06T00:00:00.000Z"
   */
  endTime: string;
}
export interface GetIrrigationGroupingResponse {
  /** @example true */
  success?: boolean;
  /** @example "Agrupamiento de equipos de riego obtenido exitosamente" */
  message?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farmId?: string;
  pumpSystems: {
    /**
     * @format float
     * @example 7652
     */
    id: number;
    /** @example "Equipo Norte" */
    name: string;
  }[];
  sectors: {
    /** @example "669814726c9ca473fff3ee4d" */
    id: string;
    /**
     * @format float
     * @example 7652
     */
    pumpSystemId?: number | null;
  }[];
}
export interface GetIrrigationsResponse {
  /** @example true */
  success?: boolean;
  /** @example "Riegos del campo obtenidos exitosamente" */
  message?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farmId?: string;
  pumpSystems: {
    /**
     * @format float
     * @example 7652
     */
    id: number;
    /** @example "Equipo Norte" */
    name: string;
    /** @example true */
    parallelIrrigation?: boolean | null;
  }[];
  zones: {
    /**
     * @format float
     * @example 40835
     */
    id: number;
    /** @example "Sector 1" */
    name: string;
    /**
     * @format float
     * @example 7652
     */
    pumpSystemId?: number | null;
  }[];
  irrigations: {
    /**
     * @format float
     * @example 18720510
     */
    id: number;
    /** @example "2026-04-01T21:00:00.000Z" */
    initTime: string;
    /** @example "2026-04-01T21:10:00.000Z" */
    endTime: string;
    /** @example "executedOk" */
    status: "scheduled" | "proposal" | "running" | "executedOk" | "stoppedByUser" | "failure" | "unknown";
    /** @example "Executed OK" */
    rawStatus?: string | null;
    /** @example "Duration" */
    irrigationType?: string | null;
    /**
     * @format float
     * @example 40835
     */
    zoneId?: number | null;
    /**
     * @format float
     * @example 7652
     */
    pumpSystemId?: number | null;
    volume?: {
      /**
       * @format float
       * @example 7.4
       */
      value?: number | null;
      /** @example "m³" */
      unit?: string | null;
    };
    precipitation?: {
      /**
       * @format float
       * @example 7.4
       */
      value?: number | null;
      /** @example "m³" */
      unit?: string | null;
    };
  }[];
}
export interface StartIrrigationBody {
  /** @example "669814726c9ca473fff3ee4d" */
  sector?: string;
  /**
   * @format float
   * @example 174107
   */
  wiseconnZoneId?: number;
  /**
   * @format int32
   * @example 30
   */
  durationMin?: number;
  /** @example "2026-05-30T21:30:00Z" */
  endTime?: string;
  /**
   * @format float
   * @example 1.5
   */
  precipitation?: number;
  /** @example "2026-05-30T20:30:00Z" */
  initTime?: string;
  /** @example "a3f9b1e2-1c4d-4e5f-8a9b-0c1d2e3f4a5b" */
  idempotencyKey: string;
  /** @example true */
  directSchedule?: boolean;
}
export interface EditIrrigationBody {
  /** @example "a3f9b1e2-1c4d-4e5f-8a9b-0c1d2e3f4a5b" */
  idempotencyKey: string;
  /**
   * @format float
   * @example 174107
   */
  wiseconnZoneId?: number;
}
export interface IrrigationCommandResponse {
  /** @example true */
  success?: boolean;
  /** @example "Comando de riego aceptado" */
  message?: string;
  command?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id: string;
    /** @example "dry_run" */
    status: "pending" | "sent" | "success" | "failed" | "dry_run";
    /** @example true */
    dryRun: boolean;
    /**
     * @format float
     * @example 12345
     */
    wiseconnIrrigationId?: number | null;
  };
}

export interface PeakHourConfig {
  /**
   * @format float
   * @example 174107
   */
  pumpSystemId: number;
  /** @example "Equipo 1" */
  name: string;
  /** @example true */
  enabled: boolean;
  /** @example "18:00" */
  init: string | null;
  /** @example "23:00" */
  end: string | null;
  /** @example false */
  wiseconnEnabled: boolean | null;
  /** @example "18:00" */
  wiseconnInit: string | null;
  /** @example "23:00" */
  wiseconnEnd: string | null;
}
export interface GetPeakHoursResponse {
  /** @example true */
  success: boolean;
  /** @example "Franjas de hora punta obtenidas" */
  message: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farmId: string;
  configs: PeakHourConfig[];
}
export interface SetPeakHourBody {
  /** @example true */
  enabled: boolean;
  /** @example "18:00" */
  init?: string;
  /** @example "23:00" */
  end?: string;
}
export interface SetPeakHourResponse {
  /** @example true */
  success: boolean;
  /** @example "Hora punta actualizada" */
  message: string;
  config: PeakHourConfig;
}

export interface UpdateFarmSchema {
  /** @example "Campo Cerezos" */
  name?: string;
  /** @example "Calle Ejemplo Exampl 123" */
  location?: string;
  /** @example "100" */
  theoreticalSurface?: string;
  center?: {
    /** @example "-30.35161" */
    lat: string | number;
    /** @example "58.681618" */
    lng: string | number;
  };
  coordinates?: {
    /**
     * @format float
     * @example -30.35161
     */
    lat: number;
    /**
     * @format float
     * @example 58.681618
     */
    lng: number;
  }[];
  /** @example "58" */
  wiseconnId?: string;
  /** @example "api-key-123" */
  wiseconnApiKey?: string;
}

export interface GetFarmsPerPageResponse {
  /** @example true */
  success?: boolean;
  /** @example "Cuenta creada exitosamente" */
  message?: string;
  farms?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "New Far" */
    name?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    accountId?: string;
  }[];
  /** @example 1 */
  totalFarms?: number;
}

export interface PostFarmsResponse {
  /** @example true */
  success?: boolean;
  /** @example "Campo creado exitosamente" */
  message?: string;
  farm?: {
    /** @example "Campo Cerezos" */
    name: string;
    /** @example "Calle Ejemplo Exampl 123" */
    location: string;
    /** @example "100" */
    theoreticalSurface: string;
    center: {
      /** @example "-30.35161" */
      lat: string | number;
      /** @example "58.681618" */
      lng: string | number;
    };
    coordinates?: {
      /** @example "-30.35161" */
      lat: string;
      /** @example "58.681618" */
      lng: string;
    }[];
    /**
     * @format float
     * @example 18
     */
    zoom?: number;
    /** @example "669814726c9ca473fff3ee4d" */
    accountId?: string;
    sectors?: {
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @example "Sector 1" */
      name: string;
      /** @example "Drill and drop" */
      sectorDevice: string;
      /** @example "100" */
      theoreticalSurface: string;
      /** @example "669814726c9ca473fff3ee4d" */
      farm?: string;
      /** @example "5618131" */
      wiseconnId?: string;
      /** @example "1" */
      sectorNumber: string;
      variety?: {
        /** @example "Chandler" */
        name?: string;
        /** @example "Chandler" */
        species?: string;
      };
      /** @example "Loamy" */
      typeOfSoil: string;
      coordinates?: {
        /**
         * @format float
         * @example -25.12
         */
        lng: number;
        /**
         * @format float
         * @example 35.12
         */
        lat: number;
      }[];
      /** @example [] */
      subSectors?: any[];
      /** @example {} */
      graphConfig?: object;
      /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
      measures?: {
        wiseconn?: {
          /** @example ["1-80474"] */
          sectorMeasures?: string[];
          /** @example ["1-80475"] */
          weatherMeasures?: string[];
          /** @example ["1-80476"] */
          irrigationMeasures?: string[];
        };
      };
      /**
       * @format float
       * @example "2020"
       */
      plantingYear?: number;
      /** @example "Wiseconn" */
      telemetryType?: string;
    }[];
    devices?: {
      id?: string;
      type: string;
      brand: string;
      model: string;
      nodeId?: string | null;
      nodeType?: string | null;
    }[];
    /** @example "58" */
    wiseconnId?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @default false */
    deleted?: boolean;
    /**
     * @format date-time
     * @default "2023-03-07T19:43:46.303Z"
     */
    createdAt?: string;
    /**
     * @format date-time
     * @default "2023-03-07T19:43:46.303Z"
     */
    updatedAt?: string;
  };
}

export interface GetFarmsByAccountIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Campos asociados a la cuenta encontrados exitosamente" */
  message?: string;
  allFarms?: {
    /** @example "Campo Cerezos" */
    name: string;
    /** @example "Calle Ejemplo Exampl 123" */
    location: string;
    /** @example "100" */
    theoreticalSurface: string;
    center: {
      /** @example "-30.35161" */
      lat: string | number;
      /** @example "58.681618" */
      lng: string | number;
    };
    coordinates?: {
      /** @example "-30.35161" */
      lat: string;
      /** @example "58.681618" */
      lng: string;
    }[];
    /**
     * @format float
     * @example 18
     */
    zoom?: number;
    /** @example "669814726c9ca473fff3ee4d" */
    accountId?: string;
    sectors?: {
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @example "Sector 1" */
      name: string;
      /** @example "Drill and drop" */
      sectorDevice: string;
      /** @example "100" */
      theoreticalSurface: string;
      /** @example "669814726c9ca473fff3ee4d" */
      farm?: string;
      /** @example "5618131" */
      wiseconnId?: string;
      /** @example "1" */
      sectorNumber: string;
      variety?: {
        /** @example "Chandler" */
        name?: string;
        /** @example "Chandler" */
        species?: string;
      };
      /** @example "Loamy" */
      typeOfSoil: string;
      coordinates?: {
        /**
         * @format float
         * @example -25.12
         */
        lng: number;
        /**
         * @format float
         * @example 35.12
         */
        lat: number;
      }[];
      /** @example [] */
      subSectors?: any[];
      /** @example {} */
      graphConfig?: object;
      /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
      measures?: {
        wiseconn?: {
          /** @example ["1-80474"] */
          sectorMeasures?: string[];
          /** @example ["1-80475"] */
          weatherMeasures?: string[];
          /** @example ["1-80476"] */
          irrigationMeasures?: string[];
        };
      };
      /**
       * @format float
       * @example "2020"
       */
      plantingYear?: number;
      /** @example "Wiseconn" */
      telemetryType?: string;
    }[];
    devices?: {
      id?: string;
      type: string;
      brand: string;
      model: string;
      nodeId?: string | null;
      nodeType?: string | null;
    }[];
    /** @example "58" */
    wiseconnId?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @default false */
    deleted?: boolean;
    /**
     * @format date-time
     * @default "2023-03-07T19:43:46.303Z"
     */
    createdAt?: string;
    /**
     * @format date-time
     * @default "2023-03-07T19:43:46.303Z"
     */
    updatedAt?: string;
  }[];
}

export interface GetFarmsWiseconnIdsResponse {
  /** @example true */
  success?: boolean;
  /** @example "Wiseconn Ids de todos los campos obtenidos con éxito" */
  message?: string;
  /** @example ["1234567","7654321"] */
  allFarmsWiseconnIds?: string[];
}

export interface AccountSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  _id?: string;
  /** @example "Tubesoft" */
  name: string;
  /** @example "669814726c9ca473fff3ee4d" */
  id?: string;
  companies?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "Empresa 123" */
    name: string;
    /** @example "12345678-9" */
    rut: string;
    /** @example "Empresa Cerezos" */
    businessName: string;
    /** @example "Chile" */
    country: string;
    /** @example "Region Metropolitana" */
    region: string;
    /** @example "Santiago" */
    commune: string;
    /** @example "123 Vespucio" */
    address: string;
    /** @example false */
    deleted: boolean;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    createdAt: string;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    updatedAt: string;
  }[];
  farms?: {
    /** @example "Campo Cerezos" */
    name: string;
    /** @example "Calle Ejemplo Exampl 123" */
    location: string;
    /** @example "100" */
    theoreticalSurface: string;
    center: {
      /** @example "-30.35161" */
      lat: string | number;
      /** @example "58.681618" */
      lng: string | number;
    };
    coordinates?: {
      /** @example "-30.35161" */
      lat: string;
      /** @example "58.681618" */
      lng: string;
    }[];
    /**
     * @format float
     * @example 18
     */
    zoom?: number;
    /** @example "669814726c9ca473fff3ee4d" */
    accountId?: string;
    sectors?: {
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @example "Sector 1" */
      name: string;
      /** @example "Drill and drop" */
      sectorDevice: string;
      /** @example "100" */
      theoreticalSurface: string;
      /** @example "669814726c9ca473fff3ee4d" */
      farm?: string;
      /** @example "5618131" */
      wiseconnId?: string;
      /** @example "1" */
      sectorNumber: string;
      variety?: {
        /** @example "Chandler" */
        name?: string;
        /** @example "Chandler" */
        species?: string;
      };
      /** @example "Loamy" */
      typeOfSoil: string;
      coordinates?: {
        /**
         * @format float
         * @example -25.12
         */
        lng: number;
        /**
         * @format float
         * @example 35.12
         */
        lat: number;
      }[];
      /** @example [] */
      subSectors?: any[];
      /** @example {} */
      graphConfig?: object;
      /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
      measures?: {
        wiseconn?: {
          /** @example ["1-80474"] */
          sectorMeasures?: string[];
          /** @example ["1-80475"] */
          weatherMeasures?: string[];
          /** @example ["1-80476"] */
          irrigationMeasures?: string[];
        };
      };
      /**
       * @format float
       * @example "2020"
       */
      plantingYear?: number;
      /** @example "Wiseconn" */
      telemetryType?: string;
    }[];
    devices?: {
      id?: string;
      type: string;
      brand: string;
      model: string;
      nodeId?: string | null;
      nodeType?: string | null;
    }[];
    /** @example "58" */
    wiseconnId?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @default false */
    deleted?: boolean;
    /**
     * @format date-time
     * @default "2023-03-07T19:43:46.303Z"
     */
    createdAt?: string;
    /**
     * @format date-time
     * @default "2023-03-07T19:43:46.303Z"
     */
    updatedAt?: string;
  }[];
}

export interface GetAccountsPerPageSchema {
  /**
   * @format float
   * @example 10
   */
  limit?: number;
  /**
   * @format float
   * @example 0
   */
  page?: number;
  /** @example "" */
  searchValue?: string;
  /** @pattern (\|DESC\b|\|ASC\b) */
  sort?: string;
}

export interface PostAccountSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  _id?: string;
  /** @example "Tubesoft" */
  name: string;
  companies?: string[];
}

export interface PutAccountSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  _id?: string;
  /** @example "Tubesoft" */
  name: string;
  companies?: string[];
}

export interface DeleteAccountSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id: string;
}

export interface GetAccountsPerPageResponse {
  /** @example true */
  success?: boolean;
  /** @example "Cuenta creada exitosamente" */
  message?: string;
  accounts?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "New Company" */
    name?: string;
    companies?: {
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @example "Empresa 123" */
      name: string;
      /** @example "12345678-9" */
      rut: string;
      /** @example "Empresa Cerezos" */
      businessName: string;
      /** @example "Chile" */
      country: string;
      /** @example "Region Metropolitana" */
      region: string;
      /** @example "Santiago" */
      commune: string;
      /** @example "123 Vespucio" */
      address: string;
      /** @example false */
      deleted: boolean;
      /**
       * @format date-time
       * @example "2023-03-07T19:43:46.303Z"
       */
      createdAt: string;
      /**
       * @format date-time
       * @example "2023-03-07T19:43:46.303Z"
       */
      updatedAt: string;
    }[];
    farms?: {
      /** @example "Campo Cerezos" */
      name: string;
      /** @example "Calle Ejemplo Exampl 123" */
      location: string;
      /** @example "100" */
      theoreticalSurface: string;
      center: {
        /** @example "-30.35161" */
        lat: string | number;
        /** @example "58.681618" */
        lng: string | number;
      };
      coordinates?: {
        /** @example "-30.35161" */
        lat: string;
        /** @example "58.681618" */
        lng: string;
      }[];
      /**
       * @format float
       * @example 18
       */
      zoom?: number;
      /** @example "669814726c9ca473fff3ee4d" */
      accountId?: string;
      sectors?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Sector 1" */
        name: string;
        /** @example "Drill and drop" */
        sectorDevice: string;
        /** @example "100" */
        theoreticalSurface: string;
        /** @example "669814726c9ca473fff3ee4d" */
        farm?: string;
        /** @example "5618131" */
        wiseconnId?: string;
        /** @example "1" */
        sectorNumber: string;
        variety?: {
          /** @example "Chandler" */
          name?: string;
          /** @example "Chandler" */
          species?: string;
        };
        /** @example "Loamy" */
        typeOfSoil: string;
        coordinates?: {
          /**
           * @format float
           * @example -25.12
           */
          lng: number;
          /**
           * @format float
           * @example 35.12
           */
          lat: number;
        }[];
        /** @example [] */
        subSectors?: any[];
        /** @example {} */
        graphConfig?: object;
        /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
        measures?: {
          wiseconn?: {
            /** @example ["1-80474"] */
            sectorMeasures?: string[];
            /** @example ["1-80475"] */
            weatherMeasures?: string[];
            /** @example ["1-80476"] */
            irrigationMeasures?: string[];
          };
        };
        /**
         * @format float
         * @example "2020"
         */
        plantingYear?: number;
        /** @example "Wiseconn" */
        telemetryType?: string;
      }[];
      devices?: {
        id?: string;
        type: string;
        brand: string;
        model: string;
        nodeId?: string | null;
        nodeType?: string | null;
      }[];
      /** @example "58" */
      wiseconnId?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @default false */
      deleted?: boolean;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      createdAt?: string;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      updatedAt?: string;
    }[];
    /** @example 1 */
    numberOfCompanies?: number;
    /** @example 3 */
    numberOfFarms?: number;
  }[];
  /** @example 1 */
  totalAccounts?: number;
}

export interface PostAccountResponse {
  /** @example true */
  success?: boolean;
  /** @example "Cuenta creada exitosamente" */
  message?: string;
  account?: AccountSchema;
}

export interface GetAccountByIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Cuenta encontrada exitosamente" */
  message?: string;
  account?: {
    /** @example "669814726c9ca473fff3ee4d" */
    _id?: string;
    /** @example "Tubesoft" */
    name: string;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    companies?: {
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @example "Empresa 123" */
      name: string;
      /** @example "12345678-9" */
      rut: string;
      /** @example "Empresa Cerezos" */
      businessName: string;
      /** @example "Chile" */
      country: string;
      /** @example "Region Metropolitana" */
      region: string;
      /** @example "Santiago" */
      commune: string;
      /** @example "123 Vespucio" */
      address: string;
      /** @example false */
      deleted: boolean;
      /**
       * @format date-time
       * @example "2023-03-07T19:43:46.303Z"
       */
      createdAt: string;
      /**
       * @format date-time
       * @example "2023-03-07T19:43:46.303Z"
       */
      updatedAt: string;
    }[];
    farms?: {
      /** @example "Campo Cerezos" */
      name: string;
      /** @example "Calle Ejemplo Exampl 123" */
      location: string;
      /** @example "100" */
      theoreticalSurface: string;
      center: {
        /** @example "-30.35161" */
        lat: string | number;
        /** @example "58.681618" */
        lng: string | number;
      };
      coordinates?: {
        /** @example "-30.35161" */
        lat: string;
        /** @example "58.681618" */
        lng: string;
      }[];
      /**
       * @format float
       * @example 18
       */
      zoom?: number;
      /** @example "669814726c9ca473fff3ee4d" */
      accountId?: string;
      sectors?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Sector 1" */
        name: string;
        /** @example "Drill and drop" */
        sectorDevice: string;
        /** @example "100" */
        theoreticalSurface: string;
        /** @example "669814726c9ca473fff3ee4d" */
        farm?: string;
        /** @example "5618131" */
        wiseconnId?: string;
        /** @example "1" */
        sectorNumber: string;
        variety?: {
          /** @example "Chandler" */
          name?: string;
          /** @example "Chandler" */
          species?: string;
        };
        /** @example "Loamy" */
        typeOfSoil: string;
        coordinates?: {
          /**
           * @format float
           * @example -25.12
           */
          lng: number;
          /**
           * @format float
           * @example 35.12
           */
          lat: number;
        }[];
        /** @example [] */
        subSectors?: any[];
        /** @example {} */
        graphConfig?: object;
        /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
        measures?: {
          wiseconn?: {
            /** @example ["1-80474"] */
            sectorMeasures?: string[];
            /** @example ["1-80475"] */
            weatherMeasures?: string[];
            /** @example ["1-80476"] */
            irrigationMeasures?: string[];
          };
        };
        /**
         * @format float
         * @example "2020"
         */
        plantingYear?: number;
        /** @example "Wiseconn" */
        telemetryType?: string;
      }[];
      devices?: {
        id?: string;
        type: string;
        brand: string;
        model: string;
        nodeId?: string | null;
        nodeType?: string | null;
      }[];
      /** @example "58" */
      wiseconnId?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @default false */
      deleted?: boolean;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      createdAt?: string;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      updatedAt?: string;
    }[];
  };
}

export interface PutAccountResponse {
  /** @example true */
  success?: boolean;
  /** @example "Cuenta creada exitosamente" */
  message?: string;
}

export interface DeleteAccountResponse {
  /** @example true */
  success?: boolean;
  /** @example "Cuenta eliminada exitosamente" */
  message?: string;
}

export interface GetUserAccountsByUserIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Cuentas de usuario encontrada exitosamente" */
  message?: string;
  userAccounts?: {
    /** @example "669814726c9ca473fff3ee4d" */
    _id?: string;
    /** @example "Tubesoft" */
    name: string;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    companies?: {
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @example "Empresa 123" */
      name: string;
      /** @example "12345678-9" */
      rut: string;
      /** @example "Empresa Cerezos" */
      businessName: string;
      /** @example "Chile" */
      country: string;
      /** @example "Region Metropolitana" */
      region: string;
      /** @example "Santiago" */
      commune: string;
      /** @example "123 Vespucio" */
      address: string;
      /** @example false */
      deleted: boolean;
      /**
       * @format date-time
       * @example "2023-03-07T19:43:46.303Z"
       */
      createdAt: string;
      /**
       * @format date-time
       * @example "2023-03-07T19:43:46.303Z"
       */
      updatedAt: string;
    }[];
    farms?: {
      /** @example "Campo Cerezos" */
      name: string;
      /** @example "Calle Ejemplo Exampl 123" */
      location: string;
      /** @example "100" */
      theoreticalSurface: string;
      center: {
        /** @example "-30.35161" */
        lat: string | number;
        /** @example "58.681618" */
        lng: string | number;
      };
      coordinates?: {
        /** @example "-30.35161" */
        lat: string;
        /** @example "58.681618" */
        lng: string;
      }[];
      /**
       * @format float
       * @example 18
       */
      zoom?: number;
      /** @example "669814726c9ca473fff3ee4d" */
      accountId?: string;
      sectors?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Sector 1" */
        name: string;
        /** @example "Drill and drop" */
        sectorDevice: string;
        /** @example "100" */
        theoreticalSurface: string;
        /** @example "669814726c9ca473fff3ee4d" */
        farm?: string;
        /** @example "5618131" */
        wiseconnId?: string;
        /** @example "1" */
        sectorNumber: string;
        variety?: {
          /** @example "Chandler" */
          name?: string;
          /** @example "Chandler" */
          species?: string;
        };
        /** @example "Loamy" */
        typeOfSoil: string;
        coordinates?: {
          /**
           * @format float
           * @example -25.12
           */
          lng: number;
          /**
           * @format float
           * @example 35.12
           */
          lat: number;
        }[];
        /** @example [] */
        subSectors?: any[];
        /** @example {} */
        graphConfig?: object;
        /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
        measures?: {
          wiseconn?: {
            /** @example ["1-80474"] */
            sectorMeasures?: string[];
            /** @example ["1-80475"] */
            weatherMeasures?: string[];
            /** @example ["1-80476"] */
            irrigationMeasures?: string[];
          };
        };
        /**
         * @format float
         * @example "2020"
         */
        plantingYear?: number;
        /** @example "Wiseconn" */
        telemetryType?: string;
      }[];
      devices?: {
        id?: string;
        type: string;
        brand: string;
        model: string;
        nodeId?: string | null;
        nodeType?: string | null;
      }[];
      /** @example "58" */
      wiseconnId?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @default false */
      deleted?: boolean;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      createdAt?: string;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      updatedAt?: string;
    }[];
  }[];
}

export interface UserSchema {
  /** @example "John" */
  name: string;
  /** @example "Doe" */
  lastname: string;
  /** @example "example@gmail.com" */
  email: string;
  /** @example "+56912345678" */
  phoneNumber?: string | null;
  /** @example "Interno" */
  type?: string | null;
  /** @example "user" */
  role: string;
  /** @example "ACME SA" */
  company?: string | null;
  /** @example "669814726c9ca473fff3ee4d" */
  id?: string;
  /** @example null */
  password?: string | null;
  /** @example null */
  resetPasswordToken?: string | null;
  /** @example false */
  active?: boolean;
  /** @example false */
  deleted?: boolean;
  /**
   * @format date-time
   * @example "2023-03-07T19:43:46.303Z"
   */
  createdAt?: string;
  /**
   * @format date-time
   * @example "2023-03-07T19:43:46.303Z"
   */
  updatedAt?: string;
  /** @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzg4MjMwMjYyOTgsImVtYWlsIjoiZXhlQGdtYWlsLmNvbSIsImlhdCI6MTY3ODIxODIyNn0.i95FbUjB5dysL1M8WJOtnRojiQrxsn1Mj7r57339qug" */
  userVerificationToken?: string;
  accounts?: {
    /** @example "669814726c9ca473fff3ee4d" */
    _id?: string;
    /** @example "Tubesoft" */
    name: string;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    companies?: {
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @example "Empresa 123" */
      name: string;
      /** @example "12345678-9" */
      rut: string;
      /** @example "Empresa Cerezos" */
      businessName: string;
      /** @example "Chile" */
      country: string;
      /** @example "Region Metropolitana" */
      region: string;
      /** @example "Santiago" */
      commune: string;
      /** @example "123 Vespucio" */
      address: string;
      /** @example false */
      deleted: boolean;
      /**
       * @format date-time
       * @example "2023-03-07T19:43:46.303Z"
       */
      createdAt: string;
      /**
       * @format date-time
       * @example "2023-03-07T19:43:46.303Z"
       */
      updatedAt: string;
    }[];
    farms?: {
      /** @example "Campo Cerezos" */
      name: string;
      /** @example "Calle Ejemplo Exampl 123" */
      location: string;
      /** @example "100" */
      theoreticalSurface: string;
      center: {
        /** @example "-30.35161" */
        lat: string | number;
        /** @example "58.681618" */
        lng: string | number;
      };
      coordinates?: {
        /** @example "-30.35161" */
        lat: string;
        /** @example "58.681618" */
        lng: string;
      }[];
      /**
       * @format float
       * @example 18
       */
      zoom?: number;
      /** @example "669814726c9ca473fff3ee4d" */
      accountId?: string;
      sectors?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Sector 1" */
        name: string;
        /** @example "Drill and drop" */
        sectorDevice: string;
        /** @example "100" */
        theoreticalSurface: string;
        /** @example "669814726c9ca473fff3ee4d" */
        farm?: string;
        /** @example "5618131" */
        wiseconnId?: string;
        /** @example "1" */
        sectorNumber: string;
        variety?: {
          /** @example "Chandler" */
          name?: string;
          /** @example "Chandler" */
          species?: string;
        };
        /** @example "Loamy" */
        typeOfSoil: string;
        coordinates?: {
          /**
           * @format float
           * @example -25.12
           */
          lng: number;
          /**
           * @format float
           * @example 35.12
           */
          lat: number;
        }[];
        /** @example [] */
        subSectors?: any[];
        /** @example {} */
        graphConfig?: object;
        /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
        measures?: {
          wiseconn?: {
            /** @example ["1-80474"] */
            sectorMeasures?: string[];
            /** @example ["1-80475"] */
            weatherMeasures?: string[];
            /** @example ["1-80476"] */
            irrigationMeasures?: string[];
          };
        };
        /**
         * @format float
         * @example "2020"
         */
        plantingYear?: number;
        /** @example "Wiseconn" */
        telemetryType?: string;
      }[];
      devices?: {
        id?: string;
        type: string;
        brand: string;
        model: string;
        nodeId?: string | null;
        nodeType?: string | null;
      }[];
      /** @example "58" */
      wiseconnId?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @default false */
      deleted?: boolean;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      createdAt?: string;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      updatedAt?: string;
    }[];
  }[];
  farms?: {
    /** @example "Campo Cerezos" */
    name: string;
    /** @example "Calle Ejemplo Exampl 123" */
    location: string;
    /** @example "100" */
    theoreticalSurface: string;
    center: {
      /** @example "-30.35161" */
      lat: string | number;
      /** @example "58.681618" */
      lng: string | number;
    };
    coordinates?: {
      /** @example "-30.35161" */
      lat: string;
      /** @example "58.681618" */
      lng: string;
    }[];
    /**
     * @format float
     * @example 18
     */
    zoom?: number;
    /** @example "669814726c9ca473fff3ee4d" */
    accountId?: string;
    sectors?: {
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @example "Sector 1" */
      name: string;
      /** @example "Drill and drop" */
      sectorDevice: string;
      /** @example "100" */
      theoreticalSurface: string;
      /** @example "669814726c9ca473fff3ee4d" */
      farm?: string;
      /** @example "5618131" */
      wiseconnId?: string;
      /** @example "1" */
      sectorNumber: string;
      variety?: {
        /** @example "Chandler" */
        name?: string;
        /** @example "Chandler" */
        species?: string;
      };
      /** @example "Loamy" */
      typeOfSoil: string;
      coordinates?: {
        /**
         * @format float
         * @example -25.12
         */
        lng: number;
        /**
         * @format float
         * @example 35.12
         */
        lat: number;
      }[];
      /** @example [] */
      subSectors?: any[];
      /** @example {} */
      graphConfig?: object;
      /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
      measures?: {
        wiseconn?: {
          /** @example ["1-80474"] */
          sectorMeasures?: string[];
          /** @example ["1-80475"] */
          weatherMeasures?: string[];
          /** @example ["1-80476"] */
          irrigationMeasures?: string[];
        };
      };
      /**
       * @format float
       * @example "2020"
       */
      plantingYear?: number;
      /** @example "Wiseconn" */
      telemetryType?: string;
    }[];
    devices?: {
      id?: string;
      type: string;
      brand: string;
      model: string;
      nodeId?: string | null;
      nodeType?: string | null;
    }[];
    /** @example "58" */
    wiseconnId?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @default false */
    deleted?: boolean;
    /**
     * @format date-time
     * @default "2023-03-07T19:43:46.303Z"
     */
    createdAt?: string;
    /**
     * @format date-time
     * @default "2023-03-07T19:43:46.303Z"
     */
    updatedAt?: string;
  }[];
}

export interface GetUsersPerPageSchema {
  /**
   * @format float
   * @example 10
   */
  limit?: number;
  /**
   * @format float
   * @example 0
   */
  page?: number;
  /** @example "" */
  searchValue?: string;
  /** @pattern (\|DESC\b|\|ASC\b) */
  sort?: string;
  /** @example "" */
  filterAccount?: string;
  /** @example "" */
  filterFarm?: string;
}

export interface GetUsersForAlertsSchema {
  /** @example "" */
  filterAccount?: string;
  /** @example "" */
  filterFarm?: string;
}

export interface GetUsersForAlertsResponse {
  /** @example true */
  success?: boolean;
  /** @example "Usuarios encontrados exitosamente" */
  message?: string;
  users?: Array<{
    /** @example "669814726c9ca473fff3ee4d" */
    id: string;
    /** @example "John" */
    name: string;
    /** @example "Doe" */
    lastname: string;
    /** @example "john.doe@example.com" */
    email: string;
    /** @example "+56912345678" */
    phoneNumber?: string;
  }>;
}

export interface UpdateUserSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id?: string;
  /** @example "María" */
  name?: string;
  /** @example "Rodríguez" */
  lastname?: string;
  /** @example true */
  active?: boolean;
  /** @example "admin" */
  role?: string;
}

export interface PostUserSchema {
  /** @example "John" */
  name: string;
  /** @example "Doe" */
  lastname: string;
  /** @example "example@gmail.com" */
  email: string;
  /** @example "+56912345678" */
  phoneNumber?: string | null;
  /** @example "Interno" */
  type?: string | null;
  /** @example "user" */
  role: string;
  /** @example "ACME SA" */
  company?: string | null;
  /** @example false */
  active?: boolean;
  accounts?: {
    accountId: string;
    farms?: string[];
    /** @example "Account 1" */
    name?: string;
  }[];
}

export interface UpdateUserResponse {
  /** @example true */
  success?: boolean;
  /** @example "Usuario editado exitosamente" */
  message?: string;
  editedUser?: {
    /** @example "John" */
    name: string;
    /** @example "Doe" */
    lastname: string;
    /** @example "example@gmail.com" */
    email: string;
    /** @example "+56912345678" */
    phoneNumber?: string | null;
    /** @example "Interno" */
    type?: string | null;
    /** @example "user" */
    role: string;
    /** @example "ACME SA" */
    company?: string | null;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example null */
    password?: string | null;
    /** @example null */
    resetPasswordToken?: string | null;
    /** @example false */
    active?: boolean;
    /** @example false */
    deleted?: boolean;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    createdAt?: string;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    updatedAt?: string;
    /** @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzg4MjMwMjYyOTgsImVtYWlsIjoiZXhlQGdtYWlsLmNvbSIsImlhdCI6MTY3ODIxODIyNn0.i95FbUjB5dysL1M8WJOtnRojiQrxsn1Mj7r57339qug" */
    userVerificationToken?: string;
    accounts?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id?: string;
      /** @example "Tubesoft" */
      name: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      companies?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Empresa 123" */
        name: string;
        /** @example "12345678-9" */
        rut: string;
        /** @example "Empresa Cerezos" */
        businessName: string;
        /** @example "Chile" */
        country: string;
        /** @example "Region Metropolitana" */
        region: string;
        /** @example "Santiago" */
        commune: string;
        /** @example "123 Vespucio" */
        address: string;
        /** @example false */
        deleted: boolean;
        /**
         * @format date-time
         * @example "2023-03-07T19:43:46.303Z"
         */
        createdAt: string;
        /**
         * @format date-time
         * @example "2023-03-07T19:43:46.303Z"
         */
        updatedAt: string;
      }[];
      farms?: {
        /** @example "Campo Cerezos" */
        name: string;
        /** @example "Calle Ejemplo Exampl 123" */
        location: string;
        /** @example "100" */
        theoreticalSurface: string;
        center: {
          /** @example "-30.35161" */
          lat: string | number;
          /** @example "58.681618" */
          lng: string | number;
        };
        coordinates?: {
          /** @example "-30.35161" */
          lat: string;
          /** @example "58.681618" */
          lng: string;
        }[];
        /**
         * @format float
         * @example 18
         */
        zoom?: number;
        /** @example "669814726c9ca473fff3ee4d" */
        accountId?: string;
        sectors?: {
          /** @example "669814726c9ca473fff3ee4d" */
          id?: string;
          /** @example "Sector 1" */
          name: string;
          /** @example "Drill and drop" */
          sectorDevice: string;
          /** @example "100" */
          theoreticalSurface: string;
          /** @example "669814726c9ca473fff3ee4d" */
          farm?: string;
          /** @example "5618131" */
          wiseconnId?: string;
          /** @example "1" */
          sectorNumber: string;
          variety?: {
            /** @example "Chandler" */
            name?: string;
            /** @example "Chandler" */
            species?: string;
          };
          /** @example "Loamy" */
          typeOfSoil: string;
          coordinates?: {
            /**
             * @format float
             * @example -25.12
             */
            lng: number;
            /**
             * @format float
             * @example 35.12
             */
            lat: number;
          }[];
          /** @example [] */
          subSectors?: any[];
          /** @example {} */
          graphConfig?: object;
          /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
          measures?: {
            wiseconn?: {
              /** @example ["1-80474"] */
              sectorMeasures?: string[];
              /** @example ["1-80475"] */
              weatherMeasures?: string[];
              /** @example ["1-80476"] */
              irrigationMeasures?: string[];
            };
          };
          /**
           * @format float
           * @example "2020"
           */
          plantingYear?: number;
          /** @example "Wiseconn" */
          telemetryType?: string;
        }[];
        devices?: {
          id?: string;
          type: string;
          brand: string;
          model: string;
          nodeId?: string | null;
          nodeType?: string | null;
        }[];
        /** @example "58" */
        wiseconnId?: string;
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @default false */
        deleted?: boolean;
        /**
         * @format date-time
         * @default "2023-03-07T19:43:46.303Z"
         */
        createdAt?: string;
        /**
         * @format date-time
         * @default "2023-03-07T19:43:46.303Z"
         */
        updatedAt?: string;
      }[];
    }[];
    farms?: {
      /** @example "Campo Cerezos" */
      name: string;
      /** @example "Calle Ejemplo Exampl 123" */
      location: string;
      /** @example "100" */
      theoreticalSurface: string;
      center: {
        /** @example "-30.35161" */
        lat: string | number;
        /** @example "58.681618" */
        lng: string | number;
      };
      coordinates?: {
        /** @example "-30.35161" */
        lat: string;
        /** @example "58.681618" */
        lng: string;
      }[];
      /**
       * @format float
       * @example 18
       */
      zoom?: number;
      /** @example "669814726c9ca473fff3ee4d" */
      accountId?: string;
      sectors?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Sector 1" */
        name: string;
        /** @example "Drill and drop" */
        sectorDevice: string;
        /** @example "100" */
        theoreticalSurface: string;
        /** @example "669814726c9ca473fff3ee4d" */
        farm?: string;
        /** @example "5618131" */
        wiseconnId?: string;
        /** @example "1" */
        sectorNumber: string;
        variety?: {
          /** @example "Chandler" */
          name?: string;
          /** @example "Chandler" */
          species?: string;
        };
        /** @example "Loamy" */
        typeOfSoil: string;
        coordinates?: {
          /**
           * @format float
           * @example -25.12
           */
          lng: number;
          /**
           * @format float
           * @example 35.12
           */
          lat: number;
        }[];
        /** @example [] */
        subSectors?: any[];
        /** @example {} */
        graphConfig?: object;
        /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
        measures?: {
          wiseconn?: {
            /** @example ["1-80474"] */
            sectorMeasures?: string[];
            /** @example ["1-80475"] */
            weatherMeasures?: string[];
            /** @example ["1-80476"] */
            irrigationMeasures?: string[];
          };
        };
        /**
         * @format float
         * @example "2020"
         */
        plantingYear?: number;
        /** @example "Wiseconn" */
        telemetryType?: string;
      }[];
      devices?: {
        id?: string;
        type: string;
        brand: string;
        model: string;
        nodeId?: string | null;
        nodeType?: string | null;
      }[];
      /** @example "58" */
      wiseconnId?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @default false */
      deleted?: boolean;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      createdAt?: string;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      updatedAt?: string;
    }[];
  };
}

export interface GetUsersPerPageResponse {
  /** @example true */
  success?: boolean;
  /** @example "Usuarios encontrados exitosamente" */
  message?: string;
  users?: {
    /** @example "John" */
    name: string;
    /** @example "Doe" */
    lastname: string;
    /** @example "example@gmail.com" */
    email: string;
    /** @example "+56912345678" */
    phoneNumber?: string | null;
    /** @example "Interno" */
    type?: string | null;
    /** @example "user" */
    role: string;
    /** @example "ACME SA" */
    company?: string | null;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example null */
    password?: string | null;
    /** @example null */
    resetPasswordToken?: string | null;
    /** @example false */
    active?: boolean;
    /** @example false */
    deleted?: boolean;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    createdAt?: string;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    updatedAt?: string;
    /** @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzg4MjMwMjYyOTgsImVtYWlsIjoiZXhlQGdtYWlsLmNvbSIsImlhdCI6MTY3ODIxODIyNn0.i95FbUjB5dysL1M8WJOtnRojiQrxsn1Mj7r57339qug" */
    userVerificationToken?: string;
    accounts?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id?: string;
      /** @example "Tubesoft" */
      name: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      companies?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Empresa 123" */
        name: string;
        /** @example "12345678-9" */
        rut: string;
        /** @example "Empresa Cerezos" */
        businessName: string;
        /** @example "Chile" */
        country: string;
        /** @example "Region Metropolitana" */
        region: string;
        /** @example "Santiago" */
        commune: string;
        /** @example "123 Vespucio" */
        address: string;
        /** @example false */
        deleted: boolean;
        /**
         * @format date-time
         * @example "2023-03-07T19:43:46.303Z"
         */
        createdAt: string;
        /**
         * @format date-time
         * @example "2023-03-07T19:43:46.303Z"
         */
        updatedAt: string;
      }[];
      farms?: {
        /** @example "Campo Cerezos" */
        name: string;
        /** @example "Calle Ejemplo Exampl 123" */
        location: string;
        /** @example "100" */
        theoreticalSurface: string;
        center: {
          /** @example "-30.35161" */
          lat: string | number;
          /** @example "58.681618" */
          lng: string | number;
        };
        coordinates?: {
          /** @example "-30.35161" */
          lat: string;
          /** @example "58.681618" */
          lng: string;
        }[];
        /**
         * @format float
         * @example 18
         */
        zoom?: number;
        /** @example "669814726c9ca473fff3ee4d" */
        accountId?: string;
        sectors?: {
          /** @example "669814726c9ca473fff3ee4d" */
          id?: string;
          /** @example "Sector 1" */
          name: string;
          /** @example "Drill and drop" */
          sectorDevice: string;
          /** @example "100" */
          theoreticalSurface: string;
          /** @example "669814726c9ca473fff3ee4d" */
          farm?: string;
          /** @example "5618131" */
          wiseconnId?: string;
          /** @example "1" */
          sectorNumber: string;
          variety?: {
            /** @example "Chandler" */
            name?: string;
            /** @example "Chandler" */
            species?: string;
          };
          /** @example "Loamy" */
          typeOfSoil: string;
          coordinates?: {
            /**
             * @format float
             * @example -25.12
             */
            lng: number;
            /**
             * @format float
             * @example 35.12
             */
            lat: number;
          }[];
          /** @example [] */
          subSectors?: any[];
          /** @example {} */
          graphConfig?: object;
          /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
          measures?: {
            wiseconn?: {
              /** @example ["1-80474"] */
              sectorMeasures?: string[];
              /** @example ["1-80475"] */
              weatherMeasures?: string[];
              /** @example ["1-80476"] */
              irrigationMeasures?: string[];
            };
          };
          /**
           * @format float
           * @example "2020"
           */
          plantingYear?: number;
          /** @example "Wiseconn" */
          telemetryType?: string;
        }[];
        devices?: {
          id?: string;
          type: string;
          brand: string;
          model: string;
          nodeId?: string | null;
          nodeType?: string | null;
        }[];
        /** @example "58" */
        wiseconnId?: string;
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @default false */
        deleted?: boolean;
        /**
         * @format date-time
         * @default "2023-03-07T19:43:46.303Z"
         */
        createdAt?: string;
        /**
         * @format date-time
         * @default "2023-03-07T19:43:46.303Z"
         */
        updatedAt?: string;
      }[];
    }[];
    farms?: {
      /** @example "Campo Cerezos" */
      name: string;
      /** @example "Calle Ejemplo Exampl 123" */
      location: string;
      /** @example "100" */
      theoreticalSurface: string;
      center: {
        /** @example "-30.35161" */
        lat: string | number;
        /** @example "58.681618" */
        lng: string | number;
      };
      coordinates?: {
        /** @example "-30.35161" */
        lat: string;
        /** @example "58.681618" */
        lng: string;
      }[];
      /**
       * @format float
       * @example 18
       */
      zoom?: number;
      /** @example "669814726c9ca473fff3ee4d" */
      accountId?: string;
      sectors?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Sector 1" */
        name: string;
        /** @example "Drill and drop" */
        sectorDevice: string;
        /** @example "100" */
        theoreticalSurface: string;
        /** @example "669814726c9ca473fff3ee4d" */
        farm?: string;
        /** @example "5618131" */
        wiseconnId?: string;
        /** @example "1" */
        sectorNumber: string;
        variety?: {
          /** @example "Chandler" */
          name?: string;
          /** @example "Chandler" */
          species?: string;
        };
        /** @example "Loamy" */
        typeOfSoil: string;
        coordinates?: {
          /**
           * @format float
           * @example -25.12
           */
          lng: number;
          /**
           * @format float
           * @example 35.12
           */
          lat: number;
        }[];
        /** @example [] */
        subSectors?: any[];
        /** @example {} */
        graphConfig?: object;
        /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
        measures?: {
          wiseconn?: {
            /** @example ["1-80474"] */
            sectorMeasures?: string[];
            /** @example ["1-80475"] */
            weatherMeasures?: string[];
            /** @example ["1-80476"] */
            irrigationMeasures?: string[];
          };
        };
        /**
         * @format float
         * @example "2020"
         */
        plantingYear?: number;
        /** @example "Wiseconn" */
        telemetryType?: string;
      }[];
      devices?: {
        id?: string;
        type: string;
        brand: string;
        model: string;
        nodeId?: string | null;
        nodeType?: string | null;
      }[];
      /** @example "58" */
      wiseconnId?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @default false */
      deleted?: boolean;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      createdAt?: string;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      updatedAt?: string;
    }[];
  }[];
  /** @example 1 */
  totalUsers?: number;
}

export interface DeleteUserResponse {
  /** @example true */
  success?: boolean;
  /** @example "Usuario/s eliminado/s exitosamente" */
  message?: string;
}

export interface GetUserResponse {
  /** @example true */
  success?: boolean;
  /** @example "Usuario encontrado" */
  message?: string;
  user?: {
    /** @example "John" */
    name: string;
    /** @example "Doe" */
    lastname: string;
    /** @example "example@gmail.com" */
    email: string;
    /** @example "+56912345678" */
    phoneNumber?: string | null;
    /** @example "Interno" */
    type?: string | null;
    /** @example "user" */
    role: string;
    /** @example "ACME SA" */
    company?: string | null;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example null */
    password?: string | null;
    /** @example null */
    resetPasswordToken?: string | null;
    /** @example false */
    active?: boolean;
    /** @example false */
    deleted?: boolean;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    createdAt?: string;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    updatedAt?: string;
    /** @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzg4MjMwMjYyOTgsImVtYWlsIjoiZXhlQGdtYWlsLmNvbSIsImlhdCI6MTY3ODIxODIyNn0.i95FbUjB5dysL1M8WJOtnRojiQrxsn1Mj7r57339qug" */
    userVerificationToken?: string;
    accounts?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id?: string;
      /** @example "Tubesoft" */
      name: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      companies?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Empresa 123" */
        name: string;
        /** @example "12345678-9" */
        rut: string;
        /** @example "Empresa Cerezos" */
        businessName: string;
        /** @example "Chile" */
        country: string;
        /** @example "Region Metropolitana" */
        region: string;
        /** @example "Santiago" */
        commune: string;
        /** @example "123 Vespucio" */
        address: string;
        /** @example false */
        deleted: boolean;
        /**
         * @format date-time
         * @example "2023-03-07T19:43:46.303Z"
         */
        createdAt: string;
        /**
         * @format date-time
         * @example "2023-03-07T19:43:46.303Z"
         */
        updatedAt: string;
      }[];
      farms?: {
        /** @example "Campo Cerezos" */
        name: string;
        /** @example "Calle Ejemplo Exampl 123" */
        location: string;
        /** @example "100" */
        theoreticalSurface: string;
        center: {
          /** @example "-30.35161" */
          lat: string | number;
          /** @example "58.681618" */
          lng: string | number;
        };
        coordinates?: {
          /** @example "-30.35161" */
          lat: string;
          /** @example "58.681618" */
          lng: string;
        }[];
        /**
         * @format float
         * @example 18
         */
        zoom?: number;
        /** @example "669814726c9ca473fff3ee4d" */
        accountId?: string;
        sectors?: {
          /** @example "669814726c9ca473fff3ee4d" */
          id?: string;
          /** @example "Sector 1" */
          name: string;
          /** @example "Drill and drop" */
          sectorDevice: string;
          /** @example "100" */
          theoreticalSurface: string;
          /** @example "669814726c9ca473fff3ee4d" */
          farm?: string;
          /** @example "5618131" */
          wiseconnId?: string;
          /** @example "1" */
          sectorNumber: string;
          variety?: {
            /** @example "Chandler" */
            name?: string;
            /** @example "Chandler" */
            species?: string;
          };
          /** @example "Loamy" */
          typeOfSoil: string;
          coordinates?: {
            /**
             * @format float
             * @example -25.12
             */
            lng: number;
            /**
             * @format float
             * @example 35.12
             */
            lat: number;
          }[];
          /** @example [] */
          subSectors?: any[];
          /** @example {} */
          graphConfig?: object;
          /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
          measures?: {
            wiseconn?: {
              /** @example ["1-80474"] */
              sectorMeasures?: string[];
              /** @example ["1-80475"] */
              weatherMeasures?: string[];
              /** @example ["1-80476"] */
              irrigationMeasures?: string[];
            };
          };
          /**
           * @format float
           * @example "2020"
           */
          plantingYear?: number;
          /** @example "Wiseconn" */
          telemetryType?: string;
        }[];
        devices?: {
          id?: string;
          type: string;
          brand: string;
          model: string;
          nodeId?: string | null;
          nodeType?: string | null;
        }[];
        /** @example "58" */
        wiseconnId?: string;
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @default false */
        deleted?: boolean;
        /**
         * @format date-time
         * @default "2023-03-07T19:43:46.303Z"
         */
        createdAt?: string;
        /**
         * @format date-time
         * @default "2023-03-07T19:43:46.303Z"
         */
        updatedAt?: string;
      }[];
    }[];
    farms?: {
      /** @example "Campo Cerezos" */
      name: string;
      /** @example "Calle Ejemplo Exampl 123" */
      location: string;
      /** @example "100" */
      theoreticalSurface: string;
      center: {
        /** @example "-30.35161" */
        lat: string | number;
        /** @example "58.681618" */
        lng: string | number;
      };
      coordinates?: {
        /** @example "-30.35161" */
        lat: string;
        /** @example "58.681618" */
        lng: string;
      }[];
      /**
       * @format float
       * @example 18
       */
      zoom?: number;
      /** @example "669814726c9ca473fff3ee4d" */
      accountId?: string;
      sectors?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Sector 1" */
        name: string;
        /** @example "Drill and drop" */
        sectorDevice: string;
        /** @example "100" */
        theoreticalSurface: string;
        /** @example "669814726c9ca473fff3ee4d" */
        farm?: string;
        /** @example "5618131" */
        wiseconnId?: string;
        /** @example "1" */
        sectorNumber: string;
        variety?: {
          /** @example "Chandler" */
          name?: string;
          /** @example "Chandler" */
          species?: string;
        };
        /** @example "Loamy" */
        typeOfSoil: string;
        coordinates?: {
          /**
           * @format float
           * @example -25.12
           */
          lng: number;
          /**
           * @format float
           * @example 35.12
           */
          lat: number;
        }[];
        /** @example [] */
        subSectors?: any[];
        /** @example {} */
        graphConfig?: object;
        /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
        measures?: {
          wiseconn?: {
            /** @example ["1-80474"] */
            sectorMeasures?: string[];
            /** @example ["1-80475"] */
            weatherMeasures?: string[];
            /** @example ["1-80476"] */
            irrigationMeasures?: string[];
          };
        };
        /**
         * @format float
         * @example "2020"
         */
        plantingYear?: number;
        /** @example "Wiseconn" */
        telemetryType?: string;
      }[];
      devices?: {
        id?: string;
        type: string;
        brand: string;
        model: string;
        nodeId?: string | null;
        nodeType?: string | null;
      }[];
      /** @example "58" */
      wiseconnId?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @default false */
      deleted?: boolean;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      createdAt?: string;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      updatedAt?: string;
    }[];
  };
}

export interface GetUsersByAccountResponse {
  /** @example true */
  success?: boolean;
  /** @example "Usuarios encontrados" */
  message?: string;
  users?: {
    /** @example "John" */
    name: string;
    /** @example "Doe" */
    lastname: string;
    /** @example "example@gmail.com" */
    email: string;
    /** @example "+56912345678" */
    phoneNumber?: string | null;
    /** @example "Interno" */
    type?: string | null;
    /** @example "user" */
    role: string;
    /** @example "ACME SA" */
    company?: string | null;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example null */
    password?: string | null;
    /** @example null */
    resetPasswordToken?: string | null;
    /** @example false */
    active?: boolean;
    /** @example false */
    deleted?: boolean;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    createdAt?: string;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    updatedAt?: string;
    /** @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzg4MjMwMjYyOTgsImVtYWlsIjoiZXhlQGdtYWlsLmNvbSIsImlhdCI6MTY3ODIxODIyNn0.i95FbUjB5dysL1M8WJOtnRojiQrxsn1Mj7r57339qug" */
    userVerificationToken?: string;
    accounts?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id?: string;
      /** @example "Tubesoft" */
      name: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      companies?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Empresa 123" */
        name: string;
        /** @example "12345678-9" */
        rut: string;
        /** @example "Empresa Cerezos" */
        businessName: string;
        /** @example "Chile" */
        country: string;
        /** @example "Region Metropolitana" */
        region: string;
        /** @example "Santiago" */
        commune: string;
        /** @example "123 Vespucio" */
        address: string;
        /** @example false */
        deleted: boolean;
        /**
         * @format date-time
         * @example "2023-03-07T19:43:46.303Z"
         */
        createdAt: string;
        /**
         * @format date-time
         * @example "2023-03-07T19:43:46.303Z"
         */
        updatedAt: string;
      }[];
      farms?: {
        /** @example "Campo Cerezos" */
        name: string;
        /** @example "Calle Ejemplo Exampl 123" */
        location: string;
        /** @example "100" */
        theoreticalSurface: string;
        center: {
          /** @example "-30.35161" */
          lat: string | number;
          /** @example "58.681618" */
          lng: string | number;
        };
        coordinates?: {
          /** @example "-30.35161" */
          lat: string;
          /** @example "58.681618" */
          lng: string;
        }[];
        /**
         * @format float
         * @example 18
         */
        zoom?: number;
        /** @example "669814726c9ca473fff3ee4d" */
        accountId?: string;
        sectors?: {
          /** @example "669814726c9ca473fff3ee4d" */
          id?: string;
          /** @example "Sector 1" */
          name: string;
          /** @example "Drill and drop" */
          sectorDevice: string;
          /** @example "100" */
          theoreticalSurface: string;
          /** @example "669814726c9ca473fff3ee4d" */
          farm?: string;
          /** @example "5618131" */
          wiseconnId?: string;
          /** @example "1" */
          sectorNumber: string;
          variety?: {
            /** @example "Chandler" */
            name?: string;
            /** @example "Chandler" */
            species?: string;
          };
          /** @example "Loamy" */
          typeOfSoil: string;
          coordinates?: {
            /**
             * @format float
             * @example -25.12
             */
            lng: number;
            /**
             * @format float
             * @example 35.12
             */
            lat: number;
          }[];
          /** @example [] */
          subSectors?: any[];
          /** @example {} */
          graphConfig?: object;
          /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
          measures?: {
            wiseconn?: {
              /** @example ["1-80474"] */
              sectorMeasures?: string[];
              /** @example ["1-80475"] */
              weatherMeasures?: string[];
              /** @example ["1-80476"] */
              irrigationMeasures?: string[];
            };
          };
          /**
           * @format float
           * @example "2020"
           */
          plantingYear?: number;
          /** @example "Wiseconn" */
          telemetryType?: string;
        }[];
        devices?: {
          id?: string;
          type: string;
          brand: string;
          model: string;
          nodeId?: string | null;
          nodeType?: string | null;
        }[];
        /** @example "58" */
        wiseconnId?: string;
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @default false */
        deleted?: boolean;
        /**
         * @format date-time
         * @default "2023-03-07T19:43:46.303Z"
         */
        createdAt?: string;
        /**
         * @format date-time
         * @default "2023-03-07T19:43:46.303Z"
         */
        updatedAt?: string;
      }[];
    }[];
    farms?: {
      /** @example "Campo Cerezos" */
      name: string;
      /** @example "Calle Ejemplo Exampl 123" */
      location: string;
      /** @example "100" */
      theoreticalSurface: string;
      center: {
        /** @example "-30.35161" */
        lat: string | number;
        /** @example "58.681618" */
        lng: string | number;
      };
      coordinates?: {
        /** @example "-30.35161" */
        lat: string;
        /** @example "58.681618" */
        lng: string;
      }[];
      /**
       * @format float
       * @example 18
       */
      zoom?: number;
      /** @example "669814726c9ca473fff3ee4d" */
      accountId?: string;
      sectors?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Sector 1" */
        name: string;
        /** @example "Drill and drop" */
        sectorDevice: string;
        /** @example "100" */
        theoreticalSurface: string;
        /** @example "669814726c9ca473fff3ee4d" */
        farm?: string;
        /** @example "5618131" */
        wiseconnId?: string;
        /** @example "1" */
        sectorNumber: string;
        variety?: {
          /** @example "Chandler" */
          name?: string;
          /** @example "Chandler" */
          species?: string;
        };
        /** @example "Loamy" */
        typeOfSoil: string;
        coordinates?: {
          /**
           * @format float
           * @example -25.12
           */
          lng: number;
          /**
           * @format float
           * @example 35.12
           */
          lat: number;
        }[];
        /** @example [] */
        subSectors?: any[];
        /** @example {} */
        graphConfig?: object;
        /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
        measures?: {
          wiseconn?: {
            /** @example ["1-80474"] */
            sectorMeasures?: string[];
            /** @example ["1-80475"] */
            weatherMeasures?: string[];
            /** @example ["1-80476"] */
            irrigationMeasures?: string[];
          };
        };
        /**
         * @format float
         * @example "2020"
         */
        plantingYear?: number;
        /** @example "Wiseconn" */
        telemetryType?: string;
      }[];
      devices?: {
        id?: string;
        type: string;
        brand: string;
        model: string;
        nodeId?: string | null;
        nodeType?: string | null;
      }[];
      /** @example "58" */
      wiseconnId?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @default false */
      deleted?: boolean;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      createdAt?: string;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      updatedAt?: string;
    }[];
  }[];
}

export interface PostUserResponse {
  /** @example true */
  success?: boolean;
  /** @example "Usuarios creado exitosamente" */
  message?: string;
}

export interface ResendVerificationResponse {
  /** @example true */
  success?: boolean;
  /** @example "Correo de invitación reenviado" */
  message?: string;
}

export interface RegisterRequest {
  /**
   * @minLength 3
   * @maxLength 255
   * @pattern ^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/
   * @example "example@gmail.com"
   */
  email: string;
  /**
   * @minLength 2
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9]
   * @example "María"
   */
  name: string;
  /**
   * @minLength 2
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9]
   * @example "Rodríguez"
   */
  lastname: string;
  /**
   * @pattern ^[a-zA-Z0-9]
   * @example null
   */
  password?: string | null;
  /** @example "admin" */
  role?: string;
}

export interface PutDeletedUserRequest {
  /**
   * @minLength 2
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9]
   * @example "María"
   */
  name: string;
  /**
   * @minLength 2
   * @maxLength 255
   * @pattern ^[a-zA-Z0-9]
   * @example "Rodríguez"
   */
  lastname: string;
  /** @example "admin" */
  role?: string;
}

export interface LoginRequest {
  /**
   * @minLength 3
   * @maxLength 255
   * @pattern ^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/
   * @example "example@gmail.com"
   */
  email: string;
  /**
   * @pattern ^[a-zA-Z0-9]
   * @example "password123"
   */
  password: string;
}

export interface VerificationRequest {
  /**
   * @minLength 8
   * @pattern ^[a-zA-Z0-9]
   * @example "password123"
   */
  password: string;
  /** @example "password123" */
  confirmPassword: any;
  /** @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzg4MjMwMjYyOTgsImVtYWlsIjoiZXhlQGdtYWlsLmNvbSIsImlhdCI6MTY3ODIxODIyNn0.i95FbUjB5dysL1M8WJOtnRojiQrxsn1Mj7r57339qug" */
  token: string;
}

export interface ResetPasswordRequest {
  /**
   * @minLength 8
   * @pattern ^[a-zA-Z0-9]
   * @example "password123"
   */
  password: string;
  /** @example "password123" */
  confirmPassword: any;
  /** @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzg4MjMwMjYyOTgsImVtYWlsIjoiZXhlQGdtYWlsLmNvbSIsImlhdCI6MTY3ODIxODIyNn0.i95FbUjB5dysL1M8WJOtnRojiQrxsn1Mj7r57339qug" */
  token: string;
}

export interface RecoverPasswordRequest {
  /**
   * Email de usuario
   * @format email
   * @minLength 3
   * @maxLength 255
   */
  email: string;
}

export interface RegisterResponse {
  /** @example true */
  success?: boolean;
  /** @example "Usuario creado con éxito" */
  message?: string;
  user?: {
    /** @example "John" */
    name: string;
    /** @example "Doe" */
    lastname: string;
    /** @example "example@gmail.com" */
    email: string;
    /** @example "+56912345678" */
    phoneNumber?: string | null;
    /** @example "Interno" */
    type?: string | null;
    /** @example "user" */
    role: string;
    /** @example "ACME SA" */
    company?: string | null;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example null */
    password?: string | null;
    /** @example null */
    resetPasswordToken?: string | null;
    /** @example false */
    active?: boolean;
    /** @example false */
    deleted?: boolean;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    createdAt?: string;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    updatedAt?: string;
    /** @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzg4MjMwMjYyOTgsImVtYWlsIjoiZXhlQGdtYWlsLmNvbSIsImlhdCI6MTY3ODIxODIyNn0.i95FbUjB5dysL1M8WJOtnRojiQrxsn1Mj7r57339qug" */
    userVerificationToken?: string;
    accounts?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id?: string;
      /** @example "Tubesoft" */
      name: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      companies?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Empresa 123" */
        name: string;
        /** @example "12345678-9" */
        rut: string;
        /** @example "Empresa Cerezos" */
        businessName: string;
        /** @example "Chile" */
        country: string;
        /** @example "Region Metropolitana" */
        region: string;
        /** @example "Santiago" */
        commune: string;
        /** @example "123 Vespucio" */
        address: string;
        /** @example false */
        deleted: boolean;
        /**
         * @format date-time
         * @example "2023-03-07T19:43:46.303Z"
         */
        createdAt: string;
        /**
         * @format date-time
         * @example "2023-03-07T19:43:46.303Z"
         */
        updatedAt: string;
      }[];
      farms?: {
        /** @example "Campo Cerezos" */
        name: string;
        /** @example "Calle Ejemplo Exampl 123" */
        location: string;
        /** @example "100" */
        theoreticalSurface: string;
        center: {
          /** @example "-30.35161" */
          lat: string | number;
          /** @example "58.681618" */
          lng: string | number;
        };
        coordinates?: {
          /** @example "-30.35161" */
          lat: string;
          /** @example "58.681618" */
          lng: string;
        }[];
        /**
         * @format float
         * @example 18
         */
        zoom?: number;
        /** @example "669814726c9ca473fff3ee4d" */
        accountId?: string;
        sectors?: {
          /** @example "669814726c9ca473fff3ee4d" */
          id?: string;
          /** @example "Sector 1" */
          name: string;
          /** @example "Drill and drop" */
          sectorDevice: string;
          /** @example "100" */
          theoreticalSurface: string;
          /** @example "669814726c9ca473fff3ee4d" */
          farm?: string;
          /** @example "5618131" */
          wiseconnId?: string;
          /** @example "1" */
          sectorNumber: string;
          variety?: {
            /** @example "Chandler" */
            name?: string;
            /** @example "Chandler" */
            species?: string;
          };
          /** @example "Loamy" */
          typeOfSoil: string;
          coordinates?: {
            /**
             * @format float
             * @example -25.12
             */
            lng: number;
            /**
             * @format float
             * @example 35.12
             */
            lat: number;
          }[];
          /** @example [] */
          subSectors?: any[];
          /** @example {} */
          graphConfig?: object;
          /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
          measures?: {
            wiseconn?: {
              /** @example ["1-80474"] */
              sectorMeasures?: string[];
              /** @example ["1-80475"] */
              weatherMeasures?: string[];
              /** @example ["1-80476"] */
              irrigationMeasures?: string[];
            };
          };
          /**
           * @format float
           * @example "2020"
           */
          plantingYear?: number;
          /** @example "Wiseconn" */
          telemetryType?: string;
        }[];
        devices?: {
          id?: string;
          type: string;
          brand: string;
          model: string;
          nodeId?: string | null;
          nodeType?: string | null;
        }[];
        /** @example "58" */
        wiseconnId?: string;
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @default false */
        deleted?: boolean;
        /**
         * @format date-time
         * @default "2023-03-07T19:43:46.303Z"
         */
        createdAt?: string;
        /**
         * @format date-time
         * @default "2023-03-07T19:43:46.303Z"
         */
        updatedAt?: string;
      }[];
    }[];
    farms?: {
      /** @example "Campo Cerezos" */
      name: string;
      /** @example "Calle Ejemplo Exampl 123" */
      location: string;
      /** @example "100" */
      theoreticalSurface: string;
      center: {
        /** @example "-30.35161" */
        lat: string | number;
        /** @example "58.681618" */
        lng: string | number;
      };
      coordinates?: {
        /** @example "-30.35161" */
        lat: string;
        /** @example "58.681618" */
        lng: string;
      }[];
      /**
       * @format float
       * @example 18
       */
      zoom?: number;
      /** @example "669814726c9ca473fff3ee4d" */
      accountId?: string;
      sectors?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Sector 1" */
        name: string;
        /** @example "Drill and drop" */
        sectorDevice: string;
        /** @example "100" */
        theoreticalSurface: string;
        /** @example "669814726c9ca473fff3ee4d" */
        farm?: string;
        /** @example "5618131" */
        wiseconnId?: string;
        /** @example "1" */
        sectorNumber: string;
        variety?: {
          /** @example "Chandler" */
          name?: string;
          /** @example "Chandler" */
          species?: string;
        };
        /** @example "Loamy" */
        typeOfSoil: string;
        coordinates?: {
          /**
           * @format float
           * @example -25.12
           */
          lng: number;
          /**
           * @format float
           * @example 35.12
           */
          lat: number;
        }[];
        /** @example [] */
        subSectors?: any[];
        /** @example {} */
        graphConfig?: object;
        /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
        measures?: {
          wiseconn?: {
            /** @example ["1-80474"] */
            sectorMeasures?: string[];
            /** @example ["1-80475"] */
            weatherMeasures?: string[];
            /** @example ["1-80476"] */
            irrigationMeasures?: string[];
          };
        };
        /**
         * @format float
         * @example "2020"
         */
        plantingYear?: number;
        /** @example "Wiseconn" */
        telemetryType?: string;
      }[];
      devices?: {
        id?: string;
        type: string;
        brand: string;
        model: string;
        nodeId?: string | null;
        nodeType?: string | null;
      }[];
      /** @example "58" */
      wiseconnId?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @default false */
      deleted?: boolean;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      createdAt?: string;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      updatedAt?: string;
    }[];
  };
}

export interface LoginResponse {
  /** @example true */
  success?: boolean;
  /** @example "Login exitoso" */
  message?: string;
  user?: {
    /** @example "John" */
    name: string;
    /** @example "Doe" */
    lastname: string;
    /** @example "example@gmail.com" */
    email: string;
    /** @example "+56912345678" */
    phoneNumber?: string | null;
    /** @example "Interno" */
    type?: string | null;
    /** @example "user" */
    role: string;
    /** @example "ACME SA" */
    company?: string | null;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example null */
    password?: string | null;
    /** @example null */
    resetPasswordToken?: string | null;
    /** @example false */
    active?: boolean;
    /** @example false */
    deleted?: boolean;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    createdAt?: string;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    updatedAt?: string;
    /** @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzg4MjMwMjYyOTgsImVtYWlsIjoiZXhlQGdtYWlsLmNvbSIsImlhdCI6MTY3ODIxODIyNn0.i95FbUjB5dysL1M8WJOtnRojiQrxsn1Mj7r57339qug" */
    userVerificationToken?: string;
    accounts?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id?: string;
      /** @example "Tubesoft" */
      name: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      companies?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Empresa 123" */
        name: string;
        /** @example "12345678-9" */
        rut: string;
        /** @example "Empresa Cerezos" */
        businessName: string;
        /** @example "Chile" */
        country: string;
        /** @example "Region Metropolitana" */
        region: string;
        /** @example "Santiago" */
        commune: string;
        /** @example "123 Vespucio" */
        address: string;
        /** @example false */
        deleted: boolean;
        /**
         * @format date-time
         * @example "2023-03-07T19:43:46.303Z"
         */
        createdAt: string;
        /**
         * @format date-time
         * @example "2023-03-07T19:43:46.303Z"
         */
        updatedAt: string;
      }[];
      farms?: {
        /** @example "Campo Cerezos" */
        name: string;
        /** @example "Calle Ejemplo Exampl 123" */
        location: string;
        /** @example "100" */
        theoreticalSurface: string;
        center: {
          /** @example "-30.35161" */
          lat: string | number;
          /** @example "58.681618" */
          lng: string | number;
        };
        coordinates?: {
          /** @example "-30.35161" */
          lat: string;
          /** @example "58.681618" */
          lng: string;
        }[];
        /**
         * @format float
         * @example 18
         */
        zoom?: number;
        /** @example "669814726c9ca473fff3ee4d" */
        accountId?: string;
        sectors?: {
          /** @example "669814726c9ca473fff3ee4d" */
          id?: string;
          /** @example "Sector 1" */
          name: string;
          /** @example "Drill and drop" */
          sectorDevice: string;
          /** @example "100" */
          theoreticalSurface: string;
          /** @example "669814726c9ca473fff3ee4d" */
          farm?: string;
          /** @example "5618131" */
          wiseconnId?: string;
          /** @example "1" */
          sectorNumber: string;
          variety?: {
            /** @example "Chandler" */
            name?: string;
            /** @example "Chandler" */
            species?: string;
          };
          /** @example "Loamy" */
          typeOfSoil: string;
          coordinates?: {
            /**
             * @format float
             * @example -25.12
             */
            lng: number;
            /**
             * @format float
             * @example 35.12
             */
            lat: number;
          }[];
          /** @example [] */
          subSectors?: any[];
          /** @example {} */
          graphConfig?: object;
          /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
          measures?: {
            wiseconn?: {
              /** @example ["1-80474"] */
              sectorMeasures?: string[];
              /** @example ["1-80475"] */
              weatherMeasures?: string[];
              /** @example ["1-80476"] */
              irrigationMeasures?: string[];
            };
          };
          /**
           * @format float
           * @example "2020"
           */
          plantingYear?: number;
          /** @example "Wiseconn" */
          telemetryType?: string;
        }[];
        devices?: {
          id?: string;
          type: string;
          brand: string;
          model: string;
          nodeId?: string | null;
          nodeType?: string | null;
        }[];
        /** @example "58" */
        wiseconnId?: string;
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @default false */
        deleted?: boolean;
        /**
         * @format date-time
         * @default "2023-03-07T19:43:46.303Z"
         */
        createdAt?: string;
        /**
         * @format date-time
         * @default "2023-03-07T19:43:46.303Z"
         */
        updatedAt?: string;
      }[];
    }[];
    farms?: {
      /** @example "Campo Cerezos" */
      name: string;
      /** @example "Calle Ejemplo Exampl 123" */
      location: string;
      /** @example "100" */
      theoreticalSurface: string;
      center: {
        /** @example "-30.35161" */
        lat: string | number;
        /** @example "58.681618" */
        lng: string | number;
      };
      coordinates?: {
        /** @example "-30.35161" */
        lat: string;
        /** @example "58.681618" */
        lng: string;
      }[];
      /**
       * @format float
       * @example 18
       */
      zoom?: number;
      /** @example "669814726c9ca473fff3ee4d" */
      accountId?: string;
      sectors?: {
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "Sector 1" */
        name: string;
        /** @example "Drill and drop" */
        sectorDevice: string;
        /** @example "100" */
        theoreticalSurface: string;
        /** @example "669814726c9ca473fff3ee4d" */
        farm?: string;
        /** @example "5618131" */
        wiseconnId?: string;
        /** @example "1" */
        sectorNumber: string;
        variety?: {
          /** @example "Chandler" */
          name?: string;
          /** @example "Chandler" */
          species?: string;
        };
        /** @example "Loamy" */
        typeOfSoil: string;
        coordinates?: {
          /**
           * @format float
           * @example -25.12
           */
          lng: number;
          /**
           * @format float
           * @example 35.12
           */
          lat: number;
        }[];
        /** @example [] */
        subSectors?: any[];
        /** @example {} */
        graphConfig?: object;
        /** @example {"wiseconn":{"sectorMeasures":["1-80474"],"weatherMeasures":["1-80475"],"irrigationMeasures":["1-80476"]}} */
        measures?: {
          wiseconn?: {
            /** @example ["1-80474"] */
            sectorMeasures?: string[];
            /** @example ["1-80475"] */
            weatherMeasures?: string[];
            /** @example ["1-80476"] */
            irrigationMeasures?: string[];
          };
        };
        /**
         * @format float
         * @example "2020"
         */
        plantingYear?: number;
        /** @example "Wiseconn" */
        telemetryType?: string;
      }[];
      devices?: {
        id?: string;
        type: string;
        brand: string;
        model: string;
        nodeId?: string | null;
        nodeType?: string | null;
      }[];
      /** @example "58" */
      wiseconnId?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @default false */
      deleted?: boolean;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      createdAt?: string;
      /**
       * @format date-time
       * @default "2023-03-07T19:43:46.303Z"
       */
      updatedAt?: string;
    }[];
  };
  /** @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzg4MjMwMjYyOTgsImVtYWlsIjoiZXhlQGdtYWlsLmNvbSIsImlhdCI6MTY3ODIxODIyNn0.i95FbUjB5dysL1M8WJOtnRojiQrxsn1Mj7r57339qug" */
  token?: string;
}

export interface ErrorResponse {
  /** @example true */
  success?: boolean;
  /** @example "Login fallido" */
  message?: string;
  /** @example "Error en el servidor" */
  errorMessage?: string;
}

export interface VerificationResponse {
  /** @example true */
  success?: boolean;
  /** @example "Usuario verificado correctamente" */
  message?: string;
}

export interface ResetPasswordResponse {
  /** @example true */
  success?: boolean;
  /** @example "Contraseña actualizada" */
  message?: string;
}

export interface RecoverPasswordResponse {
  /** @example true */
  success?: boolean;
  /** @example "Correo de recuperar contraseña enviado" */
  message?: string;
}

export interface VarietySchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id?: string;
  /** @example "Maiz dulce" */
  name: string;
  /**
   * Nombre populado desde Species (read-only)
   * @example "Maiz"
   */
  species?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  speciesId?: string;
  phenologicalStates?: {
    name: string;
    /** @format date-time */
    startDate: string;
    /** @format date-time */
    endDate: string;
    /** @example 0.3 */
    kcMin?: number;
    /** @example 1.2 */
    kcMax?: number;
  }[];
}

export interface PostVarietySchema {
  /** @example "Maiz dulce" */
  name: string;
  /** @example "669814726c9ca473fff3ee4d" */
  speciesId: string;
  phenologicalStates?: {
    name: string;
    /** @format date-time */
    startDate: string;
    /** @format date-time */
    endDate: string;
    /** @example 0.3 */
    kcMin?: number;
    /** @example 1.2 */
    kcMax?: number;
  }[];
}

export interface PutVarietySchema {
  /** @example "Maiz dulce" */
  name: string;
  /** @example "669814726c9ca473fff3ee4d" */
  speciesId: string;
  phenologicalStates?: {
    name: string;
    /** @format date-time */
    startDate: string;
    /** @format date-time */
    endDate: string;
    /** @example 0.3 */
    kcMin?: number;
    /** @example 1.2 */
    kcMax?: number;
  }[];
}

export interface DeleteVarietySchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id: string;
}

export interface GetVarietiesPerPageResponse {
  /** @example true */
  success?: boolean;
  /** @example "Variedades encontradas exitosamente" */
  message?: string;
  varieties?: VarietySchema[];
  /** @example 1 */
  totalVarieties?: number;
}

export interface PostVarietyResponse {
  /** @example true */
  success?: boolean;
  /** @example "Variedad creada exitosamente" */
  message?: string;
}

export interface PutVarietyResponse {
  /** @example true */
  success?: boolean;
  /** @example "Variedad editada exitosamente" */
  message?: string;
}

export interface GetVarietyByIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Variedad encontrada exitosamente" */
  message?: string;
  variety?: VarietySchema;
}

export interface DeleteVarietyResponse {
  /** @example true */
  success?: boolean;
  /** @example "Variedad eliminada exitosamente" */
  message?: string;
}

export interface GetSpeciesResponse {
  /** @example true */
  success?: boolean;
  /** @example "Especies encontradas exitosamente" */
  message?: string;
  species?: {
    id?: string;
    name?: string;
  }[];
  /** @example 1 */
  totalSpecies?: number;
}

export interface PostSpeciesSchema {
  /** @example "Maiz" */
  name: string;
}

export interface PutSpeciesSchema {
  /** @example "Maiz" */
  name: string;
}

export interface DeleteSpeciesSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id: string;
}

export interface PostSpeciesResponse {
  /** @example true */
  success?: boolean;
  /** @example "Especie creada exitosamente" */
  message?: string;
}

export interface PutSpeciesResponse {
  /** @example true */
  success?: boolean;
  /** @example "Especie editada exitosamente" */
  message?: string;
}

export interface DeleteSpeciesResponse {
  /** @example true */
  success?: boolean;
  /** @example "Especie eliminada exitosamente" */
  message?: string;
}

export interface GetSpeciesVarietiesCountResponse {
  /** @example true */
  success?: boolean;
  /** @example "Conteo de variedades obtenido exitosamente" */
  message?: string;
  /** @example 3 */
  count?: number;
}

export interface GetSectorResumeDataResponse {
  /** @example true */
  success?: boolean;
  /** @example "Datos de resumen del sector encontrados exitosamente" */
  message?: string;
  sectorResumeData?: {
    /** @example "66cbf41852c77781afe27220" */
    id: string;
    phenologicalStatesNames: string[];
    irrigationAccumulatedResult: number;
    rainAccumulatedResult: number;
    et0AccumulatedResult: number;
    kcIrrigation: number;
    irrigationPerDay: number;
  };
}

export interface PostCultivationCycleSchema {
  /** @example "Primer cultivo" */
  name: string;
  /**
   * @format date-time
   * @example "2024-03-01"
   */
  startDate: string;
  /**
   * @format date-time
   * @example "2024-04-01"
   */
  endDate: string;
  /** @example "66cbf41852c77781afe27220" */
  sectorId: string;
  /** @example "66cbf41852c77781afe27220" */
  varietyId: string;
  /** @example true */
  useDefaultPhenologicalStates: boolean;
  producedKg?: number;
  exportablePercentage?: number;
  productionQuality?: number;
}

export interface CultivationCyclePopulatedSchema {
  /** @example "66cbf41852c77781afe27220" */
  id: string;
  /** @example "Primer cultivo" */
  name: string;
  /** @example [{"name":"Germinación","startDate":"2024-03-01","endDate":"2024-03-15"},{"name":"Floración","startDate":"2024-04-01","endDate":"2024-04-20"}] */
  variety: {
    /** @example "Howard" */
    name: string;
    /** @example "Nogal" */
    species: string;
  };
  /**
   * @format date-time
   * @example "2024-03-01"
   */
  startDate: string;
  /**
   * @format date-time
   * @example "2024-04-01"
   */
  endDate: string;
  phenologicalStates?: PhenologicalStateWithId[];
  producedKg?: number;
  exportablePercentage?: number;
  productionQuality?: number;
}

export interface PutPhenologicalStateSchema {
  /** @example "Germinación" */
  name: string;
  /**
   * @format date-time
   * @example "2024-03-01"
   */
  startDate: string;
  /**
   * @format date-time
   * @example "2024-03-01"
   */
  endDate: string;
}

export interface UpdateCultivationCycleSchema {
  /** @example "66cbf41852c77781afe27220" */
  id: string;
  /** @example "Primer cultivo" */
  name?: string;
  /**
   * @format date-time
   * @example "2024-03-01"
   */
  startDate?: string;
  /**
   * @format date-time
   * @example "2024-04-01"
   */
  endDate?: string;
  /** @example "66cbf41852c77781afe27220" */
  varietyId?: string;
  /** @example true */
  useDefaultPhenologicalStates: boolean;
  producedKg?: number;
  exportablePercentage?: number;
  productionQuality?: number;
}

export interface PostCultivationCycleResponse {
  /** @example true */
  success?: boolean;
  /** @example "Ciclo de cultivo creado exitosamente" */
  message?: string;
  cultivationCycle?: {
    cultivationCycle?: {
      /** @example "66cbf41852c77781afe27220" */
      id: string;
      /** @example "Primer cultivo" */
      name: string;
      /** @example [{"name":"Germinación","startDate":"2024-03-01","endDate":"2024-03-15"},{"name":"Floración","startDate":"2024-04-01","endDate":"2024-04-20"}] */
      phenologicalStates: {
        /** @example "Germinación" */
        name: string;
        /**
        * @format date-time
        * @example "2024-03-01"
        */
        startDate: string;
        /**
        * @format date-time
        * @example "2024-03-01"
        */
        endDate: string;
      }[];
      /** @example "66cbf41852c77781afe27220" */
      variety: string;
      /** @example "66cbf41852c77781afe27220" */
      sector: string;
      /**
      * @format date-time
      * @example "2024-03-01"
      */
      startDate: string;
      /**
      * @format date-time
      * @example "2024-04-01"
      */
      endDate: string;
      producedKg?: number;
      exportablePercentage?: number;
      productionQuality?: number;
    };
    phenologicalStates: PhenologicalStateWithId[];
  }
}

export interface GetCultivationCyclesBySectorResponse {
  /** @example true */
  success?: boolean;
  /** @example "Obtenidos ciclos de cultivo" */
  message?: string;
  cultivationCycles: CultivationCyclePopulatedSchema[];
}

export interface DeleteCultivationCycleResponse {
  /** @example true */
  success?: boolean;
  /** @example "Ciclo de cultivo eliminado" */
  message?: string;
}


export interface UpdateCultivationCycleResponse {
  /** @example true */
  success?: boolean;
  /** @example "Agregado estado fenológico" */
  message?: string;
  updatedCycle?: {
    cultivationCycle: {

      /** @example "66cbf41852c77781afe27220" */
      id: string;
      /** @example "Primer cultivo" */
      name: string;
      /** @example [{"name":"Germinación","startDate":"2024-03-01","endDate":"2024-03-15"},{"name":"Floración","startDate":"2024-04-01","endDate":"2024-04-20"}] */
      phenologicalStates: {
        /** @example "Germinación" */
        name: string;
        /**
        * @format date-time
        * @example "2024-03-01"
        */
        startDate: string;
        /**
        * @format date-time
        * @example "2024-03-01"
        */
        endDate: string;
      }[];
      /** @example "66cbf41852c777781afe27220" */
      variety: string;
      /** @example "66cbf41852c77781afe27220" */
      sector: string;
      /**
      * @format date-time
      * @example "2024-03-01"
      */
      startDate: string;
      /**
      * @format date-time
      * @example "2024-04-01"
      */
      endDate: string;
      producedKg?: number;
      exportablePercentage?: number;
      productionQuality?: number;
    };
    phenologicalStates: PhenologicalStateWithId[];
  }
}

export interface PostPhenologicalStateResponse {
  /** @example true */
  success?: boolean;
  /** @example "Estado fenológico creado exitosamente" */
  message?: string;
  phenologicalState: PhenologicalStateWithId;
}

export interface GetPhenologicalStatesResponse {
  /** @example true */
  success?: boolean;
  /** @example "Estado fenológico encontrado exitosamente" */
  message?: string;
  phenologicalStates: PhenologicalStateWithCycle[];
}

export interface UpdatePhenologicalStateLineResponse {
  /** @example true */
  success?: boolean;
  /** @example "Estado fenológico encontrado exitosamente" */
  message?: string;
  updatedState?: PhenologicalStateWithId;
}

export interface PhenologicalStateSectorResponse {
  message?: string;
  success?: boolean;
  phenologicalStates: PhenologicalStateWithCycle;
}
export interface PhenologicalStateWithCycle {
  [cycle: string]: PhenologicalStateWithId[];
}

export interface PhenologicalStateSchema {
  name: string;
  cycle: string;
  sector: string;
  startDate: string;
  endDate: string;
  /** @example 0.3 */
  kcMin?: number;
  /** @example 1.2 */
  kcMax?: number;
  lines?: CriticalPoint[];
}

export interface PhenologicalStateWithId extends PhenologicalStateSchema {
  id: string;
  phenologicalStateNameId?: string;
}

export interface PostPhenologicalStateSchema extends PhenologicalStateSchema { }

export interface DeletePhenologicalStateSchema {
  phenologicalStateNameId: string;
  sector: string;
  cycle: string;
}

export interface DeletePhenologicalStateResponse {
  /** @example true */
  success?: boolean;
  /** @example "Estado fenológico eliminado" */
  message?: string;
}

export interface UploadImageToStorageSchema {
  /** @example "1" */
  deviceId: string;
}

export interface GetGoogleStorageImagesResponse {
  /** @example true */
  success?: boolean;
  /** @example "Equipo encontrado exitosamente" */
  message?: string;
  images: {
    /** @example "https://storage.googleapis.com/devices-images-storage/1/image.jpg" */
    url?: string;
    /** @example "image.jpg" */
    fileName?: string;
    /** @example "1" */
    deviceId?: string;
  }[];
}

export interface UploadImageToStorageResponse {
  /** @example true */
  success?: boolean;
  /** @example "Imagen subida exitosamente" */
  message?: string;
  /** @example "https://storage.googleapis.com/devices-images-storage/1/image.jpg" */
  url?: string;
}

export interface DeleteImageFromStorageResponse {
  /** @example true */
  success?: boolean;
  /** @example "Imagen eliminada exitosamente" */
  message?: string;
}

export interface WorkOrderSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id?: string;
  /** @example "123456" */
  name?: string;
  /**
   * @format date-time
   * @example "2024-08-08T12:00:00.000Z"
   */
  softlandCreationDate?: string;
  /** @example "p" */
  status?: string;
  dispatchGuides?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "123456" */
    name?: string;
    /**
     * @format date-time
     * @example "2024-08-08T12:00:00.000Z"
     */
    dGuideSoftLandCreationDate?: string;
    /** @example "s" */
    type?: string;
    devices?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id: string;
      deviceModel?: {
        /** @example "669814726c9ca473fff3ee4d" */
        _id: string;
        /** @example "669814726c9ca473fff3ee4d" */
        id: string;
        name: string;
        model?: string;
        group?: string;
        subGroup?: string;
        codProd?: string;
        /** @default false */
        deleted: boolean;
        /** @example "135654" */
        cdtecDeviceId?: string;
        /** @example "Sentek" */
        brand?: string;
      };
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @example "node" */
      deviceType: string;
      /** @example "1351-545-548-DP2564" */
      uniqueSoftlandId: string;
      /** @example "DP50256" */
      serie?: string;
      nodeId?:
      | string
      | {
        _id: string;
        deviceModel: {
          /** @example "669814726c9ca473fff3ee4d" */
          _id: string;
          /** @example "669814726c9ca473fff3ee4d" */
          id: string;
          name: string;
          model?: string;
          group?: string;
          subGroup?: string;
          codProd?: string;
          /** @default false */
          deleted: boolean;
          /** @example "135654" */
          cdtecDeviceId?: string;
          /** @example "Sentek" */
          brand?: string;
        };
      };
      /** @example "suelo" */
      sensorType?: string;
      /** @example true */
      isGatewayNode?: boolean;
      nodeChip?: string;
      /** @example "123456" */
      deviceId: string;
      /** @example "2024-05-01T00:00:00.000Z" */
      createdAt: string;
      /** @example "2024-05-01T00:00:00.000Z" */
      updatedAt: string;
      /** @example "active" */
      status: string;
      /** @example false */
      deleted: boolean;
      /** @example "Nuevo sensor" */
      comment?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      farm: string;
      /** @example "669814726c9ca473fff3ee4d" */
      sector?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      subSector?: string;
      coordinates?: {
        /**
         * @format float
         * @example -25.12
         */
        lng: number;
        /**
         * @format float
         * @example 35.12
         */
        lat: number;
      };
    }[];
  }[];
}

export interface GetDispatchGuidesByAccountIdSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  accountId?: string;
}

export interface GetWorkOrdersPerPageSchema {
  /** @example "10" */
  limit?: string;
  /** @example "0" */
  page?: string;
  /** @example "" */
  searchValue?: string;
  /** @pattern (\|DESC\b|\|ASC\b) */
  sort?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  accountId?: string;
}

export interface PutWorkOrdersFromSoftlandSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  accountId?: string;
}

export interface GetWorkOrdersPerPageResponse {
  /** @example true */
  success?: boolean;
  /** @example "Ordenes de trabajo encontradas exitosamente" */
  message?: string;
  workOrders?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "123456" */
    name?: string;
    /**
     * @format date-time
     * @example "2024-08-08T12:00:00.000Z"
     */
    softlandCreationDate?: string;
    /** @example "p" */
    status?: string;
    dispatchGuides?: {
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @example "123456" */
      name?: string;
      /**
       * @format date-time
       * @example "2024-08-08T12:00:00.000Z"
       */
      dGuideSoftLandCreationDate?: string;
      /** @example "s" */
      type?: string;
      devices?: {
        /** @example "669814726c9ca473fff3ee4d" */
        _id: string;
        deviceModel?: {
          /** @example "669814726c9ca473fff3ee4d" */
          _id: string;
          /** @example "669814726c9ca473fff3ee4d" */
          id: string;
          name: string;
          model?: string;
          group?: string;
          subGroup?: string;
          codProd?: string;
          /** @default false */
          deleted: boolean;
          /** @example "135654" */
          cdtecDeviceId?: string;
          /** @example "Sentek" */
          brand?: string;
        };
        /** @example "669814726c9ca473fff3ee4d" */
        id?: string;
        /** @example "node" */
        deviceType: string;
        /** @example "1351-545-548-DP2564" */
        uniqueSoftlandId: string;
        /** @example "DP50256" */
        serie?: string;
        nodeId?:
        | string
        | {
          _id: string;
          deviceModel: {
            /** @example "669814726c9ca473fff3ee4d" */
            _id: string;
            /** @example "669814726c9ca473fff3ee4d" */
            id: string;
            name: string;
            model?: string;
            group?: string;
            subGroup?: string;
            codProd?: string;
            /** @default false */
            deleted: boolean;
            /** @example "135654" */
            cdtecDeviceId?: string;
            /** @example "Sentek" */
            brand?: string;
          };
        };
        /** @example "suelo" */
        sensorType?: string;
        /** @example true */
        isGatewayNode?: boolean;
        nodeChip?: string;
        /** @example "123456" */
        deviceId: string;
        /** @example "2024-05-01T00:00:00.000Z" */
        createdAt: string;
        /** @example "2024-05-01T00:00:00.000Z" */
        updatedAt: string;
        /** @example "active" */
        status: string;
        /** @example false */
        deleted: boolean;
        /** @example "Nuevo sensor" */
        comment?: string;
        /** @example "669814726c9ca473fff3ee4d" */
        farm: string;
        /** @example "669814726c9ca473fff3ee4d" */
        sector?: string;
        /** @example "669814726c9ca473fff3ee4d" */
        subSector?: string;
        coordinates?: {
          /**
           * @format float
           * @example -25.12
           */
          lng: number;
          /**
           * @format float
           * @example 35.12
           */
          lat: number;
        };
      }[];
    }[];
  }[];
  /** @example 1 */
  totalWorkOrders?: number;
}

export interface GetDispatchGuidesByAccountIdResponse {
  /** @example true */
  success?: boolean;
  /** @example "Ordenes de encontradas exitosamente" */
  message?: string;
  dispatchGuides?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "123456" */
    name?: string;
    /**
     * @format date-time
     * @example "2024-08-08T12:00:00.000Z"
     */
    dGuideSoftLandCreationDate?: string;
    /** @example "s" */
    type?: string;
    devices?: {
      /** @example "669814726c9ca473fff3ee4d" */
      _id: string;
      deviceModel?: {
        /** @example "669814726c9ca473fff3ee4d" */
        _id: string;
        /** @example "669814726c9ca473fff3ee4d" */
        id: string;
        name: string;
        model?: string;
        group?: string;
        subGroup?: string;
        codProd?: string;
        /** @default false */
        deleted: boolean;
        /** @example "135654" */
        cdtecDeviceId?: string;
        /** @example "Sentek" */
        brand?: string;
      };
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
      /** @example "node" */
      deviceType: string;
      /** @example "1351-545-548-DP2564" */
      uniqueSoftlandId: string;
      /** @example "DP50256" */
      serie?: string;
      nodeId?:
      | string
      | {
        _id: string;
        deviceModel: {
          /** @example "669814726c9ca473fff3ee4d" */
          _id: string;
          /** @example "669814726c9ca473fff3ee4d" */
          id: string;
          name: string;
          model?: string;
          group?: string;
          subGroup?: string;
          codProd?: string;
          /** @default false */
          deleted: boolean;
          /** @example "135654" */
          cdtecDeviceId?: string;
          /** @example "Sentek" */
          brand?: string;
        };
      };
      /** @example "suelo" */
      sensorType?: string;
      /** @example true */
      isGatewayNode?: boolean;
      nodeChip?: string;
      /** @example "123456" */
      deviceId: string;
      /** @example "2024-05-01T00:00:00.000Z" */
      createdAt: string;
      /** @example "2024-05-01T00:00:00.000Z" */
      updatedAt: string;
      /** @example "active" */
      status: string;
      /** @example false */
      deleted: boolean;
      /** @example "Nuevo sensor" */
      comment?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      farm: string;
      /** @example "669814726c9ca473fff3ee4d" */
      sector?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      subSector?: string;
      coordinates?: {
        /**
         * @format float
         * @example -25.12
         */
        lng: number;
        /**
         * @format float
         * @example 35.12
         */
        lat: number;
      };
    }[];
  }[];
}

export interface GetNodeIdsListResponse {
  /** @example true */
  success?: boolean;
  /** @example "NodeIds de todos los campos obtenidos con éxito" */
  message?: string;
  farm?: {
    farmId: string;
    farmName: string;
    nodeId: {
      batteryLevelId: string[];
      rfPowerId: string[];
      currentId: string[];
    };
  };
}

export interface PutWorkOrdersFromSoftlandResponse {
  /** @example true */
  success?: boolean;
  /** @example "Ordenes de trabajo actualizadas exitosamente" */
  message?: string;
}

export interface ReadingSchema {
  /** @example "2024-01-10T15:15:00.000Z_3-11440" */
  _id: string;
  /** @example "669814726c9ca473fff3ee4d" */
  sectorId: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farmId: string;
  /** @example "1234567890" */
  wiseconnId: string;
  /** @example "1234567890" */
  wiseconnZoneId?: string;
  /** @example "m3" */
  unit: string;
  /** @example "1234567890" */
  value: string;
  /**
   * @format date-time
   * @example "2023-03-07T19:43:46.303Z"
   */
  dateTime: string;
  /** @example "1234567890" */
  sensorDepth?: string;
  /** @example "m" */
  depthUnit?: string;
  /** @example "Temperature" */
  sensorType?: string;
  /** @example "Irrigation Precipitation" */
  name?: string;
}

export interface GetStackedSoilMoistureDataResponse {
  /** @example true */
  success?: boolean;
  /** @example "Datos de humedad suelo obtenidos" */
  message?: string;
  seriesData: {
    series: {
      type: string;
      name: string;
      data: number[];
    }[];
    absoluteCategories: string[];
  }
}

export interface GetET0DataResponse {
  /** @example true */
  success?: boolean;
  /** @example "Datos de humedad suelo obtenidos" */
  message?: string;
  et0: {
    [key: string]: {
      cumulativeET0: number;
      et0: number;
    };
  }
  length: number;
}

export interface getKcDataResponse {
  /** @example true */
  success?: boolean;
  /** @example "Datos de humedad suelo obtenidos" */
  message?: string;
  kcData: {
    date: string;
    kc: number;
  }[];
  accumulatedEt0ForKc: any;
  normalizedIrrigation: any;
  normalizedEt0: any;
  length: number;
}

export interface getBiweeklyReportSummaryResponse {
  /** @example true */
  success?: boolean;
  /** @example "Datos de resumen obtenidos exitosamente" */
  message?: string;
  summaryData: {
    /** @example 45.5 */
    irrigationSum: number;
    /** @example 12.3 */
    rainfallSum: number;
    /** @example 23.7 */
    et0Sum: number;
    /** @example 1.85 */
    kcSum: number;
  };
}
export interface GetSoilMoistureDataResponse {
  /** @example true */
  success?: boolean;
  /** @example "Datos de humedad suelo obtenidos" */
  message?: string;
  summedSeries: number[];
  min: number;
  max: number;
  absoluteCategories: string[];
}

export interface GetPlantsDataResponse {
  /** @example true */
  success?: boolean;
  /** @example "Datos de humedad suelo obtenidos" */
  message?: string;
  series: {
    type: string;
    name: string;
    data: number[];
  }[];
  absoluteCategories: string[];
}

export interface GetReadingsResponse {
  /** @example true */
  success?: boolean;
  /** @example "Readings encontradas exitosamente" */
  message?: string;
  readings?: {
    /**
     * @format float
     * @example 1
     */
    count: number;
    /** @example "2024-11-14" */
    date: string;
    /** @example "Rain" */
    sensorType: string;
    /** @example "00:00" */
    hour?: string;
    /** @example "W1" */
    week?: string;
    /** @example "D1" */
    day?: string;
    /**
     * @format float
     * @example 0
     */
    averageValue: number;
    /**
     * @format float
     * @example 0
     */
    minValue: number;
    /**
     * @format float
     * @example 0
     */
    maxValue: number;
    /** @example "m3" */
    unit: string;
    /** @example "20" */
    sensorDepth?: string;
    /** @example "m" */
    depthUnit?: string;
  }[];
}

export interface PostSectorRainfallConfigSchema {
  /**
   * @format date-time
   * @example "2024-01-01"
   */
  rainfallStartMonth?: number;
  rainfallStartDay?: number;
  rainfallEndMonth?: number;
  rainfallEndDay?: number;
}

export interface PostSectorPlantsConfigSchema {
  /**
   * @format date-time
   * @example "2024-01-01"
   */
  accumulateFrom?: string;
}

export interface PostSectorEt0ConfigSchema {
  /**
   * @format date-time
   * @example "2024-01-01"
   */
  accumulateFrom?: string;
}

export interface PostSectorRootsConfigSchema {
  /**
   * @format float
   * @example 0
   */
  threshold: number;
}

export interface GetSoilMoistureAvailableDepthsResponse {
  /** @example true */
  success?: boolean;
  /** @example "Profundidades disponibles obtenidas" */
  message?: string;
  /** @example ["20 cm","40 cm","60 cm"] */
  availableDepths?: string[];
}

export interface GetSectorPlantsConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de plantas obtenida" */
  message?: string;
  plantsConfig?: {
    /**
     * @format date-time
     * @example "2024-01-01"
     */
    accumulateFrom?: string;
  };
}

export interface GetSectorRainfallConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de precipitaciones obtenida" */
  message?: string;
  rainfallConfig?: {
    /**
     * @format date-time
     * @example "2024-01-01"
     */
    accumulateFrom?: string;
  };
}

export interface PostSectorRainfallConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de precipitaciones actualizada" */
  message?: string;
  newRainfallConfig?: {
    /**
     * @format date-time
     * @example "2024-01-01"
     */
    accumulateFrom?: string;
  };
}

export interface GetSectorEt0ConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de ET0 obtenida" */
  message?: string;
  et0Config?: {
    /**
     * @format date-time
     * @example "2024-01-01"
     */
    accumulateFrom?: string;
  };
}

export interface PostSectorEt0ConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de ET0 actualizada" */
  message?: string;
  newEt0Config?: {
    /**
     * @format date-time
     * @example "2024-01-01"
     */
    accumulateFrom?: string;
  };
}

export interface GetSectorStackedSoilMoistureConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de humedad suelo apilada obtenida" */
  message?: string;
  stackedSoilMoistureConfig?: {
    /** @example "Humedad" */
    sortBy?: "Humedad" | "Profundidad";
  };
}

export interface PostSectorStackedSoilMoistureConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de humedad suelo apilada actualizada" */
  message?: string;
  newStackedSoilMoistureConfig?: {
    /** @example "Humedad" */
    sortBy?: "Humedad" | "Profundidad";
  };
}

export interface GetSectorSalinityConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de humedad suelo apilada obtenida" */
  message?: string;
  salinityConfig?: {
    /** @example "Salinidad" */
    sortBy?: "Salinidad" | "Profundidad";
  };
}

export interface PostSectorSalinityConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de Salinidad suelo apilada actualizada" */
  message?: string;
  newSalinityConfig?: {
    /** @example "Salinidad" */
    sortBy?: "Salinidad" | "Profundidad";
  };
}

export interface GetSectorPlantConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de planta obtenida" */
  message?: string;
  plantConfig?: {
    /** @example "Tronco" */
    measureBy?: "Tronco" | "Tallo" | "Brote";
  };
}

export interface PostSectorPlantConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de Salinidad suelo apilada actualizada" */
  message?: string;
  newPlantConfig?: {
    /** @example "Tronco" */
    measureBy?: "Tronco" | "Tallo" | "Brote";
  };
}

export interface GetSectorSoilMoistureConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de humedad suelo actualizada" */
  message?: string;
  soilMoistureConfig?: {
    /** @example ["10","20","30"] */
    levels?: string[];
    /** @example [{"from":0,"to":100,"label":"Zona Azul","areaType":"blue","inputName":"pc_1","inputValue":0}] */
    generalLines?: CriticalPoint[];
    phaseLines: {
      [key: string]: {
        [key: string]: CriticalPoint[];
      };
    };
    phenologicalStatesLabels: {
      [key: string]: string;
    };
    chartLines: ChartLines[];
    maxValue: number;
    minValue: number;
    /** @example {"min":{"type":"number","$_root":{"_types":{},"version":"17.10.1","cache":{}},"$_temp":{"ruleset":false,"whens":{}},"_ids":{"_byId":{},"_byKey":{},"_schemaChain":false},"_preferences":null,"_valids":null,"_invalids":null,"_rules":[],"_singleRules":{},"_refs":{"refs":[]},"_flags":{},"_cache":null,"$_terms":{"alterations":null,"examples":[30],"externals":null,"metas":[],"notes":[],"shared":null,"tags":[],"whens":null},"$_super":{}},"criticalPoint1":{"type":"number","$_root":{"_types":{},"version":"17.10.1","cache":{}},"$_temp":{"ruleset":false,"whens":{}},"_ids":{"_byId":{},"_byKey":{},"_schemaChain":false},"_preferences":null,"_valids":null,"_invalids":null,"_rules":[],"_singleRules":{},"_refs":{"refs":[]},"_flags":{},"_cache":null,"$_terms":{"alterations":null,"examples":[40],"externals":null,"metas":[],"notes":[],"shared":null,"tags":[],"whens":null},"$_super":{}},"max":{"type":"number","$_root":{"_types":{},"version":"17.10.1","cache":{}},"$_temp":{"ruleset":false,"whens":{}},"_ids":{"_byId":{},"_byKey":{},"_schemaChain":false},"_preferences":null,"_valids":null,"_invalids":null,"_rules":[],"_singleRules":{},"_refs":{"refs":[]},"_flags":{},"_cache":null,"$_terms":{"alterations":null,"examples":[90],"externals":null,"metas":[],"notes":[],"shared":null,"tags":[],"whens":null},"$_super":{}}} */
    threshold?: object;
  };
}

export interface PostSectorSoilMoistureLevelsConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Profundidad de grafico de humedad suelo actualizada" */
  message?: string;
  newSoilMoistureLevelsConfig?: {
    /** @example ["10","20","30"] */
    levels?: string[];
  };
}

export interface PostSectorSoilMoistureGeneralLinesConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Areas de grafico de humedad suelo actualizada" */
  message: string;
  newSoilMoistureGeneralLinesConfig: {
    generalLines: {
      id: number;
      value: number;
      label: string;
      customLabel: string;
    }[];
  };
}

export interface PostSectorSoilMoisturePhaseLinesConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Areas de grafico de humedad suelo actualizada" */
  message: string;

}

export interface GetSectorRootsConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de profundidad de riego obtenida" */
  message?: string;
  rootsConfig?: {
    /**
     * @format float
     * @example 0
     */
    irrigationThreshold?: number;
    /**
     * @format float
     * @example 0
     */
    rootsThreshold?: number;
  };
}

export interface PostSectorRootsConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de profundidad de riego actualizada" */
  message?: string;
  newRootsConfig?: {
    /**
     * @format float
     * @example 0
     */
    irrigationThreshold?: number;
    /**
     * @format float
     * @example 0
     */
    rootsThreshold?: number;
  };
}

export interface GetSectorDegreeDayConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de grados día obtenida" */
  message?: string;
  degreeDayConfig?: {
    /**
     * @format float
     * @example 0
     */
    accumulatedDegreesBaseTemp?: number;
    accumulatedColdHoursBaseTemp?: number;
    accumulatedColdHoursStartDate?: string;
    accumulatedColdHoursEndDate?: string;
  };
}

export interface PostSectorDegreeDayConfigResponse {
  /** @example true */
  success?: boolean;
  /** @example "Configuración gráfico de grados día actualizada" */
  message?: string;
  newDegreeDayConfig?: {
    /**
     * @format float
     * @example 0
     */
    accumulatedDegreesBaseTemp?: number;
    accumulatedColdHoursBaseTemp?: number;
    accumulatedColdHoursStartDate?: string;
    accumulatedColdHoursEndDate?: string;
  };
}

export interface CommentSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id: string;
  /** @example "Lore ipsum dolor sit amet" */
  message: string;
  /** @example "Luis Álvarez" */
  author: string;
  /**
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  createdAt: string;
}

export interface ConversationSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  conversationId: string;
  /**
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /** @example "Luis Álvarez" */
  updatedBy: string;
  /** @example "Lore ipsum dolor sit amet" */
  lastComment: string;
  /** @example "Las Delicias" */
  farmName: string;
  /** @example "Sector 1" */
  farmId: string;
  /** @example "67d07cff95257e3dc54694cb" */
  sectorName: string;
  /** @example "Gráfico de humedad del suelo" */
  sectorId: string;
  /** @example "67d07dce95257e3dc5469a8b" */
  wiseconnId: string;
  /** @example "10203" */
  chart: string;
  timePoint: {
    /** @example "14:00" */
    hour: string;
    /** @example "01" */
    day: string;
    /** @example "01" */
    month: string;
    /** @example "2024" */
    year: string;
  };
  /** @example false */
  deleted: boolean;
}

export interface TimePointSchema {
  /** @example "14:00" */
  hour?: string;
  /** @example "01" */
  day?: string;
  /** @example "01" */
  month?: string;
  /** @example "2024" */
  year?: string;
}

export interface PostCommentOnNewConversationSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  farmId: string;
  /** @example "669814726c9ca473fff3ee4d" */
  sectorId: string;
  /** @example "Gráfico de humedad del suelo" */
  chart: string;
  /** @example "669814726c9ca473fff3ee4d" */
  author: string;
  /** @example "Lore ipsum dolor sit amet" */
  message: string;
  timePoint: {
    /** @example "14:00" */
    hour?: string;
    /** @example "01" */
    day?: string;
    /** @example "01" */
    month?: string;
    /** @example "2024" */
    year?: string;
  };
}

export interface PostCommentOnNewConversationResponse {
  /** @example true */
  success: boolean;
  /** @example "Comentario creado exitosamente" */
  message: string;
  conversation: {
    /** @example "669814726c9ca473fff3ee4d" */
    conversationId: string;
    /**
     * @format date-time
     * @example "2024-01-01T00:00:00.000Z"
     */
    updatedAt: string;
    /** @example "Luis Álvarez" */
    updatedBy: string;
    /** @example "Lore ipsum dolor sit amet" */
    lastComment: string;
    /** @example "Las Delicias" */
    farmName: string;
    /** @example "Sector 1" */
    sectorName: string;
    /** @example "Gráfico de humedad del suelo" */
    chart: string;
    timePoint: {
      /** @example "14:00" */
      hour?: string;
      /** @example "01" */
      day?: string;
      /** @example "01" */
      month?: string;
      /** @example "2024" */
      year?: string;
    };
  };
  comment: {
    /** @example "669814726c9ca473fff3ee4d" */
    id: string;
    /** @example "Lore ipsum dolor sit amet" */
    message: string;
    /** @example "Luis Álvarez" */
    author: string;
    /**
     * @format date-time
     * @example "2024-01-01T00:00:00.000Z"
     */
    createdAt: string;
  };
}

export interface GetCommentsByConversationIdSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  conversationId: string;
}

export interface GetCommentsByConversationIdResponse {
  /** @example true */
  success: boolean;
  /** @example "Comentarios cargados exitosamente" */
  message: string;
  comments: {
    /** @example "669814726c9ca473fff3ee4d" */
    id: string;
    /** @example "Lore ipsum dolor sit amet" */
    message: string;
    /** @example "Luis Álvarez" */
    author: string;
    /**
     * @format date-time
     * @example "2024-01-01T00:00:00.000Z"
     */
    createdAt: string;
  }[];
}

export interface GetConversationsSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  sectorId: string;
  /** @example "Humedad SueloS" */
  chart: string;
}

export interface GetConversationsResponse {
  /** @example true */
  success: boolean;
  /** @example "Conversaciones cargadas exitosamente" */
  message: string;
  conversations: ConversationSchema[];
}

export interface PostCommentSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  conversationId: string;
  /** @example "Luis Álvarez" */
  author: string;
  /** @example "Lore ipsum dolor sit amet" */
  message: string;
}

export interface PostCommentResponse {
  /** @example true */
  success: boolean;
  /** @example "Comentario creado exitosamente" */
  message: string;
  comment: {
    /** @example "669814726c9ca473fff3ee4d" */
    id: string;
    /** @example "Lore ipsum dolor sit amet" */
    message: string;
    /** @example "Luis Álvarez" */
    author: string;
    /**
     * @format date-time
     * @example "2024-01-01T00:00:00.000Z"
     */
    createdAt: string;
  };
  conversation: {
    /** @example "669814726c9ca473fff3ee4d" */
    conversationId: string;
    /**
     * @format date-time
     * @example "2024-01-01T00:00:00.000Z"
     */
    updatedAt: string;
    /** @example "Luis Álvarez" */
    updatedBy: string;
    /** @example "Lore ipsum dolor sit amet" */
    lastComment: string;
    /** @example "Las Delicias" */
    farmName: string;
    /** @example "Sector 1" */
    sectorName: string;
    /** @example "Gráfico de humedad del suelo" */
    chart: string;
    timePoint: {
      /** @example "14:00" */
      hour?: string;
      /** @example "01" */
      day?: string;
      /** @example "01" */
      month?: string;
      /** @example "2024" */
      year?: string;
    };
  };
}

export interface NotificationSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  id?: string;
  /** @example "New Alert" */
  title: string;
  /** @example "alert" */
  type: string | null;
  /** @example "669814726c9ca473fff3ee4d" */
  user: string;
  createdBy?: {
    /** @example "John" */
    name?: string;
    /** @example "Doe" */
    lastname?: string;
  };
  /** @example "Alert details" */
  subtitle?: string | null;
  /** @example "Account name" */
  account?: string | null;
  sector?: {
    /** @example "Sector A" */
    name?: string;
    /** @example "1234567890" */
    wiseconnZoneId?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
  };
  farm?: {
    /** @example "Farm 1" */
    name?: string;
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
  };
  /** @example "Chart 1" */
  highchartName?: string | null;
  /**
   * @format date-time
   * @example "2023-03-07T19:43:46.303Z"
   */
  createdAt?: string;
  /**
   * @format date-time
   * @example "2023-03-07T19:43:46.303Z"
   */
  updatedAt?: string;
  /** @example "/account/123" */
  path?: string | null;
  /** @example "There is a new alert in your farm" */
  message?: string;
  /** @example false */
  is_read?: boolean;
  /** @example "669814726c9ca473fff3ee4d" */
  conversationId?: {
    _id: string;
    timePoint?: {
      day: number;
      month: number;
      year: number;
    };
    createdAt?: string;
  } | string;
}

export interface GetNotificationsPerUserSchema {
  /** @example "669814726c9ca473fff3ee4d" */
  userId: string;
}

export interface PostNotificationSchema {
  /** @example "New Alert" */
  title: string;
  /** @example "alert" */
  type: string;
  /** @example "669814726c9ca473fff3ee4d" */
  userId: string;
  /** @example "There is a new alert in your farm" */
  message?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  createdBy?: string;
  /** @example "Alert details" */
  subtitle?: string | null;
  /** @example "Account name" */
  account?: string | null;
  /** @example "669814726c9ca473fff3ee4d" */
  sector?: string;
  /** @example "669814726c9ca473fff3ee4d" */
  farm?: string;
  /** @example "Chart 1" */
  highchartName?: string | null;
  /** @example "/account/123" */
  path?: string | null;
  conversationId?: {
    _id: string;
    timePoint?: {
      day: number;
      month: number;
      year: number;
    };
    createdAt?: string;
  } | string;
}

export interface UpdateNotificationSchema {
  /** @example "Updated Alert" */
  title?: string;
  /** @example "Updated alert message" */
  message?: string;
  /** @example true */
  is_read?: boolean;
  /** @example "Updated details" */
  subtitle?: string | null;
  /** @example "Updated account" */
  account?: string | null;
  /** @example "Updated sector" */
  sector?: string | null;
  /** @example "Updated chart" */
  highchartName?: string | null;
  /** @example "/updated/path" */
  path?: string | null;
  /** @example "updated-alert" */
  type?: string | null;
  /** @example "Updated farm" */
  farm?: string | null;
}

export interface GetNotificationsPerUserResponse {
  /** @example true */
  success?: boolean;
  /** @example "Notificaciones encontradas exitosamente" */
  message?: string;
  notifications?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "New Alert" */
    title: string;
    /** @example "alert" */
    type: string | null;
    /** @example "669814726c9ca473fff3ee4d" */
    user: string;
    createdBy?: {
      /** @example "John" */
      name?: string;
      /** @example "Doe" */
      lastname?: string;
    };
    /** @example "Alert details" */
    subtitle?: string | null;
    /** @example "Account name" */
    account?: string | null;
    sector?: {
      /** @example "Sector A" */
      name?: string;
      /** @example "1234567890" */
      wiseconnZoneId?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
    };
    farm?: {
      /** @example "Farm 1" */
      name?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
    };
    /** @example "Chart 1" */
    highchartName?: string | null;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    createdAt?: string;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    updatedAt?: string;
    /** @example "/account/123" */
    path?: string | null;
    /** @example "There is a new alert in your farm" */
    message?: string;
    /** @example false */
    is_read?: boolean;
    conversationId?: {
      _id: string;
      timePoint?: {
        day: number;
        month: number;
        year: number;
      };
      createdAt?: string;
    } | string;
  }[];
}

export interface DeleteNotificationResponse {
  /** @example true */
  success?: boolean;
  /** @example "Notificación eliminada exitosamente" */
  message?: string;
}

export interface PostNotificationResponse {
  /** @example true */
  success?: boolean;
  /** @example "Notificación creada exitosamente" */
  message?: string;
  notification?: {
    /** @example "669814726c9ca473fff3ee4d" */
    id?: string;
    /** @example "New Alert" */
    title: string;
    /** @example "alert" */
    type: string | null;
    /** @example "669814726c9ca473fff3ee4d" */
    user: string;
    createdBy?: {
      /** @example "John" */
      name?: string;
      /** @example "Doe" */
      lastname?: string;
    };
    /** @example "Alert details" */
    subtitle?: string | null;
    /** @example "Account name" */
    account?: string | null;
    sector?: {
      /** @example "Sector A" */
      name?: string;
      /** @example "1234567890" */
      wiseconnZoneId?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
    };
    farm?: {
      /** @example "Farm 1" */
      name?: string;
      /** @example "669814726c9ca473fff3ee4d" */
      id?: string;
    };
    /** @example "Chart 1" */
    highchartName?: string | null;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    createdAt?: string;
    /**
     * @format date-time
     * @example "2023-03-07T19:43:46.303Z"
     */
    updatedAt?: string;
    /** @example "/account/123" */
    path?: string | null;
    /** @example "There is a new alert in your farm" */
    message?: string;
    /** @example false */
    is_read?: boolean;
    conversationId?: {
      _id: string;
      timePoint?: {
        day: number;
        month: number;
        year: number;
      };
      createdAt?: string;
    } | string;
  };
}

export interface WebhookNotificationSchema {
  /** @example "00001326" */
  SN: string;
  /**
   * @min 0
   * @example 2
   */
  records: number;
  /** @example 1740582593000 */
  ini: number;
  /** @example 1740597023000 */
  end: number;
}

export interface WebhookNuvathingsResponseSchema {
  /** @example true */
  success: boolean;
  /** @example "Data received and processed successfully" */
  message: string;
  result?: {
    /** @example true */
    processed: boolean;
  };
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
          .then((data) => {
            if (r.ok) {
              r.data = data;
            } else {
              r.error = data;
            }
            return r;
          })
          .catch((e) => {
            r.error = e;
            return r;
          });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Template REST API Docs
 * @version 0.1.61
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  accounts = {
    /**
     * @description Get accounts information
     *
     * @tags Account
     * @name AccountsList
     * @request GET:/accounts
     * @secure
     */
    accountsList: (
      query?: {
        page?: number;
        limit?: number;
        searchValue?: string;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAccountsPerPageResponse, void>({
        path: `/accounts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates an account.
     *
     * @tags Account
     * @name AccountsCreate
     * @request POST:/accounts
     * @secure
     */
    accountsCreate: (data: PostAccountSchema, params: RequestParams = {}) =>
      this.request<PostAccountResponse, void>({
        path: `/accounts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get account information
     *
     * @tags Account
     * @name AccountsDetail
     * @request GET:/accounts/{id}
     * @secure
     */
    accountsDetail: (id?: string, params: RequestParams = {}) =>
      this.request<GetAccountByIdResponse, void>({
        path: `/accounts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Modifies an account.
     *
     * @tags Account
     * @name AccountsUpdate
     * @request PUT:/accounts/{id}
     * @secure
     */
    accountsUpdate: (id: string, data: PutAccountSchema, params: RequestParams = {}) =>
      this.request<PutAccountResponse, void>({
        path: `/accounts/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an account by ID.
     *
     * @tags Account
     * @name AccountsDelete
     * @request DELETE:/accounts/{id}
     * @secure
     */
    accountsDelete: (id: string, params: RequestParams = {}) =>
      this.request<DeleteAccountResponse, void>({
        path: `/accounts/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  userAccounts = {
    /**
     * @description Get information of all accounts from user
     *
     * @tags User, Account
     * @name UserAccountsDetail
     * @request GET:/user-accounts/{id}
     * @secure
     */
    userAccountsDetail: (id?: string, params: RequestParams = {}) =>
      this.request<GetUserAccountsByUserIdResponse, void>({
        path: `/user-accounts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  register = {
    /**
     * @description Creates a new user that must afterwards verify the account with a token
     *
     * @tags Auth
     * @name RegisterCreate
     * @request POST:/register
     * @secure
     */
    registerCreate: (data: RegisterRequest, params: RequestParams = {}) =>
      this.request<RegisterResponse, void>({
        path: `/register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  login = {
    /**
     * @description Authenticates a user by email and password and returns a JWT token
     *
     * @tags Auth
     * @name LoginCreate
     * @request POST:/login
     * @secure
     */
    loginCreate: (data: LoginRequest, params: RequestParams = {}) =>
      this.request<LoginResponse, ErrorResponse | void>({
        path: `/login`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  recoverPassword = {
    /**
     * @description Sends an email to the user with instructions to recover password
     *
     * @tags Auth
     * @name RecoverPasswordCreate
     * @request POST:/recover-password
     * @secure
     */
    recoverPasswordCreate: (data: RecoverPasswordRequest, params: RequestParams = {}) =>
      this.request<RecoverPasswordResponse, void>({
        path: `/recover-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  resetPassword = {
    /**
     * @description Resets a user's password
     *
     * @tags Auth
     * @name ResetPasswordCreate
     * @request POST:/reset-password
     * @secure
     */
    resetPasswordCreate: (data: ResetPasswordRequest, params: RequestParams = {}) =>
      this.request<ResetPasswordResponse, void>({
        path: `/reset-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  userVerification = {
    /**
     * @description Verifies user account with a token
     *
     * @tags Auth
     * @name UserVerificationCreate
     * @request POST:/user-verification
     * @secure
     */
    userVerificationCreate: (data: VerificationRequest, params: RequestParams = {}) =>
      this.request<VerificationResponse, void>({
        path: `/user-verification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  rainfallConfig = {
    /**
     * @description Get Config for Rainfall Graph of Sector
     *
     * @tags GraphConfigurations
     * @name RainfallConfigDetail
     * @request GET:/rainfallConfig/{sectorId}
     * @secure
     */
    rainfallConfigDetail: (sectorId: string, params: RequestParams = {}) =>
      this.request<GetSectorRainfallConfigResponse, void>({
        path: `/rainfallConfig/${sectorId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update Config for Rainfall Graph of Sector
     *
     * @tags GraphConfigurations
     * @name RainfallConfigCreate
     * @request POST:/rainfallConfig/{sectorId}
     * @secure
     */
    rainfallConfigCreate: (sectorId: string, data: PostSectorRainfallConfigSchema, params: RequestParams = {}) =>
      this.request<PostSectorRainfallConfigResponse, void>({
        path: `/rainfallConfig/${sectorId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  et0Config = {
    /**
     * @description Get Config for ET0 Graph of Sector
     *
     * @tags GraphConfigurations
     * @name Et0ConfigDetail
     * @request GET:/et0Config/{sectorId}
     * @secure
     */
    et0ConfigDetail: (sectorId: string, params: RequestParams = {}) =>
      this.request<GetSectorEt0ConfigResponse, void>({
        path: `/et0Config/${sectorId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update Config for ET0 Graph of Sector
     *
     * @tags GraphConfigurations
     * @name Et0ConfigCreate
     * @request POST:/et0Config/{sectorId}
     * @secure
     */
    et0ConfigCreate: (sectorId: string, data: PostSectorEt0ConfigSchema, params: RequestParams = {}) =>
      this.request<PostSectorEt0ConfigResponse, void>({
        path: `/et0Config/${sectorId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  stackedSoilMoistureConfig = {
    /**
     * @description Get Config for Stacked Soil Moisture Graph of Sector
     *
     * @tags GraphConfigurations
     * @name StackedSoilMoistureConfigDetail
     * @request GET:/stackedSoilMoistureConfig/{sectorId}
     * @secure
     */
    stackedSoilMoistureConfigDetail: (sectorId: string, params: RequestParams = {}) =>
      this.request<GetSectorStackedSoilMoistureConfigResponse, void>({
        path: `/stackedSoilMoistureConfig/${sectorId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update Config for Stacked Soil Moisture Graph of Sector
     *
     * @tags GraphConfigurations
     * @name StackedSoilMoistureConfigCreate
     * @request POST:/stackedSoilMoistureConfig/{sectorId}
     * @secure
     */
    stackedSoilMoistureConfigCreate: (sectorId: string, data: any, params: RequestParams = {}) =>
      this.request<PostSectorStackedSoilMoistureConfigResponse, void>({
        path: `/stackedSoilMoistureConfig/${sectorId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  salinityConfig = {
    /**
      * @description Get Config for Stacked Soil Moisture Graph of Sector
      *
      * @tags GraphConfigurations
      * @name salinityConfigDetail
      * @request GET:/salinityConfig/{sectorId}
      * @secure
      */
    salinityConfigDetail: (sectorId: string, params: RequestParams = {}) =>
      this.request<GetSectorSalinityConfigResponse, void>({
        path: `/salinityConfig/${sectorId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update Config for Salinity Graph of Sector
     *
     * @tags GraphConfigurations
     * @name salinityConfigCreate
     * @request POST:/salinityConfig/{sectorId}
     * @secure
     */
    salinityConfigCreate: (sectorId: string, data: any, params: RequestParams = {}) =>
      this.request<PostSectorSalinityConfigResponse, void>({
        path: `/salinityConfig/${sectorId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  }
  plantConfig = {
    /**
      * @description Get Config for Stacked Soil Moisture Graph of Sector
      *
      * @tags GraphConfigurations
      * @name plantConfigDetail
      * @request GET:/plantConfig/{sectorId}
      * @secure
      */
    plantConfigDetail: (sectorId: string, params: RequestParams = {}) =>
      this.request<GetSectorPlantConfigResponse, void>({
        path: `/plantConfig/${sectorId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update Config for plant Graph of Sector
     *
     * @tags GraphConfigurations
     * @name plantConfigCreate
     * @request POST:/plantConfig/{sectorId}
     * @secure
     */
    plantConfigCreate: (sectorId: string, data: any, params: RequestParams = {}) =>
      this.request<PostSectorPlantConfigResponse, void>({
        path: `/plantConfig/${sectorId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  }
  soilMoistureConfig = {
    /**
     * @description Get Config for Soil Moisture Graph of Sector
     *
     * @tags GraphConfigurations
     * @name SoilMoistureConfigDetail
     * @request GET:/soilMoistureConfig/{sectorId}
     * @secure
     */
    soilMoistureConfig: (sectorId: string, params: RequestParams = {}) =>
      this.request<GetSectorSoilMoistureConfigResponse, void>({
        path: `/soilMoistureConfig/${sectorId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Get Config for Soil Moisture Graph of Sector
     *
     * @tags GraphConfigurations
     * @name SoilMoistureConfigDetail
     * @request GET:/soilMoistureConfig/{sectorId}
     * @secure
     */
    soilMoistureConfigDetail: (sectorId: string, inputData: { startDate: string, endDate: string }, params: RequestParams = {}) =>
      this.request<GetSectorSoilMoistureConfigResponse, void>({
        path: `/soilMoistureConfigDetail/${sectorId}?startDate=${inputData.startDate}&endDate=${inputData.endDate}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update Config for Soil Moisture Graph of Sector
     *
     * @tags GraphConfigurations
     * @name LevelsCreate
     * @request POST:/soilMoistureConfig/levels/{sectorId}
     * @secure
     */
    levelsCreate: (sectorId: string, data: any, params: RequestParams = {}) =>
      this.request<PostSectorSoilMoistureLevelsConfigResponse, void>({
        path: `/soilMoistureConfig/levels/${sectorId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update Config for Areas of Soil Moisture Graph of Sector
     *
     * @tags GraphConfigurations
     * @name GeneralLinesCreate
     * @request POST:/soilMoistureConfig/areas/{sectorId}
     * @secure
     */
    generalLinesCreate: (sectorId: string, data: any, params: RequestParams = {}) =>
      this.request<PostSectorSoilMoistureGeneralLinesConfigResponse, void>({
        path: `/soilMoistureConfig/generalLines/${sectorId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get available depths for Soil Moisture Graph of Sector
     *
     * @tags GraphConfigurations
     * @name AvailableDepthsDetail
     * @request GET:/soilMoistureConfig/availableDepths/{sectorId}
     * @secure
     */
    availableDepthsDetail: (sectorId: string, params: RequestParams = {}) =>
      this.request<GetSoilMoistureAvailableDepthsResponse, void>({
        path: `/soilMoistureConfig/availableDepths/${sectorId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  rootsConfig = {
    /**
     * @description Get Config for Roots Graph of Sector
     *
     * @tags GraphConfigurations
     * @name RootsConfigDetail
     * @request GET:/rootsConfig/{sectorId}
     * @secure
     */
    rootsConfigDetail: (sectorId: string, params: RequestParams = {}) =>
      this.request<GetSectorRootsConfigResponse, void>({
        path: `/rootsConfig/${sectorId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update Config for Irrigation Threshold of Roots Graph of Sector
     *
     * @tags GraphConfigurations
     * @name IrrigationThresholdCreate
     * @request POST:/rootsConfig/irrigationThreshold/{sectorId}
     * @secure
     */
    irrigationThresholdCreate: (sectorId: string, data: PostSectorRootsConfigSchema, params: RequestParams = {}) =>
      this.request<PostSectorRootsConfigResponse, void>({
        path: `/rootsConfig/irrigationThreshold/${sectorId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update Config for Roots Threshold of Roots Graph of Sector
     *
     * @tags GraphConfigurations
     * @name RootsThresholdCreate
     * @request POST:/rootsConfig/rootsThreshold/{sectorId}
     * @secure
     */
    rootsThresholdCreate: (sectorId: string, data: PostSectorRootsConfigSchema, params: RequestParams = {}) =>
      this.request<PostSectorRootsConfigResponse, void>({
        path: `/rootsConfig/rootsThreshold/${sectorId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  sectors = {
    /**
     * @description Get sectors information
     *
     * @tags Sector
     * @name SectorsList
     * @request GET:/sectors
     * @secure
     */
    sectorsList: (
      query?: {
        page?: number;
        limit?: number;
        searchValue?: string;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, void>({
        path: `/sectors`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Add new sector to farm
     *
     * @tags Sector
     * @name SectorsCreate
     * @request POST:/sectors
     * @secure
     */
    sectorsCreate: (data: PostFarmSectorsSchema, params: RequestParams = {}) =>
      this.request<PostFarmSectorsResponse, void>({
        path: `/sectors`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all sectors wiseconn ids
     *
     * @tags Sector
     * @name WiseconnIdsList
     * @request GET:/sectors/wiseconn-ids
     * @secure
     */
    wiseconnIdsList: (params: RequestParams = {}) =>
      this.request<GetSectorsWiseconnIdsResponse, void>({
        path: `/sectors/wiseconn-ids`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all sectors helius sn
     *
     * @tags Sector
     * @name SectorsHeliusSnList
     * @request GET:/sectors/helius-sn
     * @secure
     */
    sectorsHeliusSnList: (params: RequestParams = {}) =>
      this.request<GetSectorsHeliusSnResponse, void>({
        path: `/sectors/helius-sn`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get farm sectors
     *
     * @tags Sector
     * @name SectorsDetail
     * @request GET:/sectors/{farmId}
     * @secure
     */
    sectorsDetail: (farmId: string, params: RequestParams = {}) =>
      this.request<GetFarmSectorsResponse, void>({
        path: `/sectors/${farmId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update measures for a specific sector
     *
     * @tags Sector
     * @name IndividualSectorMeasuresUpdate
     * @request PUT:/sectors/individual-sector-measures
     * @secure
     */
    individualSectorMeasuresUpdate: (
      query: {
        farmId: string;
        wiseconnZoneId: string;
      },
      data: UpdateSectorMeasuresSchema,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSectorResponse, void>({
        path: `/sectors/individual-sector-measures`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  sector = {
    getSectorResumeData: (sectorId: string, startDate: string, endDate: string) =>
      this.request<GetSectorResumeDataResponse, void>({
        path: `/sector/${sectorId}/resume-data?startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        secure: true,
        format: "json",
      }),
    checkSectorDataRecoveryStatus: (sectorId: string) => this.request<CheckSectorDataRecoveryStatusResponse, void>({
      path: `/sectors/${sectorId}/data-recovery-status`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
    }),
    publishSectorDataRecoveryBatches: (data: {
      sectorId: string,
      startDate: string,
      endDate: string,
    }) => this.request<PublishSectorDataRecoveryBatchesSchema, void>({
      path: '/sectors/data-recovery-batches',
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
    }),
    /**
     * @description Get sector information for SectorDetail View
     *
     * @tags Sector
     * @name SectorDetail
     * @request GET:/sector/{id}
     * @secure
     */
    sectorDetail: (id: string, params: RequestParams = {}) =>
      this.request<SectorByIdSchemaResponse, void>({
        path: `/sector/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a general information of sector
     *
     * @tags Sector
     * @name SectorUpdate
     * @request PUT:/sector/{id}
     * @secure
     */
    sectorUpdate: (id: string, data: UpdateSectorSchema, params: RequestParams = {}) =>
      this.request<UpdateSectorResponse, void>({
        path: `/sector/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a sector
     *
     * @tags Sector
     * @name SectorDelete
     * @request DELETE:/sector/{id}
     * @secure
     */
    sectorDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/sector/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Update measures for all sectors
     *
     * @tags Sector
     * @name AllSectorsMeasuresUpdate
     * @request PUT:/sector/all-sectors-measures
     * @secure
     */
    allSectorsMeasuresUpdate: (
      query: {
        farmId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UpdateSectorResponse, void>({
        path: `/sector/all-sectors-measures`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  sectorsKmz = {
    /**
     * @description Update sectors based on KMZ
     *
     * @tags Sector
     * @name SectorsKmzUpdate
     * @request PUT:/sectors-kmz
     * @secure
     */
    sectorsKmzUpdate: (data: any, params: RequestParams = {}) =>
      this.request<PutSectorsKMZResponse, void>({
        path: `/sectors-kmz`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  phenologicalState = {
    /**
     * @description add a PhenologicalState to a CultivationCycle
     *
     * @tags PhenologicalState, CultivationCycle
     * @name PhenologicalStateCultivationCycleUpdate
     * @request PUT:/phenologicalState-cultivationCycle/{id}
     * @secure
     */
    phenologicalStateCreate: (
      data: PostPhenologicalStateSchema,
      params: RequestParams = {},
    ) =>
      this.request<PostPhenologicalStateResponse, void>({
        path: `/phenological-state`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    phenologicalStateSectorList: (sectorId: string, params: RequestParams = {}) =>
      this.request<GetPhenologicalStatesResponse, void>({
        path: `/phenological-state?sector=${sectorId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    phenologicalStateUpdate: (phenlogicalStateId: string,
      lines?: CriticalPoint[], startDate?: string, endDate?: string,
      kcMin?: number, kcMax?: number, params: RequestParams = {}) =>
      this.request<UpdatePhenologicalStateLineResponse, void>({
        path: `/phenological-state`,
        method: "PUT",
        body: { id: phenlogicalStateId, lines, startDate, endDate, kcMin, kcMax },
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description Deletes a Phenological State
     *
     * @tags PhenologicalState, CultivationCycle
     * @name PhenologicalStateCultivationCycleDelete
     * @request DELETE:/phenologicalState-cultivationCycle
     * @secure
     */
    phenologicalStateDelete: (data: DeletePhenologicalStateSchema, params: RequestParams = {}) =>
      this.request<DeletePhenologicalStateResponse, void>({
        path: `/phenological-state`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  workOrders = {
    /**
     * @description Get work orders information
     *
     * @tags WorkOrder
     * @name WorkOrdersList
     * @request GET:/workOrders
     * @secure
     */
    workOrdersList: (
      query?: {
        page?: number;
        limit?: number;
        searchValue?: string;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetWorkOrdersPerPageResponse, void>({
        path: `/workOrders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dispatchGuides = {
    /**
     * @description Get all dispatch guides information from accountId
     *
     * @tags WorkOrder
     * @name AccountDetail
     * @request GET:/dispatchGuides/account/{accountId}
     * @secure
     */
    accountDetail: (accountId?: string, params: RequestParams = {}) =>
      this.request<GetDispatchGuidesByAccountIdResponse, void>({
        path: `/dispatchGuides/account/${accountId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  workOrdersFromSoftland = {
    /**
     * @description Updates or creates work orders from softland
     *
     * @tags WorkOrder
     * @name WorkOrdersFromSoftlandUpdate
     * @request PUT:/workOrdersFromSoftland
     * @secure
     */
    workOrdersFromSoftlandUpdate: (data: PutWorkOrdersFromSoftlandSchema, params: RequestParams = {}) =>
      this.request<PutWorkOrdersFromSoftlandResponse, void>({
        path: `/workOrdersFromSoftland`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  comment = {
    /**
     * @description Get Comments of Conversation
     *
     * @tags Comment
     * @name CommentDetail
     * @request GET:/comment/{conversationId}
     * @secure
     */
    commentDetail: (conversationId: string, params: RequestParams = {}) =>
      this.request<GetCommentsByConversationIdResponse, void>({
        path: `/comment/${conversationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Post Comment
     *
     * @tags Comment
     * @name CommentCreate
     * @request POST:/comment
     * @secure
     */
    commentCreate: (data: PostCommentSchema, params: RequestParams = {}) =>
      this.request<PostCommentResponse, void>({
        path: `/comment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  companies = {
    /**
     * @description Get companies information
     *
     * @tags Company
     * @name CompaniesList
     * @request GET:/companies
     * @secure
     */
    companiesList: (
      query?: {
        page?: number;
        limit?: number;
        searchValue?: string;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCompaniesPerPageResponse, void>({
        path: `/companies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get company information
     *
     * @tags Company
     * @name CompaniesDetail
     * @request GET:/companies/{id}
     * @secure
     */
    companiesDetail: (id?: string, params: RequestParams = {}) =>
      this.request<GetCompanyByIdResponse, void>({
        path: `/companies/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates all the companies' information from softland
     *
     * @tags Company
     * @name SoftlandGetAllCompaniesUpdate
     * @request PUT:/companies/softland/get-all-companies
     * @secure
     */
    softlandGetAllCompaniesUpdate: (params: RequestParams = {}) =>
      this.request<PutCompaniesSoftlandToMongoResponse, void>({
        path: `/companies/softland/get-all-companies`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  conversation = {
    /**
     * @description Create a new conversation with a comment in it
     *
     * @tags Conversation
     * @name ConversationCreate
     * @request POST:/conversation
     * @secure
     */
    conversationCreate: (data: PostCommentOnNewConversationSchema, params: RequestParams = {}) =>
      this.request<PostCommentOnNewConversationResponse, void>({
        path: `/conversation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get Conversations by SectorId and Chart
     *
     * @tags Conversation
     * @name ConversationDetail
     * @request GET:/conversation/{sectorId}/{chart}
     * @secure
     */
    conversationDetail: (sectorId: string, chart: string, params: RequestParams = {}) =>
      this.request<GetConversationsResponse, void>({
        path: `/conversation/${sectorId}/${chart}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /** 
    TODO: Add conversationList description
    */
    conversationsList: (inputData: { page: number, rowsPerPage: number, sectorId?: string, chartName?: string, farmId?: string, accountId?: string }, params: RequestParams = {}) =>
      this.request<GetConversationsPerPageResponse, void>({
        path: `/conversation?page=${inputData.page}&rowsPerPage=${inputData.rowsPerPage}${inputData.sectorId ? `&sectorId=${inputData.sectorId}` : ''}${inputData.chartName ? `&chartName=${inputData.chartName}` : ''}${inputData.farmId ? `&farmId=${inputData.farmId}` : ''}${inputData.accountId ? `&accountId=${inputData.accountId}` : ''}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a conversation and all its comments
     *
     * @tags Conversation
     * @name ConversationDelete
     * @request DELETE:/conversation/{id}
     * @secure
     */
    conversationDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/conversation/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  cultivationCycle = {
    /**
     * @description Create a new cultivation cycle
     *
     * @tags CultivationCycle
     * @name CultivationCycleCreate
     * @request POST:/cultivationCycle
     * @secure
     */
    cultivationCycleCreate: (data: PostCultivationCycleSchema, params: RequestParams = {}) =>
      this.request<PostCultivationCycleResponse, void>({
        path: `/cultivationCycle`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Edits details of CultivationCycle (except from Phen. States)
     *
     * @tags CultivationCycle
     * @name CultivationCycleUpdate
     * @request PUT:/cultivationCycle
     * @secure
     */
    cultivationCycleUpdate: (data: UpdateCultivationCycleSchema, params: RequestParams = {}) =>
      this.request<UpdateCultivationCycleResponse, void>({
        path: `/cultivationCycle`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description delete a CultivationCycle
     *
     * @tags Sector
     * @name CultivationCycleDelete
     * @request DELETE:/cultivationCycle/{id}
     * @secure
     */
    cultivationCycleDelete: (id: string, params: RequestParams = {}) =>
      this.request<DeleteCultivationCycleResponse, void>({
        path: `/cultivationCycle/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  cultivationCycleSector = {
    /**
     * @description Get CultivationCycles of Sector
     *
     * @tags Sector, CultivationCycle
     * @name CultivationCycleSectorDetail
     * @request GET:/cultivationCycle-sector/{id}
     * @secure
     */
    cultivationCycleSectorDetail: (id: string, params: RequestParams = {}) =>
      this.request<GetCultivationCyclesBySectorResponse, void>({
        path: `/cultivationCycle-sector/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  nodes = {
    /**
     * @description Get nodes information
     *
     * @tags Node
     * @name NodesList
     * @request GET:/nodes
     * @secure
   */
    nodesWiseconnList: (farmWiseconnId: string, params: RequestParams = {}) =>
      this.request<GetNodesWiseconnListResponse, void>({
        path: `/nodes/wiseconn/${farmWiseconnId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Get nodes information of a particular farm
     *
     * @tags Node
     * @name FarmsDetail
     * @request GET:/nodes/farms/{farmId}
     * @secure
   */
    nodesByFarmId: (farmId?: string, params: RequestParams = {}) =>
      this.request<GetNodesByFarmIdResponse, void>({
        path: `/nodes/farms/${farmId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get node information
     *
     * @tags Node
     * @name NodesDetail
     * @request GET:/nodes/{id}
     * @secure
   */
    nodesDetail: (id?: string, params: RequestParams = {}) =>
      this.request<GetNodeByIdResponse, void>({
        path: `/nodes/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Delete a node
     *
     * @tags Node
     * @name NodesDelete
     * @request DELETE:/nodes/{id}
     * @secure
   */
    nodesUpdate: (data: PutNodeSchema, id?: string, params: RequestParams = {}) =>
      this.request<PutNodeResponse, void>({
        path: `/nodes/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    nodesDelete: (id?: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/nodes/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  sensorModels = {
    /**
     * @description Get sensorModels information of a particular farm
     *
     * @tags SensorModel
     * @name SensorModelsByFarmId
     * @request GET:/sensorModels/farms/{farmId}
     * @secure
     */
    sensorModelsByFarmId: (farmId?: string, params: RequestParams = {}) =>
      this.request<GetSensorModelsByFarmIdResponse, void>({
        path: `/sensorModels/farms/${farmId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Get sensorModel information by ID
     *
     * @tags SensorModel
     * @name SensorModelsDetail
     * @request GET:/sensorModels/{id}
     * @secure
     */
    sensorModelsDetail: (id?: string, params: RequestParams = {}) =>
      this.request<GetSensorModelByIdResponse, void>({
        path: `/sensorModels/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Update sensorModel information
     *
     * @tags SensorModel
     * @name SensorModelsUpdate
     * @request PUT:/sensorModels/{id}
     * @secure
     */
    sensorModelsUpdate: (data: any, id?: string, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/sensorModels/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description Delete sensorModel by ID
     *
     * @tags SensorModel
     * @name SensorModelsDelete
     * @request DELETE:/sensorModels/{id}
     * @secure
     */
    sensorModelsDelete: (id?: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/sensorModels/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  sensors = {
    /**
     * @description Get sensors information of a particular farm
     *
     * @tags Sensor
     * @name SensorsByFarmId
     * @request GET:/sensors/farms/{farmId}
     * @secure
   */
    sensorsByFarmId: (farmId?: string, params: RequestParams = {}) =>
      this.request<GetSensorsByFarmIdResponse, void>({
        path: `/sensors/farms/${farmId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get sensor information by ID
     *
     * @tags Sensor
     * @name SensorsDetail
     * @request GET:/sensors/{id}
     * @secure
     */
    sensorsDetail: (id?: string, params: RequestParams = {}) =>
      this.request<GetSensorByIdResponse, void>({
        path: `/sensors/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update sensor information
     *
     * @tags Sensor
     * @name SensorsUpdate
     * @request PUT:/sensors/{id}
     * @secure
     */
    sensorsUpdate: (data: any, id?: string, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/sensors/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete sensor by ID
     *
     * @tags Sensor
     * @name SensorsDelete
     * @request DELETE:/sensors/{id}
     * @secure
     */
    sensorsDelete: (id?: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/sensors/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  devices = {
    /**
     * @description Get devices information
     *
     * @tags Device
     * @name DevicesList
     * @request GET:/devices
     * @secure
     */
    devicesList: (
      query?: {
        page?: number;
        limit?: number;
        searchValue?: string;
        sort?: string;
        accountId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDevicesPerPageResponse, void>({
        path: `/devices`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates/associates a new device to a farm
     *
     * @tags Device
     * @name DevicesCreate
     * @request POST:/devices
     * @secure
     */
    devicesCreate: (
      data: {
        files?: File[];
        /** The JSON string containing additional data such as farmId and coordinates */
        data?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PostDevicesResponse, void>({
        path: `/devices`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Get device information
     *
     * @tags Device
     * @name DevicesDetail
     * @request GET:/devices/{id}
     * @secure
     */
    devicesDetail: (id?: string, params: RequestParams = {}) =>
      this.request<GetDeviceByIdResponse, void>({
        path: `/devices/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update device information
     *
     * @tags Device
     * @name DevicesUpdate
     * @request PUT:/devices/{id}
     * @secure
     */
    devicesUpdate: (data: PutDeviceSchema, id?: string, params: RequestParams = {}) =>
      this.request<PutDeviceResponse, void>({
        path: `/devices/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a device
     *
     * @tags Device
     * @name DevicesDelete
     * @request DELETE:/devices/{id}
     * @secure
     */
    devicesDelete: (id?: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/devices/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Updates all the devices' information from softland
     *
     * @tags Device
     * @name SoftlandGetAllDevicesUpdate
     * @request PUT:/devices/softland/get-all-devices
     * @secure
     */
    softlandGetAllDevicesUpdate: (params: RequestParams = {}) =>
      this.request<PutDevicesSoftlandToMongoResponse, void>({
        path: `/devices/softland/get-all-devices`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get devices information of a particular farm
     *
     * @tags Device
     * @name FarmsDetail
     * @request GET:/devices/farms/{farmId}
     * @secure
     */
    farmsDetail: (farmId?: string, params: RequestParams = {}) =>
      this.request<GetDevicesByFarmIdResponse, void>({
        path: `/devices/farms/${farmId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get device models from softland
     *
     * @tags Device
     * @name SoftlandGetDeviceModelsList
     * @request GET:/devices/softland/get-device-models
     * @secure
     */
    softlandGetDeviceModelsList: (params: RequestParams = {}) =>
      this.request<GetDeviceModelsFromSoftlandResponse, void>({
        path: `/devices/softland/get-device-models`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  farms = {
    /**
     * @description Get farms information
     *
     * @tags Farm
     * @name FarmsList
     * @request GET:/farms
     * @secure
     */
    farmsList: (
      query?: {
        page?: number;
        limit?: number;
        searchValue?: string;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFarmsPerPageResponse, void>({
        path: `/farms`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create new farm
     *
     * @tags Farm
     * @name FarmsCreate
     * @request POST:/farms
     * @secure
     */
    farmsCreate: (data: any, params: RequestParams = {}) =>
      this.request<PostFarmsResponse, void>({
        path: `/farms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update farm information
     *
     * @tags Farm
     * @name FarmsUpdate
     * @request PUT:/farms/{id}
     * @secure
     */
    farmsUpdate: (id: string, data: UpdateFarmSchema, params: RequestParams = {}) =>
      this.request<PostFarmsResponse, void>({
        path: `/farms/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all farms based on account id
     *
     * @tags Farm
     * @name AccountsDetail
     * @request GET:/farms/accounts/{accountId}
     * @secure
     */
    accountsDetail: (accountId: string, params: RequestParams = {}) =>
      this.request<GetFarmsByAccountIdResponse, void>({
        path: `/farms/accounts/${accountId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all farms wiseconn ids
     *
     * @tags Farm
     * @name WiseconnIdsList
     * @request GET:/farms/wiseconn-ids
     * @secure
     */
    wiseconnIdsList: (params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/farms/wiseconn-ids`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Get all farms wiseconn ids
     *
     * @tags Farm
     * @name WiseconnIdsList
     * @request GET:/farms/wiseconn-ids
     * @secure
     */
    nodeIdsList: (farmId: string, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/farms/node-ids?farmId=${farmId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  images = {
    /**
     * @description Get list of images from Google Storage
     *
     * @tags Google Storage Images
     * @name ListList
     * @request GET:/images/list
     * @secure
     */
    listList: (
      query?: {
        deviceId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetGoogleStorageImagesResponse, void>({
        path: `/images/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload image to Google Storage
     *
     * @tags Google Storage Images
     * @name UploadCreate
     * @request POST:/images/upload
     * @secure
     */
    uploadCreate: (
      data: {
        /** @format binary */
        file: File;
        deviceId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadImageToStorageResponse, void>({
        path: `/images/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete image from Google Storage
     *
     * @tags Google Storage Images
     * @name DeleteDelete
     * @request DELETE:/images/delete
     * @secure
     */
    deleteDelete: (
      query?: {
        deviceId?: string;
        fileName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeleteImageFromStorageResponse, void>({
        path: `/images/delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  health = {
    /**
     * @description Responds if the app is up and running
     *
     * @tags Healthcheck
     * @name HealthList
     * @request GET:/health
     * @secure
     */
    healthList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/health`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  notifications = {
    /**
     * @description Get notifications for the current user
     *
     * @tags User, Notification
     * @name NotificationsDetail
     * @request GET:/notifications/{userId}
     * @secure
     */
    notificationsDetail: (userId?: string, params: RequestParams = {}) =>
      this.request<GetNotificationsPerUserResponse, void>({
        path: `/notifications/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a notification by ID
     *
     * @tags Notification
     * @name NotificationsDelete
     * @request DELETE:/notifications/{notificationId}
     * @secure
     */
    notificationsDelete: (notificationId: string, params: RequestParams = {}) =>
      this.request<DeleteNotificationResponse, void>({
        path: `/notifications/${notificationId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a notification by ID
     *
     * @tags Notification
     * @name NotificationsUpdate
     * @request PUT:/notifications/{notificationId}
     * @secure
     */
    notificationsUpdate: (notificationId: string, data: UpdateNotificationSchema, params: RequestParams = {}) =>
      this.request<PostNotificationResponse, void>({
        path: `/notifications/${notificationId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  sendNotification = {
    /**
     * @description Send notification to a specific user
     *
     * @tags Notification
     * @name SendNotificationCreate
     * @request POST:/send-notification
     * @secure
     */
    sendNotificationCreate: (
      data: {
        userId: string;
        message: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PostNotificationResponse, void>({
        path: `/send-notification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  createNotification = {
    /**
     * @description Create a new notification
     *
     * @tags Notification
     * @name CreateNotificationCreate
     * @request POST:/create-notification
     * @secure
     */
    createNotificationCreate: (data: PostNotificationSchema, params: RequestParams = {}) =>
      this.request<PostNotificationResponse, void>({
        path: `/create-notification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  readings = {
    /**
     * @description Get hourly aggregated readings by farm id
     *
     * @tags Reading
     * @name HourlyList
     * @request GET:/readings/hourly
     * @secure
     */
    hourlyList: (
      query?: {
        farmId?: string;
        startDate?: string;
        endDate?: string;
        sensorType?: string;
        sectorId?: string;
        wiseconnZoneId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetReadingsResponse, void>({
        path: `/readings/hourly`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get daily aggregated readings by farm id
     *
     * @tags Reading
     * @name DailyList
     * @request GET:/readings/daily
     * @secure
     */
    dailyList: (
      query?: {
        farmId?: string;
        startDate?: string;
        endDate?: string;
        sensorType?: string;
        sectorId?: string;
        wiseconnZoneId?: number;
        name?: string;
        removeDuplicates?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetReadingsResponse, void>({
        path: `/readings/daily`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get weekly aggregated readings by farm id
     *
     * @tags Reading
     * @name WeeklyList
     * @request GET:/readings/weekly
     * @secure
     */
    weeklyList: (
      query?: {
        farmId?: string;
        startDate?: string;
        endDate?: string;
        sensorType?: string;
        sectorId?: string;
        wiseconnZoneId?: number;
        daysInterval?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetReadingsResponse, void>({
        path: `/readings/weekly`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all readings by farm id
     *
     * @tags Reading
     * @name GetReadings
     * @request GET:/readings/all
     * @secure
     */
    getReadings: (
      query?: {
        farmId?: string;
        startDate?: string;
        endDate?: string;
        sensorType?: string;
        sectorId?: string;
        wiseconnZoneId?: number;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetReadingsResponse, void>({
        path: `/readings/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Get readings for a sector
     *
     * @tags Readings
     * @name ReadingsList
     * @request GET:/readings/{sectorId}
     * @secure
     */
    getSoilMoistureData: (inputData: {
      farmId: string,
      sectorId: string,
      startDate: string,
      endDate: string,
      sensorType: string,
      wiseconnZoneId?: string,
      telemetryType: string,
      sn?: string,
      chart?: string
    }, params: RequestParams = {}) =>
      this.request<GetSoilMoistureDataResponse, void>({
        path: `/readings/soilMoistureChart?farmId=${inputData.farmId}&sectorId=${inputData.sectorId}&startDate=${inputData.startDate}&endDate=${inputData.endDate}&sensorType=${inputData.sensorType}${inputData.wiseconnZoneId ? `&wiseconnZoneId=${inputData.wiseconnZoneId}` : ''}&telemetryType=${inputData.telemetryType}${inputData.sn ? `&sn=${inputData.sn}` : ''}${inputData.chart ? `&chart=${encodeURIComponent(inputData.chart)}` : ''}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Get readings for a sector
     *
     * @tags Readings
     * @name ReadingsList
     * @request GET:/readings/{sectorId}
     * @secure
     */
    getPlantData: (inputData: {
      farmId: string,
      startDate: string,
      endDate: string,
      sectorId?: string,
      wiseconnZoneId?: string,
      telemetryType?: string,
      sn?: string,
      chart?: string
    }, params: RequestParams = {}) =>
      this.request<GetPlantsDataResponse, void>({
        path: `/readings/plantsChart?farmId=${inputData.farmId}&startDate=${inputData.startDate}&endDate=${inputData.endDate}${inputData.sectorId ? '&sectorId=' + inputData.sectorId : ''}${inputData.wiseconnZoneId ? `&wiseconnZoneId=${inputData.wiseconnZoneId}` : ''}${inputData.telemetryType ? `&telemetryType=${inputData.telemetryType}` : ''}${inputData.sn ? `&sn=${inputData.sn}` : ''}${inputData.chart ? `&chart=${encodeURIComponent(inputData.chart)}` : ''}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Get readings for a sector
     *
     * @tags Readings
     * @name ReadingsList
     * @request GET:/readings/{sectorId}
     * @secure
     */
    getWindVelocityData: (inputData: {
      farmId: string,
      startDate: string,
      endDate: string,
      sectorId?: string,
      wiseconnZoneId?: string,
      telemetryType?: string,
      sn?: string,
      chart?: string,
      isWeatherStation?: boolean,
    }, params: RequestParams = {}) => {
      const queryParams = new URLSearchParams();
      queryParams.append('farmId', inputData.farmId);
      queryParams.append('startDate', inputData.startDate);
      queryParams.append('endDate', inputData.endDate);
      if (inputData.sectorId) queryParams.append('sectorId', inputData.sectorId);
      if (inputData.wiseconnZoneId) queryParams.append('wiseconnZoneId', inputData.wiseconnZoneId);
      if (inputData.telemetryType) queryParams.append('telemetryType', inputData.telemetryType);
      if (inputData.sn) queryParams.append('sn', inputData.sn);
      if (inputData.chart) queryParams.append('chart', inputData.chart);
      if (inputData.isWeatherStation !== undefined) queryParams.append('isWeatherStation', String(inputData.isWeatherStation));

      return this.request<GetWindVelocityDataResponse, void>({
        path: `/readings/windChart?${queryParams.toString()}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      });
    },
    getDpvData: (inputData: {
      farmId: string,
      startDate: string,
      endDate: string,
      sectorId?: string,
      wiseconnZoneId?: string,
      telemetryType?: string,
      sn?: string,
      chart?: string,
      isWeatherStation?: boolean,
    }, params: RequestParams = {}) => {
      const queryParams = new URLSearchParams();
      queryParams.append('farmId', inputData.farmId);
      queryParams.append('startDate', inputData.startDate);
      queryParams.append('endDate', inputData.endDate);
      if (inputData.sectorId) queryParams.append('sectorId', inputData.sectorId);
      if (inputData.wiseconnZoneId) queryParams.append('wiseconnZoneId', inputData.wiseconnZoneId);
      if (inputData.telemetryType) queryParams.append('telemetryType', inputData.telemetryType);
      if (inputData.sn) queryParams.append('sn', inputData.sn);
      if (inputData.chart) queryParams.append('chart', inputData.chart);
      if (inputData.isWeatherStation !== undefined) queryParams.append('isWeatherStation', String(inputData.isWeatherStation));

      return this.request<GetDpvDataResponse, void>({
        path: `/readings/dpv?${queryParams.toString()}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      });
    },
    /**
       * @description Get readings for a sector
       *
       * @tags Readings
       * @name ReadingsList
       * @request GET:/readings/{sectorId}
       * @secure
       */
    getStackedSoilMoistureData: (inputData: {
      farmId: string,
      startDate: string,
      endDate: string,
      sensorType: string,
      wiseconnZoneId?: string,
      telemetryType?: string,
      sn?: string,
      sectorId?: string,
      chart?: string
    }, params: RequestParams = {}) =>
      this.request<GetStackedSoilMoistureDataResponse, void>({
        path: `/readings/stackedSoilMoistureChart?farmId=${inputData.farmId}&startDate=${inputData.startDate}&endDate=${inputData.endDate}&sensorType=${inputData.sensorType}${inputData.wiseconnZoneId ? `&wiseconnZoneId=${inputData.wiseconnZoneId}` : ''}${inputData.telemetryType ? `&telemetryType=${inputData.telemetryType}` : ''}${inputData.sn ? `&sn=${inputData.sn}` : ''}${inputData.sectorId ? `&sectorId=${inputData.sectorId}` : ''}${inputData.chart ? `&chart=${encodeURIComponent(inputData.chart)}` : ''}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Get readings for a sector
     *
     * @tags Readings
     * @name ReadingsList
     * @request GET:/readings/{sectorId}
     * @secure
     */
    getKcData: (inputData: {
      farmId: string,
      startDate: string,
      endDate: string,
      sectorId: string,
      wiseconnZoneId?: string,
      weatherZoneId?: string,
      telemetryType?: string,
      sn?: string,
      chart?: string,
    }, params: RequestParams = {}) => {
      const query: Record<string, string> = {
        farmId: inputData.farmId,
        sectorId: inputData.sectorId,
        startDate: inputData.startDate,
        endDate: inputData.endDate,
      };

      if (inputData.wiseconnZoneId) query.wiseconnZoneId = inputData.wiseconnZoneId;
      if (inputData.weatherZoneId) query.weatherZoneId = inputData.weatherZoneId;
      if (inputData.telemetryType) query.telemetryType = inputData.telemetryType;
      if (inputData.sn) query.sn = inputData.sn;
      if (inputData.chart) query.chart = inputData.chart;

      return this.request<getKcDataResponse, void>({
        path: `/readings/kc`,
        method: "GET",
        query,
        secure: true,
        format: "json",
        ...params,
      });
    },
    /**
     * @description Get biweekly report summary data
     *
     * @tags BiweeklyReport
     * @name BiweeklyReportSummary
     * @request GET:/biweekly-reports/{id}/summary
     * @secure
     */
    biweeklyReportSummary: (id: string, params: RequestParams = {}) =>
      this.request<getBiweeklyReportSummaryResponse, void>({
        path: `/biweekly-reports/${id}/summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Get readings for a sector
     *
     * @tags Readings
     * @name ReadingsList
     * @request GET:/readings/{sectorId}
     * @secure
     */
    getET0Data: (inputData: {
      farmId: string,
      sectorId: string,
      startDate: string,
      endDate: string,
      wiseconnZoneId: string,
      telemetryType: string,
      sn?: string,
      isWeatherStation?: boolean,
    }, params: RequestParams = {}) =>
      this.request<GetET0DataResponse, void>({
        path: `/readings/et0?farmId=${inputData.farmId}&sectorId=${inputData.sectorId}&startDate=${inputData.startDate}&endDate=${inputData.endDate}&wiseconnZoneId=${inputData.wiseconnZoneId}&telemetryType=${inputData.telemetryType}&sn=${inputData.sn}${inputData.isWeatherStation !== undefined ? `&isWeatherStation=${inputData.isWeatherStation}` : ''}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    getColdHoursChartData: (inputData: {
      farmId: string,
      startDate: string,
      endDate: string,
      sectorId?: string,
      wiseconnZoneId?: string,
      telemetryType?: string,
      sn?: string,
      chart?: string,
      isWeatherStation?: boolean,
    }, params: RequestParams = {}) => {
      const query: Record<string, string> = {
        farmId: inputData.farmId,
        startDate: inputData.startDate,
        endDate: inputData.endDate,
      };
      if (inputData.sectorId) query.sectorId = inputData.sectorId;
      if (inputData.wiseconnZoneId) query.wiseconnZoneId = inputData.wiseconnZoneId;
      if (inputData.telemetryType) query.telemetryType = inputData.telemetryType;
      if (inputData.sn) query.sn = inputData.sn;
      if (inputData.chart) query.chart = inputData.chart;
      if (inputData.isWeatherStation !== undefined) query.isWeatherStation = String(inputData.isWeatherStation);
      return this.request<any, void>({
        path: `/readings/coldHoursChart`,
        method: "GET",
        query,
        secure: true,
        format: "json",
        ...params,
      });
    },
    getChillPortionsChartData: (inputData: {
      farmId: string,
      startDate: string,
      endDate: string,
      sectorId?: string,
      wiseconnZoneId?: string,
      telemetryType?: string,
      sn?: string,
      chart?: string,
      chillPortionsStartMonth?: number,
      chillPortionsStartDay?: number,
      chillPortionsEndMonth?: number,
      chillPortionsEndDay?: number,
    }, params: RequestParams = {}) => {
      const query: Record<string, string> = {
        farmId: inputData.farmId,
        startDate: inputData.startDate,
        endDate: inputData.endDate,
      };
      if (inputData.sectorId) query.sectorId = inputData.sectorId;
      if (inputData.wiseconnZoneId) query.wiseconnZoneId = inputData.wiseconnZoneId;
      if (inputData.telemetryType) query.telemetryType = inputData.telemetryType;
      if (inputData.sn) query.sn = inputData.sn;
      if (inputData.chart) query.chart = inputData.chart;
      if (inputData.chillPortionsStartMonth !== undefined) {
        query.chillPortionsStartMonth = String(inputData.chillPortionsStartMonth);
      }
      if (inputData.chillPortionsStartDay !== undefined) {
        query.chillPortionsStartDay = String(inputData.chillPortionsStartDay);
      }
      if (inputData.chillPortionsEndMonth !== undefined) {
        query.chillPortionsEndMonth = String(inputData.chillPortionsEndMonth);
      }
      if (inputData.chillPortionsEndDay !== undefined) {
        query.chillPortionsEndDay = String(inputData.chillPortionsEndDay);
      }
      return this.request<any, void>({
        path: `/readings/chillPortionsChart`,
        method: "GET",
        query,
        secure: true,
        format: "json",
        ...params,
      });
    },
    getDegreeDayChartData: (inputData: {
      farmId: string,
      startDate: string,
      endDate: string,
      sectorId?: string,
      wiseconnZoneId?: string,
      telemetryType?: string,
      sn?: string,
      chart?: string,
      isWeatherStation?: boolean,
    }, params: RequestParams = {}) => {
      const query: Record<string, string> = {
        farmId: inputData.farmId,
        startDate: inputData.startDate,
        endDate: inputData.endDate,
      };
      if (inputData.sectorId) query.sectorId = inputData.sectorId;
      if (inputData.wiseconnZoneId) query.wiseconnZoneId = inputData.wiseconnZoneId;
      if (inputData.telemetryType) query.telemetryType = inputData.telemetryType;
      if (inputData.sn) query.sn = inputData.sn;
      if (inputData.chart) query.chart = inputData.chart;
      if (inputData.isWeatherStation !== undefined) query.isWeatherStation = String(inputData.isWeatherStation);
      return this.request<any, void>({
        path: `/readings/degreeDayChart`,
        method: "GET",
        query,
        secure: true,
        format: "json",
        ...params,
      });
    },
    getHumidityTemperatureChartData: (inputData: {
      farmId: string,
      startDate: string,
      endDate: string,
      sectorId?: string,
      wiseconnZoneId?: string,
      telemetryType?: string,
      sn?: string,
      chart?: string,
      isWeatherStation?: boolean,
    }, params: RequestParams = {}) => {
      const query: Record<string, string> = {
        farmId: inputData.farmId,
        startDate: inputData.startDate,
        endDate: inputData.endDate,
      };
      if (inputData.sectorId) query.sectorId = inputData.sectorId;
      if (inputData.wiseconnZoneId) query.wiseconnZoneId = inputData.wiseconnZoneId;
      if (inputData.telemetryType) query.telemetryType = inputData.telemetryType;
      if (inputData.sn) query.sn = inputData.sn;
      if (inputData.chart) query.chart = inputData.chart;
      if (inputData.isWeatherStation !== undefined) query.isWeatherStation = String(inputData.isWeatherStation);
      return this.request<any, void>({
        path: `/readings/humidityTemperatureChart`,
        method: "GET",
        query,
        secure: true,
        format: "json",
        ...params,
      });
    },
    getIrrigationChartData: (inputData: {
      farmId: string,
      startDate: string,
      endDate: string,
      sectorId?: string,
      wiseconnZoneId?: string,
      weatherZoneId?: string,
      telemetryType?: string,
      sn?: string,
      chart?: string,
    }, params: RequestParams = {}) => {
      const query: Record<string, string> = {
        farmId: inputData.farmId,
        startDate: inputData.startDate,
        endDate: inputData.endDate,
      };
      if (inputData.sectorId) query.sectorId = inputData.sectorId;
      if (inputData.wiseconnZoneId) query.wiseconnZoneId = inputData.wiseconnZoneId;
      if (inputData.weatherZoneId) query.weatherZoneId = inputData.weatherZoneId;
      if (inputData.telemetryType) query.telemetryType = inputData.telemetryType;
      if (inputData.sn) query.sn = inputData.sn;
      if (inputData.chart) query.chart = inputData.chart;
      return this.request<any, void>({
        path: `/readings/irrigationChart`,
        method: "GET",
        query,
        secure: true,
        format: "json",
        ...params,
      });
    },
  };
  users = {
    /**
     * @description Get users information
     *
     * @tags User
     * @name UsersList
     * @request GET:/users
     * @secure
     */
    usersList: (
      query?: {
        page?: number;
        limit?: number;
        searchValue?: string;
        sort?: string;
        filterAccount?: string;
        filterFarm?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUsersPerPageResponse, void>({
        path: `/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a user.
     *
     * @tags User
     * @name UsersCreate
     * @request POST:/users
     * @secure
     */
    usersCreate: (data: PostUserSchema, params: RequestParams = {}) =>
      this.request<PostUserResponse, void>({
        path: `/users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a user information
     *
     * @tags User
     * @name UsersUpdate
     * @request PUT:/users/{id}
     * @secure
     */
    usersUpdate: (id: string, data: UpdateUserSchema, params: RequestParams = {}) =>
      this.request<UpdateUserResponse, void>({
        path: `/users/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a user by its ID. Needs to be accessible to every user,
     *
     * @tags User
     * @name UsersDetail
     * @request GET:/users/{id}
     * @secure
     */
    usersDetail: (id: string, data?: any, params: RequestParams = {}) =>
      this.request<GetUserResponse, void>({
        path: `/users/${id}`,
        method: "GET",
        body: data,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a users array by IDs.
     *
     * @tags User
     * @name UsersDelete
     * @request DELETE:/users/{userIds}
     * @secure
     */
    usersDelete: (userIds: string[], params: RequestParams = {}) =>
      this.request<DeleteUserResponse, void>({
        path: `/users/${userIds}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Resend the invitation/verification email to a pending user.
     *
     * @tags User
     * @name ResendVerificationCreate
     * @request POST:/users/{id}/resend-verification
     * @secure
     */
    resendVerificationCreate: (id: string, params: RequestParams = {}) =>
      this.request<ResendVerificationResponse, void>({
        path: `/users/${id}/resend-verification`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get users by account ID
     *
     * @tags User
     * @name AccountDetail
     * @request GET:/users/account/{accountId}
     * @secure
     */
    accountDetail: (accountId: string, params: RequestParams = {}) =>
      this.request<GetUsersByAccountResponse, void>({
        path: `/users/account/${accountId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get users for alerts (admin only)
     *
     * @tags User
     * @name UsersForAlerts
     * @request GET:/users/alerts
     * @secure
     */
    usersForAlerts: (
      query?: {
        filterAccount?: string;
        filterFarm?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUsersForAlertsResponse, void>({
        path: `/users-alerts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  user = {
    /**
     * @description get a current user information
     *
     * @tags User
     * @name UserList
     * @request GET:/user
     * @secure
     */
    userList: (data?: any, params: RequestParams = {}) =>
      this.request<GetUserResponse, void>({
        path: `/user`,
        method: "GET",
        body: data,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  varieties = {
    /**
     * @description Get varieties information
     *
     * @tags Variety
     * @name VarietiesList
     * @request GET:/varieties
     * @secure
     */
    varietiesList: (
      query?: {
        page?: number;
        limit?: number;
        searchValue?: string;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVarietiesPerPageResponse, void>({
        path: `/varieties`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a variety.
     *
     * @tags Variety
     * @name VarietiesCreate
     * @request POST:/varieties
     * @secure
     */
    varietiesCreate: (data: PostVarietySchema, params: RequestParams = {}) =>
      this.request<PostVarietyResponse, void>({
        path: `/varieties`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get specific variety information
     *
     * @tags Variety
     * @name VarietiesDetail
     * @request GET:/varieties/{id}
     * @secure
     */
    varietiesDetail: (id?: string, params: RequestParams = {}) =>
      this.request<GetVarietyByIdResponse, void>({
        path: `/varieties/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Modifies a variety.
     *
     * @tags Variety
     * @name VarietiesUpdate
     * @request PUT:/varieties/{id}
     * @secure
     */
    varietiesUpdate: (id: string, data: PutVarietySchema, params: RequestParams = {}) =>
      this.request<PutVarietyResponse, void>({
        path: `/varieties/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an variety by ID.
     *
     * @tags Variety
     * @name VarietiesDelete
     * @request DELETE:/varieties/{id}
     * @secure
     */
    varietiesDelete: (id: string, params: RequestParams = {}) =>
      this.request<DeleteVarietyResponse, void>({
        path: `/varieties/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  species = {
    /**
     * @description Get species. Sin page/limit devuelve todas; con paginación devuelve { species, totalSpecies }.
     *
     * @tags Species
     * @name SpeciesList
     * @request GET:/species
     * @secure
     */
    speciesList: (
      query?: {
        page?: number;
        limit?: number;
        searchValue?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSpeciesResponse, void>({
        path: `/species`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a species.
     *
     * @tags Species
     * @name SpeciesCreate
     * @request POST:/species
     * @secure
     */
    speciesCreate: (data: PostSpeciesSchema, params: RequestParams = {}) =>
      this.request<PostSpeciesResponse, void>({
        path: `/species`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Modifies a species. Renames propagate to associated varieties.
     *
     * @tags Species
     * @name SpeciesUpdate
     * @request PUT:/species/{id}
     * @secure
     */
    speciesUpdate: (id: string, data: PutSpeciesSchema, params: RequestParams = {}) =>
      this.request<PutSpeciesResponse, void>({
        path: `/species/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a species and cascade soft-deletes its associated varieties.
     *
     * @tags Species
     * @name SpeciesDelete
     * @request DELETE:/species/{id}
     * @secure
     */
    speciesDelete: (id: string, params: RequestParams = {}) =>
      this.request<DeleteSpeciesResponse, void>({
        path: `/species/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the count of non-deleted varieties associated to the species.
     *
     * @tags Species
     * @name SpeciesVarietiesCount
     * @request GET:/species/{id}/varieties-count
     * @secure
     */
    speciesVarietiesCount: (id: string, params: RequestParams = {}) =>
      this.request<GetSpeciesVarietiesCountResponse, void>({
        path: `/species/${id}/varieties-count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  webhook = {
    /**
     * @description Receive notifications from Nuvathings webhook. When a notification is received, the system will fetch the actual data from the Nuvathings API using the timestamp range provided in the notification.
     *
     * @tags Webhook
     * @name NuvathingsCreate
     * @request POST:/webhook/nuvathings
     * @secure
     */
    nuvathingsCreate: (data: WebhookNotificationSchema, params: RequestParams = {}) =>
      this.request<WebhookNuvathingsResponseSchema, void>({
        path: `/webhook/nuvathings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  nuvathingsData = {
    /**
     * @description Get Nuvathings data from MongoDB with filtering options
     *
     * @tags Nuvathings
     * @name NuvathingsDataList
     * @request GET:/nuvathings-data
     * @secure
     */
    nuvathingsDataList: (
      query?: {
        /** Filter by device serial number */
        serialNumber?: string;
        /**
         * Filter by start date (ISO format)
         * @format date-time
         */
        startDate?: string;
        /**
         * Filter by end date (ISO format)
         * @format date-time
         */
        endDate?: string;
        /**
         * Number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * Number of records to skip
         * @min 0
         * @default 0
         */
        skip?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, void>({
        path: `/nuvathings-data`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  wiseconn = {
    /**
     * @description Update measures for a specific sector
     *
     * @tags Wiseconn
     * @name CollectMeasuresCreate
     * @request POST:/wiseconn/collect-measures
     * @secure
     */
    collectMeasuresCreate: (
      data: {
        farmId: string;
        wiseconnZoneId: string;
        startDate: string;
        endDate: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UpdateSectorResponse, void>({
        path: `/wiseconn/collect-measures`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update measures for a specific farm
     *
     * @tags Wiseconn
     * @name CollectMeasuresByFarmCreate
     * @request POST:/wiseconn/collect-measures-by-farm
     * @secure
     */
    collectMeasuresByFarmCreate: (
      data: {
        farmId: string;
        startDate: string;
        endDate: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UpdateSectorResponse, void>({
        path: `/wiseconn/collect-measures-by-farm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  alert = {
    /**
     * @description Create a new alert
     *
     * @tags Alert
     * @name AlertCreate
     * @request POST:/alert
     * @secure
     */
    alertCreate: (data: any, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/alert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description Get alerts by sector ID
     *
     * @tags Alert
     * @name AlertList
     * @request GET:/alert
     * @secure
     */
    alertList: (sectorId: string, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/alert?sectorId=${sectorId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Get alerts by ID
     *
     * @tags Alert
     * @name AlertDetail
     * @request GET:/alert/{id}
     * @secure
     */
    alertDetail: (id: string, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/alert/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * @description Update an alert by ID
     *
     * @tags Alert
     * @name AlertUpdate
     * @request PATCH:/alert/{id}
     * @secure
     */
    alertUpdate: (id: string, data: any, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/alert/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description Delete an alert by ID
     *
     * @tags Alert
     * @name AlertDelete
     * @request DELETE:/alert/{id}
     * @secure
     */
    alertDelete: (id: string, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/alert/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };

}
